/* tslint:disable */
/* eslint-disable */
/**
 * opm-cockpit-backend
 * API specification for the opm-cockpit-backend Service
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActivateOrDisableEventDokumentTypMappingByExternalId200Response
 */
export interface ActivateOrDisableEventDokumentTypMappingByExternalId200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ActivateOrDisableEventDokumentTypMappingByExternalId200Response
     */
    'aktiviert': boolean | null;
}
/**
 * 
 * @export
 * @interface BulkDeleteVorgaenge200Response
 */
export interface BulkDeleteVorgaenge200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeleteVorgaenge200Response
     */
    'success': Array<string>;
    /**
     * 
     * @type {Array<BulkDeleteVorgaenge200ResponseFailedInner>}
     * @memberof BulkDeleteVorgaenge200Response
     */
    'failed': Array<BulkDeleteVorgaenge200ResponseFailedInner>;
}
/**
 * 
 * @export
 * @interface BulkDeleteVorgaenge200ResponseFailedInner
 */
export interface BulkDeleteVorgaenge200ResponseFailedInner {
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteVorgaenge200ResponseFailedInner
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteVorgaenge200ResponseFailedInner
     */
    'error': string | null;
}
/**
 * 
 * @export
 * @interface BulkDeleteVorgaengeRequest
 */
export interface BulkDeleteVorgaengeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeleteVorgaengeRequest
     */
    'ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkDeleteVorgaengeRequest
     */
    'user': string | null;
}
/**
 * 
 * @export
 * @interface BulkRetryVorgaengeRequest
 */
export interface BulkRetryVorgaengeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkRetryVorgaengeRequest
     */
    'ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkRetryVorgaengeRequest
     */
    'initiator': string | null;
}
/**
 * 
 * @export
 * @interface BulkZurueckstellenVorgaengeRequest
 */
export interface BulkZurueckstellenVorgaengeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkZurueckstellenVorgaengeRequest
     */
    'ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkZurueckstellenVorgaengeRequest
     */
    'initiator': string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkZurueckstellenVorgaengeRequest
     */
    'kommentar': string;
}
/**
 * 
 * @export
 * @interface CreateEventDokumentTypMappingRequest
 */
export interface CreateEventDokumentTypMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'dokumentTyp': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'eventName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'eventTyp': CreateEventDokumentTypMappingRequestEventTypEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'aktiviert'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'streamserveProjektExternalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'exstreamServiceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'versandartUebersteuerung'?: CreateEventDokumentTypMappingRequestVersandartUebersteuerungEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'emailVersandArt'?: CreateEventDokumentTypMappingRequestEmailVersandArtEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'emailKundenkommunikation'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'archivierungAktiv'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'anmerkungAktiv'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'anmerkungBetreff'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'anmerkungText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'prioVersand'?: boolean;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner>}
     * @memberof CreateEventDokumentTypMappingRequest
     */
    'beilagen'?: Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner>;
}

export const CreateEventDokumentTypMappingRequestEventTypEnum = {
    Order: 'order',
    Contract: 'contract',
    Invoice: 'invoice',
    Extern: 'extern'
} as const;

export type CreateEventDokumentTypMappingRequestEventTypEnum = typeof CreateEventDokumentTypMappingRequestEventTypEnum[keyof typeof CreateEventDokumentTypMappingRequestEventTypEnum];
export const CreateEventDokumentTypMappingRequestVersandartUebersteuerungEnum = {
    EMail: 'E_MAIL',
    Brief: 'BRIEF'
} as const;

export type CreateEventDokumentTypMappingRequestVersandartUebersteuerungEnum = typeof CreateEventDokumentTypMappingRequestVersandartUebersteuerungEnum[keyof typeof CreateEventDokumentTypMappingRequestVersandartUebersteuerungEnum];
export const CreateEventDokumentTypMappingRequestEmailVersandArtEnum = {
    OhneDokument: 'OHNE_DOKUMENT',
    Dokument: 'DOKUMENT',
    DokumentAnhang: 'DOKUMENT_ANHANG',
    DokumentBrief: 'DOKUMENT_BRIEF',
    DokumentAnhangBrief: 'DOKUMENT_ANHANG_BRIEF'
} as const;

export type CreateEventDokumentTypMappingRequestEmailVersandArtEnum = typeof CreateEventDokumentTypMappingRequestEmailVersandArtEnum[keyof typeof CreateEventDokumentTypMappingRequestEmailVersandArtEnum];

/**
 * 
 * @export
 * @interface CreateStreamServeProjektRequest
 */
export interface CreateStreamServeProjektRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStreamServeProjektRequest
     */
    'projektName': string;
    /**
     * 
     * @type {number}
     * @memberof CreateStreamServeProjektRequest
     */
    'projektVersion': number;
}
/**
 * 
 * @export
 * @interface DeleteEventDokumentTypMapping200Response
 */
export interface DeleteEventDokumentTypMapping200Response {
    /**
     * 
     * @type {Array<GetEventDokumentTypMappingByExternalId200Response>}
     * @memberof DeleteEventDokumentTypMapping200Response
     */
    'data': Array<GetEventDokumentTypMappingByExternalId200Response>;
}
/**
 * 
 * @export
 * @interface DeleteVorgang404Response
 */
export interface DeleteVorgang404Response {
    /**
     * 
     * @type {string}
     * @memberof DeleteVorgang404Response
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeleteVorgang404Response
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof DeleteVorgang404Response
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteVorgang404Response
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof DeleteVorgang404Response
     */
    'errorCode': DeleteVorgang404ResponseErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeleteVorgang404Response
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof DeleteVorgang404Response
     */
    'data': any | null;
}

export const DeleteVorgang404ResponseErrorCodeEnum = {
    OpmCockpitBackendClientErrorNotFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NOT_FOUND'
} as const;

export type DeleteVorgang404ResponseErrorCodeEnum = typeof DeleteVorgang404ResponseErrorCodeEnum[keyof typeof DeleteVorgang404ResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface ErstelleDokumentVorschau200Response
 */
export interface ErstelleDokumentVorschau200Response {
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschau200Response
     */
    'type': ErstelleDokumentVorschau200ResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschau200Response
     */
    'content': string;
}

export const ErstelleDokumentVorschau200ResponseTypeEnum = {
    Pdf: 'PDF',
    Html: 'HTML',
    Ics: 'ICS'
} as const;

export type ErstelleDokumentVorschau200ResponseTypeEnum = typeof ErstelleDokumentVorschau200ResponseTypeEnum[keyof typeof ErstelleDokumentVorschau200ResponseTypeEnum];

/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequest
 */
export interface ErstelleDokumentVorschauRequest {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldaten}
     * @memberof ErstelleDokumentVorschauRequest
     */
    'dokumentQuelldaten': ErstelleDokumentVorschauRequestDokumentQuelldaten;
    /**
     * 
     * @type {number}
     * @memberof ErstelleDokumentVorschauRequest
     */
    'versandArt': ErstelleDokumentVorschauRequestVersandArtEnum;
}

export const ErstelleDokumentVorschauRequestVersandArtEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type ErstelleDokumentVorschauRequestVersandArtEnum = typeof ErstelleDokumentVorschauRequestVersandArtEnum[keyof typeof ErstelleDokumentVorschauRequestVersandArtEnum];

/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldaten
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldaten {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'dokumentTyp': string | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAntwortfrist}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'antwortfrist'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAntwortfrist;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'accountDatenSPE'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProdukt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'produkt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProdukt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'postAnschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenKunde}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'kunde'?: ErstelleDokumentVorschauRequestDokumentQuelldatenKunde;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'lieferstelle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'bankdaten'?: ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'auftrag'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'vertrag'?: ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'aktion'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProdukt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'vertragsProdukt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProdukt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'metadata'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'preisanpassung'?: ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassung;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungen}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'aktiveBankverbindungen'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungen;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungen}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'zukuenftigeBankverbindungen'?: ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'vertragsZaehler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzug}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'umzug'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzug;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'kuendigung'?: ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'ablesung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesung;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'produktwechselWiderruf'?: ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstruktur}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'marktstruktur'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstruktur;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartner}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'marktpartner'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartner;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'mahnung'?: ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenSperrung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'sperrung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenSperrung;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'ratenplan'?: ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'abschlag'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'abschlagNeu'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplan}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'abschlagsplan'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplan;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferant}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'lieferant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferant;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumente}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'archivDokumente'?: ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumente;
    /**
     * 
     * @type {boolean}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'postversandDeaktiviert'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDuplikatversandGrund}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'duplikatversandGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDuplikatversandGrund;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'aenderungBankverbindung'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung;
    /**
     * 
     * @type {boolean}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'stornoMaLoIdentProzess'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'todesfall'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'vertragskontokorrent'?: ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'kontoZahlung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlung;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAddOns}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'addOns'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAddOns;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'ladeVorteil'?: ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldaten
     */
    'dynamischerTreuebonus'?: ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
     */
    'faelligkeitNaechste'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlag
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
     */
    'faelligkeitNaechste'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagAnyOf
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'faelligkeitNaechste'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeu
     */
    'prozessAbschlagsaenderung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'faelligkeitNaechste'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagNeuAnyOf
     */
    'prozessAbschlagsaenderung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplan
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplan {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplan
     */
    'naechsteRechnung'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaege}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplan
     */
    'abschlaege'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaege;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOf
     */
    'naechsteRechnung'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaege}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOf
     */
    'abschlaege'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaege;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaege
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaege {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaegeAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaegeAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaegeAnyOfInner
     */
    'bruttoBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAbschlagsplanAnyOfAbschlaegeAnyOfInner
     */
    'datumZahlungFaelligkeit'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE {
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE
     */
    'status': string;
    /**
     * 
     * @type {any}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE
     */
    'inviteLink': any;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE
     */
    'benutzer': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer;
    /**
     * 
     * @type {boolean}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPE
     */
    'verknuepftMitKundennummerSeit': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOf {
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'status': string;
    /**
     * 
     * @type {any}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'inviteLink': any;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'benutzer': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer;
    /**
     * 
     * @type {boolean}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'verknuepftMitKundennummerSeit': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf {
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'status': string;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzer}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'benutzer': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzer;
    /**
     * 
     * @type {any}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'inviteLink'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {any}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'verknuepftMitKundennummerSeit': any | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'status': string;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'benutzer': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer;
    /**
     * 
     * @type {any}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'inviteLink'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'verknuepfungMitKundennummer': boolean | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'verknuepftMitKundennummerSeit': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer {
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer
     */
    'email': string;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer
     */
    'letzterLogin': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1Benutzer
     */
    'sub': string;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzer
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzer {
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzer
     */
    'email': string;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzer
     */
    'letzterLogin': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzer
     */
    'sub': string;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLoginAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLoginAnyOf {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAddOns
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAddOns {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
     */
    'zugeordnetesCommodityProduktProductCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
     */
    'zugeordnetesCommodityProduktProductName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
     */
    'aktivAb'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
     */
    'aktivBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAddOnsAnyOfInner
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung
     */
    'aenderungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung
     */
    'aenderungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung
     */
    'geaendertDurch'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung
     */
    'relevantFuerKundenkommunikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung
     */
    'bankAlt'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindung
     */
    'bankNeu'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'aenderungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'aenderungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'geaendertDurch'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'relevantFuerKundenkommunikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'bankAlt'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'bankNeu'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'ersatzBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'sepaLastschriftAutorisiert'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'kontoInhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'sepaMandatId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'zahlungsDienstleister'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankAlt
     */
    'zahlungsRichtung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'ersatzBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'sepaLastschriftAutorisiert'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'kontoInhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'sepaMandatId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'zahlungsDienstleister'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAenderungBankverbindungAnyOfBankNeu
     */
    'zahlungsRichtung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungen
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungen {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehend}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungen
     */
    'ausgehend'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehend;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungen
     */
    'eingehend'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehend}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOf
     */
    'ausgehend'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehend;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOf
     */
    'eingehend'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehend
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehend {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'ersatzBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'sepaLastschriftAutorisiert'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'kontoInhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'sepaMandatId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'zahlungsDienstleister'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'zahlungsRichtung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'ersatzBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'sepaLastschriftAutorisiert'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'kontoInhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'sepaMandatId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'zahlungsDienstleister'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'zahlungsRichtung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAntwortfrist
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAntwortfrist {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAntwortfristAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAntwortfristAnyOf {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumente
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumente {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInner {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInnerReferenz}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInner
     */
    'referenz': ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInnerReferenz;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInner
     */
    'inhalt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInnerReferenz
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInnerReferenz {
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInnerReferenz
     */
    'archivId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInnerReferenz
     */
    'titel': string | null;
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenArchivDokumenteAnyOfInnerReferenz
     */
    'erstellDatum': string;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'kampagne'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'geburtsdatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'codenummerNetzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'datumWiderruf'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'produktBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'produktBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'sofortBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'sofortBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'datumEinzug'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'gewuenschterLieferbeginn'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'tarifScheibe'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftrag
     */
    'monateMindestlaufzeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'kampagne'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'geburtsdatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'codenummerNetzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'datumWiderruf'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'produktBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'produktBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'sofortBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'sofortBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'datumEinzug'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'gewuenschterLieferbeginn'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'tarifScheibe'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOf
     */
    'monateMindestlaufzeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe
     */
    'komplexePreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe
     */
    'simpelPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibe
     */
    'istKomplexPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf
     */
    'komplexePreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf
     */
    'simpelPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenAuftragAnyOfTarifScheibeAnyOf
     */
    'istKomplexPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten
     */
    'lastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten
     */
    'sepaMandat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten
     */
    'kontoinhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdaten
     */
    'gueltigAb'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenBankdatenAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenBankdatenAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdatenAnyOf
     */
    'lastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdatenAnyOf
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdatenAnyOf
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdatenAnyOf
     */
    'sepaMandat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdatenAnyOf
     */
    'kontoinhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenBankdatenAnyOf
     */
    'gueltigAb'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'aktivierungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'deaktivierungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'bonusStaffelung'?: ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'aktuellerBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'naechsterBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'produktNameAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'produktCodeAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'abrechnungVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'abrechnungBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'rechnungsbetragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'bonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'bonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonus
     */
    'bonusMwSt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'aktivierungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'deaktivierungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'bonusStaffelung'?: ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'aktuellerBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'naechsterBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'produktNameAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'produktCodeAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'abrechnungVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'abrechnungBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'rechnungsbetragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'bonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'bonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'bonusMwSt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner {
    /**
     * 
     * @type {number}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'vertragsJahr': number;
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'prozentSatz': string | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLoginAnyOf}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'verrechenbarAb': ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLoginAnyOf;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung
     */
    'kuendigungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung
     */
    'grundTechnischerSchluessel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigung
     */
    'ausloeserKuendigung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigungAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigungAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigungAnyOf
     */
    'kuendigungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigungAnyOf
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigungAnyOf
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigungAnyOf
     */
    'grundTechnischerSchluessel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKuendigungAnyOf
     */
    'ausloeserKuendigung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenKunde {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'kundennummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'bevorzugteVersandArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'kundengruppe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'kundenVersandArtPraeferenz'?: ErstelleDokumentVorschauRequestDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'unbekannt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'adresse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'geburtsdatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKunde
     */
    'bestandskunde'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}

export const ErstelleDokumentVorschauRequestDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum = {
    EMail: 'E-Mail',
    Brief: 'Brief',
    Unbekannt: 'Unbekannt'
} as const;

export type ErstelleDokumentVorschauRequestDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum = typeof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum[keyof typeof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum];

/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'kundennummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'bevorzugteVersandArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'kundengruppe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'kundenVersandArtPraeferenz'?: ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'unbekannt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'adresse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'geburtsdatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOf
     */
    'bestandskunde'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}

export const ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum = {
    EMail: 'E-Mail',
    Brief: 'Brief',
    Unbekannt: 'Unbekannt'
} as const;

export type ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum = typeof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum[keyof typeof ErstelleDokumentVorschauRequestDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum];

/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'aktivierungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'deaktivierungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'maximalBonusErreicht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'maximalerBonusProMonatInKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'maximalerBonusProMonatInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'bonusInCentProKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'bonusMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'bonusJahr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'energieMenge'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'bonusBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'gesamtBonusSeitAktivierungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'bonusSeitLetzterAbrechnungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'gesamtBonusSeitAktivierungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'bonusSeitLetzterAbrechnungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteil
     */
    'standGesamtBonus'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'aktivierungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'deaktivierungsDatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'maximalBonusErreicht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'maximalerBonusProMonatInKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'maximalerBonusProMonatInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusInCentProKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusJahr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'energieMenge'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'gesamtBonusSeitAktivierungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusSeitLetzterAbrechnungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'gesamtBonusSeitAktivierungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusSeitLetzterAbrechnungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenLadeVorteilAnyOf
     */
    'standGesamtBonus'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'benachrichtigungstyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'gesamtMahnfaehigerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'zahlungsfrist'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'mahngebuehr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'mahnstufeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnposten}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'mahnposten'?: ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnposten;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungen}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'zusatzforderungen'?: ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnung
     */
    'gesamtForderungsbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'benachrichtigungstyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'gesamtMahnfaehigerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'zahlungsfrist'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'mahngebuehr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'mahnstufeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnposten}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'mahnposten'?: ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnposten;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungen}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'zusatzforderungen'?: ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOf
     */
    'gesamtForderungsbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnposten
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnposten {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'faelligkeitsdatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'verrechneterAbschlagMonat'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'bruttobetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'beglichenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'steuersatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnstufenName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'zahlungsfrist'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnbar'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungen
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungen {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'faelligkeitsdatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'verrechneterAbschlagMonat'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'bruttobetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'beglichenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'steuersatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'mahnbar'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassung
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassung {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassung
     */
    'tarifAlt'?: ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassung
     */
    'tarifNeu'?: ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOf
     */
    'tarifAlt'?: ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOf
     */
    'tarifNeu'?: ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt
     */
    'komplexePreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt
     */
    'simpelPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAlt
     */
    'istKomplexPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf
     */
    'gueltigVon'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf
     */
    'gueltigBis'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf
     */
    'komplexePreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf
     */
    'simpelPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenPreisanpassungAnyOfTarifAltAnyOf
     */
    'istKomplexPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf
     */
    'datumWiderruf'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderruf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderrufAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderrufAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'datumWiderruf'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan
     */
    'gesamtbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan
     */
    'beendigungsgrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOfRatenInner>}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan
     */
    'raten': Array<ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOfRatenInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplan
     */
    'istLastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOf
     */
    'gesamtbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOf
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOf
     */
    'beendigungsgrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOfRatenInner>}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOf
     */
    'raten': Array<ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOfRatenInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOf
     */
    'istLastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOfRatenInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOfRatenInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOfRatenInner
     */
    'betrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenRatenplanAnyOfRatenInner
     */
    'faelligkeitsdatum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'vertragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'ablehnungsgrundBeschreibung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'ablehnungsgrundTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'datumLieferendeBestaetigt'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'datumVertragsbeginn'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'datumVertragsende'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'datumWiderruf'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'endeDatumGewuenscht'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'endeRechnungsZeitraum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'lieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'lieferbeginnGewuenscht'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'naechsterKuendigungstermin'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'rechnungsDatumGewuenscht'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'statusCodeBezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'vertragsbindungLieferantAlt'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertrag
     */
    'kundenSpezifikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'vertragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'ablehnungsgrundBeschreibung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'ablehnungsgrundTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'datumLieferendeBestaetigt'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'datumVertragsbeginn'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'datumVertragsende'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'datumWiderruf'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'endeDatumGewuenscht'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'endeRechnungsZeitraum'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'lieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'lieferbeginnGewuenscht'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'naechsterKuendigungstermin'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'rechnungsDatumGewuenscht'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'statusCodeBezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'vertragsbindungLieferantAlt'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragAnyOf
     */
    'kundenSpezifikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent
     */
    'varianteVertragskonto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPosten}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent
     */
    'posten'?: ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPosten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent
     */
    'allePosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent
     */
    'werteAb'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrent
     */
    'saldo'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'varianteVertragskonto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPosten}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'posten'?: ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPosten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'allePosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'werteAb'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'saldo'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPosten
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPosten {
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'zahlart'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'buchungsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'zugehoerigeBuchungsnummern'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'betrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'datumZahlungFaelligkeit'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAccountDatenSPEAnyOfAnyOfBenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungen
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungen {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungen
     */
    'ausgehend'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungen
     */
    'eingehend'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend;
}
/**
 * 
 * @export
 * @interface ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungenAnyOf
 */
export interface ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungenAnyOf {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungenAnyOf
     */
    'ausgehend'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend;
    /**
     * 
     * @type {ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend}
     * @memberof ErstelleDokumentVorschauRequestDokumentQuelldatenZukuenftigeBankverbindungenAnyOf
     */
    'eingehend'?: ErstelleDokumentVorschauRequestDokumentQuelldatenAktiveBankverbindungenAnyOfEingehend;
}
/**
 * 
 * @export
 * @interface ExportVorgaenge200Response
 */
export interface ExportVorgaenge200Response {
    /**
     * Presigned URL to download the CSV file
     * @type {string}
     * @memberof ExportVorgaenge200Response
     */
    'downloadUrl': string;
}
/**
 * 
 * @export
 * @interface GetDatentransformationDebugSettings200Response
 */
export interface GetDatentransformationDebugSettings200Response {
    [key: string]: any;

    /**
     * 
     * @type {boolean}
     * @memberof GetDatentransformationDebugSettings200Response
     */
    'aktuelleEmailadresseVerwenden': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDatentransformationDebugSettings200Response
     */
    'aktuelleVersandartVerwenden': boolean | null;
}
/**
 * 
 * @export
 * @interface GetDatentransformationDebugSettings403Response
 */
export interface GetDatentransformationDebugSettings403Response {
    /**
     * 
     * @type {string}
     * @memberof GetDatentransformationDebugSettings403Response
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDatentransformationDebugSettings403Response
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetDatentransformationDebugSettings403Response
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetDatentransformationDebugSettings403Response
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDatentransformationDebugSettings403Response
     */
    'errorCode': GetDatentransformationDebugSettings403ResponseErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDatentransformationDebugSettings403Response
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetDatentransformationDebugSettings403Response
     */
    'data': any | null;
}

export const GetDatentransformationDebugSettings403ResponseErrorCodeEnum = {
    OpmCockpitBackendClientErrorDebugNotAllowed: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DEBUG_NOT_ALLOWED'
} as const;

export type GetDatentransformationDebugSettings403ResponseErrorCodeEnum = typeof GetDatentransformationDebugSettings403ResponseErrorCodeEnum[keyof typeof GetDatentransformationDebugSettings403ResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetEventDokumentTypMappingByExternalId200Response
 */
export interface GetEventDokumentTypMappingByExternalId200Response {
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'dokumentTyp': string;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'eventName': string;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'eventTyp': GetEventDokumentTypMappingByExternalId200ResponseEventTypEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'externalId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'aktiviert'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'deletedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'streamserveProjektExternalId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'streamserveProjektName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'streamserveProjektVersion': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'exstreamServiceName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'versandartUebersteuerung': GetEventDokumentTypMappingByExternalId200ResponseVersandartUebersteuerungEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'emailVersandArt': GetEventDokumentTypMappingByExternalId200ResponseEmailVersandArtEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'emailKundenkommunikation': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'archivierungAktiv': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'anmerkungAktiv': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'anmerkungBetreff': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'anmerkungText': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'anmerkungTyp': GetEventDokumentTypMappingByExternalId200ResponseAnmerkungTypEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'prioVersand': boolean;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner>}
     * @memberof GetEventDokumentTypMappingByExternalId200Response
     */
    'beilagen': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner>;
}

export const GetEventDokumentTypMappingByExternalId200ResponseEventTypEnum = {
    Order: 'order',
    Contract: 'contract',
    Invoice: 'invoice',
    Extern: 'extern'
} as const;

export type GetEventDokumentTypMappingByExternalId200ResponseEventTypEnum = typeof GetEventDokumentTypMappingByExternalId200ResponseEventTypEnum[keyof typeof GetEventDokumentTypMappingByExternalId200ResponseEventTypEnum];
export const GetEventDokumentTypMappingByExternalId200ResponseVersandartUebersteuerungEnum = {
    EMail: 'E_MAIL',
    Brief: 'BRIEF'
} as const;

export type GetEventDokumentTypMappingByExternalId200ResponseVersandartUebersteuerungEnum = typeof GetEventDokumentTypMappingByExternalId200ResponseVersandartUebersteuerungEnum[keyof typeof GetEventDokumentTypMappingByExternalId200ResponseVersandartUebersteuerungEnum];
export const GetEventDokumentTypMappingByExternalId200ResponseEmailVersandArtEnum = {
    OhneDokument: 'OHNE_DOKUMENT',
    Dokument: 'DOKUMENT',
    DokumentAnhang: 'DOKUMENT_ANHANG',
    DokumentBrief: 'DOKUMENT_BRIEF',
    DokumentAnhangBrief: 'DOKUMENT_ANHANG_BRIEF'
} as const;

export type GetEventDokumentTypMappingByExternalId200ResponseEmailVersandArtEnum = typeof GetEventDokumentTypMappingByExternalId200ResponseEmailVersandArtEnum[keyof typeof GetEventDokumentTypMappingByExternalId200ResponseEmailVersandArtEnum];
export const GetEventDokumentTypMappingByExternalId200ResponseAnmerkungTypEnum = {
    Notiz: 'NOTIZ'
} as const;

export type GetEventDokumentTypMappingByExternalId200ResponseAnmerkungTypEnum = typeof GetEventDokumentTypMappingByExternalId200ResponseAnmerkungTypEnum[keyof typeof GetEventDokumentTypMappingByExternalId200ResponseAnmerkungTypEnum];

/**
 * 
 * @export
 * @interface GetEventDokumentTypMappingProtocolByExternalId200ResponseInner
 */
export interface GetEventDokumentTypMappingProtocolByExternalId200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingProtocolByExternalId200ResponseInner
     */
    'action': GetEventDokumentTypMappingProtocolByExternalId200ResponseInnerActionEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingProtocolByExternalId200ResponseInner
     */
    'performedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappingProtocolByExternalId200ResponseInner
     */
    'performedAt': string | null;
}

export const GetEventDokumentTypMappingProtocolByExternalId200ResponseInnerActionEnum = {
    Activated: 'ACTIVATED',
    Deactivated: 'DEACTIVATED',
    Created: 'CREATED',
    Updated: 'UPDATED',
    ArchivierungActivated: 'ARCHIVIERUNG_ACTIVATED',
    ArchivierungDeactivated: 'ARCHIVIERUNG_DEACTIVATED',
    AnmerkungActivated: 'ANMERKUNG_ACTIVATED',
    AnmerkungDeactivated: 'ANMERKUNG_DEACTIVATED',
    AnmerkungBetreffUpdated: 'ANMERKUNG_BETREFF_UPDATED',
    AnmerkungTextUpdated: 'ANMERKUNG_TEXT_UPDATED',
    AnmerkungDeleted: 'ANMERKUNG_DELETED',
    Deleted: 'DELETED',
    Restored: 'RESTORED'
} as const;

export type GetEventDokumentTypMappingProtocolByExternalId200ResponseInnerActionEnum = typeof GetEventDokumentTypMappingProtocolByExternalId200ResponseInnerActionEnum[keyof typeof GetEventDokumentTypMappingProtocolByExternalId200ResponseInnerActionEnum];

/**
 * 
 * @export
 * @interface GetEventDokumentTypMappings200Response
 */
export interface GetEventDokumentTypMappings200Response {
    /**
     * 
     * @type {Array<GetEventDokumentTypMappings200ResponseDataInner>}
     * @memberof GetEventDokumentTypMappings200Response
     */
    'data': Array<GetEventDokumentTypMappings200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetEventDokumentTypMappings200ResponseDataInner
 */
export interface GetEventDokumentTypMappings200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'dokumentTyp': string;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'eventName': string;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'eventTyp': GetEventDokumentTypMappings200ResponseDataInnerEventTypEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'externalId': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'aktiviert'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'deletedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'streamserveProjektExternalId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'streamserveProjektName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'streamserveProjektVersion': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'exstreamServiceName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'versandartUebersteuerung': GetEventDokumentTypMappings200ResponseDataInnerVersandartUebersteuerungEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'emailVersandArt': GetEventDokumentTypMappings200ResponseDataInnerEmailVersandArtEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'emailKundenkommunikation': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'archivierungAktiv': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'anmerkungAktiv': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'anmerkungBetreff': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'anmerkungText': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'anmerkungTyp': GetEventDokumentTypMappings200ResponseDataInnerAnmerkungTypEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'prioVersand': boolean | null;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner>}
     * @memberof GetEventDokumentTypMappings200ResponseDataInner
     */
    'beilagen': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner>;
}

export const GetEventDokumentTypMappings200ResponseDataInnerEventTypEnum = {
    Order: 'order',
    Contract: 'contract',
    Invoice: 'invoice',
    Extern: 'extern'
} as const;

export type GetEventDokumentTypMappings200ResponseDataInnerEventTypEnum = typeof GetEventDokumentTypMappings200ResponseDataInnerEventTypEnum[keyof typeof GetEventDokumentTypMappings200ResponseDataInnerEventTypEnum];
export const GetEventDokumentTypMappings200ResponseDataInnerVersandartUebersteuerungEnum = {
    EMail: 'E_MAIL',
    Brief: 'BRIEF'
} as const;

export type GetEventDokumentTypMappings200ResponseDataInnerVersandartUebersteuerungEnum = typeof GetEventDokumentTypMappings200ResponseDataInnerVersandartUebersteuerungEnum[keyof typeof GetEventDokumentTypMappings200ResponseDataInnerVersandartUebersteuerungEnum];
export const GetEventDokumentTypMappings200ResponseDataInnerEmailVersandArtEnum = {
    OhneDokument: 'OHNE_DOKUMENT',
    Dokument: 'DOKUMENT',
    DokumentAnhang: 'DOKUMENT_ANHANG',
    DokumentBrief: 'DOKUMENT_BRIEF',
    DokumentAnhangBrief: 'DOKUMENT_ANHANG_BRIEF'
} as const;

export type GetEventDokumentTypMappings200ResponseDataInnerEmailVersandArtEnum = typeof GetEventDokumentTypMappings200ResponseDataInnerEmailVersandArtEnum[keyof typeof GetEventDokumentTypMappings200ResponseDataInnerEmailVersandArtEnum];
export const GetEventDokumentTypMappings200ResponseDataInnerAnmerkungTypEnum = {
    Notiz: 'NOTIZ'
} as const;

export type GetEventDokumentTypMappings200ResponseDataInnerAnmerkungTypEnum = typeof GetEventDokumentTypMappings200ResponseDataInnerAnmerkungTypEnum[keyof typeof GetEventDokumentTypMappings200ResponseDataInnerAnmerkungTypEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing200Response
 */
export interface GetPingPongByPing200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing200Response
     */
    'pong': string | null;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing400Response
 */
export interface GetPingPongByPing400Response {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400Response
     */
    'instance'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400Response
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400Response
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400Response
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400Response
     */
    'errorCode': GetPingPongByPing400ResponseErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400Response
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400Response
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseErrorCodeEnum = {
    OpmCockpitBackendClientErrorStreamserveProjektInUse: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-STREAMSERVE_PROJEKT_IN_USE'
} as const;

export type GetPingPongByPing400ResponseErrorCodeEnum = typeof GetPingPongByPing400ResponseErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf
 */
export interface GetPingPongByPing400ResponseAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf
     */
    'errorCode': GetPingPongByPing400ResponseAnyOfErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf
     */
    'title': string | null;
    /**
     * 
     * @type {GetPingPongByPing400ResponseAnyOfData}
     * @memberof GetPingPongByPing400ResponseAnyOf
     */
    'data': GetPingPongByPing400ResponseAnyOfData;
}

export const GetPingPongByPing400ResponseAnyOfErrorCodeEnum = {
    OpmCockpitBackendClientErrorInvalidContentType: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-INVALID_CONTENT_TYPE'
} as const;

export type GetPingPongByPing400ResponseAnyOfErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOfErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOfErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf1
 */
export interface GetPingPongByPing400ResponseAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf1
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf1
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf1
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf1
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf1
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf1ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf1
     */
    'title': string | null;
    /**
     * 
     * @type {Array<GetPingPongByPing400ResponseAnyOf1DataInner>}
     * @memberof GetPingPongByPing400ResponseAnyOf1
     */
    'data': Array<GetPingPongByPing400ResponseAnyOf1DataInner>;
}

export const GetPingPongByPing400ResponseAnyOf1ErrorCodeEnum = {
    OpmCockpitBackendClientErrorValidationError: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VALIDATION_ERROR'
} as const;

export type GetPingPongByPing400ResponseAnyOf1ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf1ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf1ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf10
 */
export interface GetPingPongByPing400ResponseAnyOf10 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf10
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf10
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf10
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf10
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf10
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf10ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf10
     */
    'title': string | null;
    /**
     * 
     * @type {Array<GetPingPongByPing400ResponseAnyOf10DataInner>}
     * @memberof GetPingPongByPing400ResponseAnyOf10
     */
    'data': Array<GetPingPongByPing400ResponseAnyOf10DataInner>;
}

export const GetPingPongByPing400ResponseAnyOf10ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDokumentTypAlreadyExists: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DOKUMENT_TYP_ALREADY_EXISTS'
} as const;

export type GetPingPongByPing400ResponseAnyOf10ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf10ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf10ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf10DataInner
 */
export interface GetPingPongByPing400ResponseAnyOf10DataInner {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf10DataInner
     */
    'field': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf10DataInner
     */
    'value': string | null;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf11
 */
export interface GetPingPongByPing400ResponseAnyOf11 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf11
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf11
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf11
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf11
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf11
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf11ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf11
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf11
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf11ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDokumenttypMappingIsDeleted: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DOKUMENTTYP_MAPPING_IS_DELETED'
} as const;

export type GetPingPongByPing400ResponseAnyOf11ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf11ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf11ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf12
 */
export interface GetPingPongByPing400ResponseAnyOf12 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf12
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf12
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf12
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf12
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf12
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf12ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf12
     */
    'title': string | null;
    /**
     * 
     * @type {Array<GetPingPongByPing400ResponseAnyOf12DataInner>}
     * @memberof GetPingPongByPing400ResponseAnyOf12
     */
    'data': Array<GetPingPongByPing400ResponseAnyOf12DataInner>;
}

export const GetPingPongByPing400ResponseAnyOf12ErrorCodeEnum = {
    OpmCockpitBackendClientErrorStreamserveProjektNotFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-STREAMSERVE_PROJEKT_NOT_FOUND'
} as const;

export type GetPingPongByPing400ResponseAnyOf12ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf12ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf12ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf12DataInner
 */
export interface GetPingPongByPing400ResponseAnyOf12DataInner {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf12DataInner
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf12DataInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf13
 */
export interface GetPingPongByPing400ResponseAnyOf13 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf13
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf13
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf13
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf13
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf13
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf13ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf13
     */
    'title': string | null;
    /**
     * 
     * @type {Array<GetPingPongByPing400ResponseAnyOf12DataInner>}
     * @memberof GetPingPongByPing400ResponseAnyOf13
     */
    'data': Array<GetPingPongByPing400ResponseAnyOf12DataInner>;
}

export const GetPingPongByPing400ResponseAnyOf13ErrorCodeEnum = {
    OpmCockpitBackendClientErrorStreamserveProjektAlreadyExists: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-STREAMSERVE_PROJEKT_ALREADY_EXISTS'
} as const;

export type GetPingPongByPing400ResponseAnyOf13ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf13ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf13ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf14
 */
export interface GetPingPongByPing400ResponseAnyOf14 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf14
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf14
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf14
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf14
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf14
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf14ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf14
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf14
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf14ErrorCodeEnum = {
    OpmCockpitBackendClientErrorStreamserveProjektInUse: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-STREAMSERVE_PROJEKT_IN_USE'
} as const;

export type GetPingPongByPing400ResponseAnyOf14ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf14ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf14ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf1DataInner
 */
export interface GetPingPongByPing400ResponseAnyOf1DataInner {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf1DataInner
     */
    'field': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf1DataInner
     */
    'message': string | null;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf2
 */
export interface GetPingPongByPing400ResponseAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf2
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf2
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf2
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf2
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf2
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf2ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf2
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf2
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf2ErrorCodeEnum = {
    OpmCockpitBackendClientErrorNoStartStepFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NO_START_STEP_FOUND'
} as const;

export type GetPingPongByPing400ResponseAnyOf2ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf2ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf2ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf3
 */
export interface GetPingPongByPing400ResponseAnyOf3 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf3
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf3
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf3
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf3
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf3
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf3ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf3
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf3
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf3ErrorCodeEnum = {
    OpmCockpitBackendClientErrorNoLastProcessingFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NO_LAST_PROCESSING_FOUND'
} as const;

export type GetPingPongByPing400ResponseAnyOf3ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf3ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf3ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf4
 */
export interface GetPingPongByPing400ResponseAnyOf4 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf4
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf4
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf4
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf4
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf4
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf4ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf4
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf4
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf4ErrorCodeEnum = {
    OpmCockpitBackendClientErrorVorgangNotInErrorState: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VORGANG_NOT_IN_ERROR_STATE'
} as const;

export type GetPingPongByPing400ResponseAnyOf4ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf4ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf4ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf5
 */
export interface GetPingPongByPing400ResponseAnyOf5 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf5
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf5
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf5
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf5
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf5
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf5ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf5
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf5
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf5ErrorCodeEnum = {
    OpmCockpitBackendClientErrorNoCurrentStepFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NO_CURRENT_STEP_FOUND'
} as const;

export type GetPingPongByPing400ResponseAnyOf5ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf5ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf5ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf6
 */
export interface GetPingPongByPing400ResponseAnyOf6 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf6
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf6
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf6
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf6
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf6
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf6ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf6
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf6
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf6ErrorCodeEnum = {
    OpmCockpitBackendClientErrorNoInitialPayloadFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NO_INITIAL_PAYLOAD_FOUND'
} as const;

export type GetPingPongByPing400ResponseAnyOf6ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf6ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf6ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf7
 */
export interface GetPingPongByPing400ResponseAnyOf7 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf7
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf7
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf7
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf7
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf7
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf7ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf7
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf7
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf7ErrorCodeEnum = {
    OpmCockpitBackendClientErrorVorgangDeleteWaitingPeriodNotReached: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VORGANG_DELETE_WAITING_PERIOD_NOT_REACHED'
} as const;

export type GetPingPongByPing400ResponseAnyOf7ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf7ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf7ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf8
 */
export interface GetPingPongByPing400ResponseAnyOf8 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf8
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf8
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf8
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf8
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf8
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf8ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf8
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf8
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf8ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDokumentTypMappingNotFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DOKUMENT_TYP_MAPPING_NOT_FOUND'
} as const;

export type GetPingPongByPing400ResponseAnyOf8ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf8ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf8ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOf9
 */
export interface GetPingPongByPing400ResponseAnyOf9 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf9
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf9
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing400ResponseAnyOf9
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf9
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf9
     */
    'errorCode': GetPingPongByPing400ResponseAnyOf9ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOf9
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing400ResponseAnyOf9
     */
    'data': any | null;
}

export const GetPingPongByPing400ResponseAnyOf9ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDokumentTypMappingNotCreated: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DOKUMENT_TYP_MAPPING_NOT_CREATED'
} as const;

export type GetPingPongByPing400ResponseAnyOf9ErrorCodeEnum = typeof GetPingPongByPing400ResponseAnyOf9ErrorCodeEnum[keyof typeof GetPingPongByPing400ResponseAnyOf9ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing400ResponseAnyOfData
 */
export interface GetPingPongByPing400ResponseAnyOfData {
    /**
     * 
     * @type {Array<string | null>}
     * @memberof GetPingPongByPing400ResponseAnyOfData
     */
    'expectedContentTypes': Array<string | null>;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing400ResponseAnyOfData
     */
    'receivedContentType': string | null;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing500Response
 */
export interface GetPingPongByPing500Response {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500Response
     */
    'instance'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500Response
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing500Response
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500Response
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500Response
     */
    'errorCode': GetPingPongByPing500ResponseErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500Response
     */
    'title': string;
    /**
     * 
     * @type {GetPingPongByPing500ResponseAnyOf4Data}
     * @memberof GetPingPongByPing500Response
     */
    'data': GetPingPongByPing500ResponseAnyOf4Data;
}

export const GetPingPongByPing500ResponseErrorCodeEnum = {
    OpmCockpitBackendClientErrorDurableFunctionError: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DURABLE_FUNCTION_ERROR'
} as const;

export type GetPingPongByPing500ResponseErrorCodeEnum = typeof GetPingPongByPing500ResponseErrorCodeEnum[keyof typeof GetPingPongByPing500ResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf
 */
export interface GetPingPongByPing500ResponseAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing500ResponseAnyOf
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf
     */
    'errorCode': GetPingPongByPing500ResponseAnyOfErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf
     */
    'title': string | null;
    /**
     * 
     * @type {GetPingPongByPing500ResponseAnyOfData}
     * @memberof GetPingPongByPing500ResponseAnyOf
     */
    'data': GetPingPongByPing500ResponseAnyOfData;
}

export const GetPingPongByPing500ResponseAnyOfErrorCodeEnum = {
    OpmCockpitBackendExternalErrorDokumentVorschauNoResult: 'OPM_COCKPIT_BACKEND-EXTERNAL_ERROR-DOKUMENT_VORSCHAU_NO_RESULT'
} as const;

export type GetPingPongByPing500ResponseAnyOfErrorCodeEnum = typeof GetPingPongByPing500ResponseAnyOfErrorCodeEnum[keyof typeof GetPingPongByPing500ResponseAnyOfErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf1
 */
export interface GetPingPongByPing500ResponseAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf1
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf1
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing500ResponseAnyOf1
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf1
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf1
     */
    'errorCode': GetPingPongByPing500ResponseAnyOf1ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf1
     */
    'title': string | null;
    /**
     * 
     * @type {GetPingPongByPing500ResponseAnyOf1Data}
     * @memberof GetPingPongByPing500ResponseAnyOf1
     */
    'data': GetPingPongByPing500ResponseAnyOf1Data;
}

export const GetPingPongByPing500ResponseAnyOf1ErrorCodeEnum = {
    OpmCockpitBackendInternalErrorPersistenceError: 'OPM_COCKPIT_BACKEND-INTERNAL_ERROR-PERSISTENCE_ERROR'
} as const;

export type GetPingPongByPing500ResponseAnyOf1ErrorCodeEnum = typeof GetPingPongByPing500ResponseAnyOf1ErrorCodeEnum[keyof typeof GetPingPongByPing500ResponseAnyOf1ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf1Data
 */
export interface GetPingPongByPing500ResponseAnyOf1Data {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf1Data
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf1DataAnyOf
 */
export interface GetPingPongByPing500ResponseAnyOf1DataAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf1DataAnyOf
     */
    'action': string | null;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf2
 */
export interface GetPingPongByPing500ResponseAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf2
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf2
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing500ResponseAnyOf2
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf2
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf2
     */
    'errorCode': GetPingPongByPing500ResponseAnyOf2ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf2
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetPingPongByPing500ResponseAnyOf2
     */
    'data': any | null;
}

export const GetPingPongByPing500ResponseAnyOf2ErrorCodeEnum = {
    OpmCockpitBackendInternalErrorUnknown: 'OPM_COCKPIT_BACKEND-INTERNAL_ERROR-UNKNOWN'
} as const;

export type GetPingPongByPing500ResponseAnyOf2ErrorCodeEnum = typeof GetPingPongByPing500ResponseAnyOf2ErrorCodeEnum[keyof typeof GetPingPongByPing500ResponseAnyOf2ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf3
 */
export interface GetPingPongByPing500ResponseAnyOf3 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf3
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf3
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing500ResponseAnyOf3
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf3
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf3
     */
    'errorCode': GetPingPongByPing500ResponseAnyOf3ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf3
     */
    'title': string | null;
    /**
     * 
     * @type {GetPingPongByPing500ResponseAnyOf3Data}
     * @memberof GetPingPongByPing500ResponseAnyOf3
     */
    'data': GetPingPongByPing500ResponseAnyOf3Data;
}

export const GetPingPongByPing500ResponseAnyOf3ErrorCodeEnum = {
    OpmCockpitBackendClientErrorSqsError: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-SQS_ERROR'
} as const;

export type GetPingPongByPing500ResponseAnyOf3ErrorCodeEnum = typeof GetPingPongByPing500ResponseAnyOf3ErrorCodeEnum[keyof typeof GetPingPongByPing500ResponseAnyOf3ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf3Data
 */
export interface GetPingPongByPing500ResponseAnyOf3Data {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf3Data
     */
    'vorgangId': string | null;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf4
 */
export interface GetPingPongByPing500ResponseAnyOf4 {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf4
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf4
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetPingPongByPing500ResponseAnyOf4
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf4
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf4
     */
    'errorCode': GetPingPongByPing500ResponseAnyOf4ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf4
     */
    'title': string | null;
    /**
     * 
     * @type {GetPingPongByPing500ResponseAnyOf4Data}
     * @memberof GetPingPongByPing500ResponseAnyOf4
     */
    'data': GetPingPongByPing500ResponseAnyOf4Data;
}

export const GetPingPongByPing500ResponseAnyOf4ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDurableFunctionError: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DURABLE_FUNCTION_ERROR'
} as const;

export type GetPingPongByPing500ResponseAnyOf4ErrorCodeEnum = typeof GetPingPongByPing500ResponseAnyOf4ErrorCodeEnum[keyof typeof GetPingPongByPing500ResponseAnyOf4ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOf4Data
 */
export interface GetPingPongByPing500ResponseAnyOf4Data {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf4Data
     */
    'activationRequestId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOf4Data
     */
    'externalId': string | null;
}
/**
 * 
 * @export
 * @interface GetPingPongByPing500ResponseAnyOfData
 */
export interface GetPingPongByPing500ResponseAnyOfData {
    /**
     * 
     * @type {string}
     * @memberof GetPingPongByPing500ResponseAnyOfData
     */
    'responseId'?: string | null;
}
/**
 * 
 * @export
 * @interface GetStreamServeProjektByExternalId200Response
 */
export interface GetStreamServeProjektByExternalId200Response {
    /**
     * 
     * @type {string}
     * @memberof GetStreamServeProjektByExternalId200Response
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof GetStreamServeProjektByExternalId200Response
     */
    'projektName': string;
    /**
     * 
     * @type {number}
     * @memberof GetStreamServeProjektByExternalId200Response
     */
    'projektVersion': number;
}
/**
 * 
 * @export
 * @interface GetStreamServeProjekte200Response
 */
export interface GetStreamServeProjekte200Response {
    /**
     * 
     * @type {Array<GetStreamServeProjekte200ResponseDataInner>}
     * @memberof GetStreamServeProjekte200Response
     */
    'data': Array<GetStreamServeProjekte200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetStreamServeProjekte200ResponseDataInner
 */
export interface GetStreamServeProjekte200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetStreamServeProjekte200ResponseDataInner
     */
    'externalId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetStreamServeProjekte200ResponseDataInner
     */
    'projektName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetStreamServeProjekte200ResponseDataInner
     */
    'projektVersion': number;
}
/**
 * 
 * @export
 * @interface GetVorgaenge200Response
 */
export interface GetVorgaenge200Response {
    /**
     * 
     * @type {Array<GetVorgaenge200ResponseDataInner>}
     * @memberof GetVorgaenge200Response
     */
    'data': Array<GetVorgaenge200ResponseDataInner>;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaenge200Response
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface GetVorgaenge200ResponseDataInner
 */
export interface GetVorgaenge200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'archivierungsstatus': GetVorgaenge200ResponseDataInnerArchivierungsstatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'externerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'vorgangType': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'correlationId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'externeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'auftragsnummer': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'vertragsnummer': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'kundennummer': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'dokumentQuelldaten': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'createdBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'lastModifiedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'lockedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'lockedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'deletedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'lastModifiedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'error': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'status': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'currentGestartedAm': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'fehlertyp': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'dokumentTyp': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'unterdrueckung': string | null;
    /**
     * 
     * @type {Array<GetVorgaenge200ResponseDataInnerProtokollInner>}
     * @memberof GetVorgaenge200ResponseDataInner
     */
    'protokoll': Array<GetVorgaenge200ResponseDataInnerProtokollInner>;
}

export const GetVorgaenge200ResponseDataInnerArchivierungsstatusEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN',
    Ausstehend: 'AUSSTEHEND',
    Fehler: 'FEHLER',
    Unbekannt: 'UNBEKANNT'
} as const;

export type GetVorgaenge200ResponseDataInnerArchivierungsstatusEnum = typeof GetVorgaenge200ResponseDataInnerArchivierungsstatusEnum[keyof typeof GetVorgaenge200ResponseDataInnerArchivierungsstatusEnum];

/**
 * 
 * @export
 * @interface GetVorgaenge200ResponseDataInnerProtokollInner
 */
export interface GetVorgaenge200ResponseDataInnerProtokollInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInnerProtokollInner
     */
    'action': GetVorgaenge200ResponseDataInnerProtokollInnerActionEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInnerProtokollInner
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgaenge200ResponseDataInnerProtokollInner
     */
    'date': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgaenge200ResponseDataInnerProtokollInner
     */
    'details': { [key: string]: any; };
}

export const GetVorgaenge200ResponseDataInnerProtokollInnerActionEnum = {
    Locked: 'LOCKED',
    Unlocked: 'UNLOCKED',
    Deleted: 'DELETED',
    Restored: 'RESTORED',
    SchrittZwischenspeichern: 'SCHRITT_ZWISCHENSPEICHERN',
    VorgangZurueckgestellt: 'VORGANG_ZURUECKGESTELLT',
    PersistenceReconciled: 'PERSISTENCE_RECONCILED',
    ArchivierungAbgeglichen: 'ARCHIVIERUNG_ABGEGLICHEN'
} as const;

export type GetVorgaenge200ResponseDataInnerProtokollInnerActionEnum = typeof GetVorgaenge200ResponseDataInnerProtokollInnerActionEnum[keyof typeof GetVorgaenge200ResponseDataInnerProtokollInnerActionEnum];

/**
 * 
 * @export
 * @interface GetVorgaengeAlerting200Response
 */
export interface GetVorgaengeAlerting200Response {
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeAlerting200Response
     */
    'count': number;
    /**
     * 
     * @type {GetVorgaengeAlerting200ResponseByStatus}
     * @memberof GetVorgaengeAlerting200Response
     */
    'byStatus': GetVorgaengeAlerting200ResponseByStatus;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeAlerting200Response
     */
    'thresholdHours': number;
}
/**
 * 
 * @export
 * @interface GetVorgaengeAlerting200ResponseByStatus
 */
export interface GetVorgaengeAlerting200ResponseByStatus {
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeAlerting200ResponseByStatus
     */
    'WARTEND': number;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeAlerting200ResponseByStatus
     */
    'LAUFEND': number;
}
/**
 * 
 * @export
 * @interface GetVorgaengeStatusClustering200Response
 */
export interface GetVorgaengeStatusClustering200Response {
    /**
     * 
     * @type {GetVorgaengeStatusClustering200ResponseStatusClustering}
     * @memberof GetVorgaengeStatusClustering200Response
     */
    'statusClustering': GetVorgaengeStatusClustering200ResponseStatusClustering;
}
/**
 * 
 * @export
 * @interface GetVorgaengeStatusClustering200ResponseStatusClustering
 */
export interface GetVorgaengeStatusClustering200ResponseStatusClustering {
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeStatusClustering200ResponseStatusClustering
     */
    'GEPLANT': number;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeStatusClustering200ResponseStatusClustering
     */
    'LAUFEND': number;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeStatusClustering200ResponseStatusClustering
     */
    'ERFOLGREICH': number;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeStatusClustering200ResponseStatusClustering
     */
    'FEHLER': number;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeStatusClustering200ResponseStatusClustering
     */
    'WARTEND': number;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeStatusClustering200ResponseStatusClustering
     */
    'GELOESCHT': number;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeStatusClustering200ResponseStatusClustering
     */
    'PAUSIERT': number;
    /**
     * 
     * @type {number}
     * @memberof GetVorgaengeStatusClustering200ResponseStatusClustering
     */
    'ZURUECKGESTELLT': number;
}
/**
 * 
 * @export
 * @interface GetVorgang200Response
 */
export interface GetVorgang200Response {
    /**
     * 
     * @type {GetVorgang200ResponseVorgang}
     * @memberof GetVorgang200Response
     */
    'vorgang': GetVorgang200ResponseVorgang;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangProtokollInner>}
     * @memberof GetVorgang200Response
     */
    'vorgangProtokoll': Array<GetVorgang200ResponseVorgangProtokollInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200Response
     */
    'isArchived': boolean | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgang
 */
export interface GetVorgang200ResponseVorgang {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'deletedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'lockedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'lockedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'kundennummer': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'vertragsnummer': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'auftragsnummer': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'erstelltDatum': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'letzteAbarbeitungId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgang
     */
    'dunkelverarbeitung': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'externeId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgang
     */
    'type': GetVorgang200ResponseVorgangTypeEnum;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInner>}
     * @memberof GetVorgang200ResponseVorgang
     */
    'abarbeitungen': Array<GetVorgang200ResponseVorgangAbarbeitungenInner>;
}

export const GetVorgang200ResponseVorgangTypeEnum = {
    DuplikatVersand: 'DUPLIKAT_VERSAND',
    PowercloudEvent: 'POWERCLOUD_EVENT',
    CustomContractEvent: 'CUSTOM_CONTRACT_EVENT',
    Generisch: 'GENERISCH'
} as const;

export type GetVorgang200ResponseVorgangTypeEnum = typeof GetVorgang200ResponseVorgangTypeEnum[keyof typeof GetVorgang200ResponseVorgangTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInner {
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInner
     */
    'schritte': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner>;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInner
     */
    'id': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInner
     */
    'laufnummer': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInner
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInner
     */
    'aktuellerSchritt': GetVorgang200ResponseVorgangAbarbeitungenInnerAktuellerSchrittEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInner
     */
    'gestartetAm': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInner
     */
    'abgeschlossenAm': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInner
     */
    'initiator': string | null;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerStatusEnum = {
    Geplant: 'GEPLANT',
    Laufend: 'LAUFEND',
    Erfolgreich: 'ERFOLGREICH',
    Fehler: 'FEHLER',
    Wartend: 'WARTEND',
    Pausiert: 'PAUSIERT',
    Zurueckgestellt: 'ZURUECKGESTELLT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerStatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerStatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerStatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerAktuellerSchrittEnum = {
    Transformation: 'TRANSFORMATION',
    FachlicheValidierung: 'FACHLICHE_VALIDIERUNG',
    WeiterleitungAnDokumentdienstleister: 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER',
    AntwortVonDokumentdienstleister: 'ANTWORT_VON_DOKUMENTDIENSTLEISTER',
    Archivierung: 'ARCHIVIERUNG',
    EmailVersand: 'EMAIL_VERSAND',
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER',
    WarteAufReaktivierungDesDokumenttyps: 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerAktuellerSchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerAktuellerSchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerAktuellerSchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'finishedAt': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'fehler': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'schritt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerSchrittEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6InitialPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'initialPayload': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6InitialPayload;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInner
     */
    'successPayload'?: any | null;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerStatusEnum = {
    Offen: 'OFFEN',
    InBearbeitung: 'IN_BEARBEITUNG',
    Erledigt: 'ERLEDIGT',
    Fehler: 'FEHLER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerStatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerStatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerStatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerSchrittEnum = {
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerSchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerSchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerSchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'finishedAt': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'fehler': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'schritt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSchrittEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'initialPayload': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf
     */
    'successPayload'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfStatusEnum = {
    Offen: 'OFFEN',
    InBearbeitung: 'IN_BEARBEITUNG',
    Erledigt: 'ERLEDIGT',
    Fehler: 'FEHLER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfStatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfStatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfStatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSchrittEnum = {
    Transformation: 'TRANSFORMATION'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'finishedAt': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'fehler': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'schritt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SchrittEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'initialPayload': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayload;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1
     */
    'successPayload'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayload;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1StatusEnum = {
    Offen: 'OFFEN',
    InBearbeitung: 'IN_BEARBEITUNG',
    Erledigt: 'ERLEDIGT',
    Fehler: 'FEHLER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1StatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1StatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1StatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SchrittEnum = {
    FachlicheValidierung: 'FACHLICHE_VALIDIERUNG'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayload {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayload
     */
    'dokumentQuelldaten': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'dokumentTyp': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'antwortfrist'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'accountDatenSPE'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProdukt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'produkt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProdukt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'postAnschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'kunde'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'lieferstelle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'bankdaten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'auftrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'vertrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'aktion'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProdukt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'vertragsProdukt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProdukt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'metadata'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenPreisanpassung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'preisanpassung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenPreisanpassung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'aktiveBankverbindungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'zukuenftigeBankverbindungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'vertragsZaehler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzug}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'umzug'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzug;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'kuendigung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'ablesung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'produktwechselWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstruktur}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'marktstruktur'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstruktur;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartner}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'marktpartner'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartner;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'mahnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenSperrung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'sperrung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenSperrung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'ratenplan'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'abschlag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'abschlagNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplan}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'abschlagsplan'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplan;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferant}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'lieferant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferant;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenArchivDokumente}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'archivDokumente'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenArchivDokumente;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'postversandDeaktiviert'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDuplikatversandGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'duplikatversandGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDuplikatversandGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'aenderungBankverbindung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'stornoMaLoIdentProzess'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'todesfall'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'vertragskontokorrent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'kontoZahlung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOns}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'addOns'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOns;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'ladeVorteil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten
     */
    'dynamischerTreuebonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesung
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesung
     */
    'messwertVorhanden'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesungAnyOf
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAblesungAnyOf
     */
    'messwertVorhanden'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
     */
    'faelligkeitNaechste'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlag
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
     */
    'faelligkeitNaechste'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagAnyOf
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplan
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplan {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplan
     */
    'naechsteRechnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOfAbschlaege}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplan
     */
    'abschlaege'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOfAbschlaege;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOf
     */
    'naechsteRechnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOfAbschlaege}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOf
     */
    'abschlaege'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOfAbschlaege;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOfAbschlaege
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAbschlagsplanAnyOfAbschlaege {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE
     */
    'status': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE
     */
    'inviteLink': any;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE
     */
    'benutzer': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPE
     */
    'verknuepftMitKundennummerSeit': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'status': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'inviteLink': any;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'benutzer': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOf
     */
    'verknuepftMitKundennummerSeit': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'inviteLink': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'benutzer'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {null}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf
     */
    'verknuepftMitKundennummerSeit': null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'status': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'benutzer': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'inviteLink'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {null}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf1
     */
    'verknuepftMitKundennummerSeit': null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf2
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf2
     */
    'status': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf2
     */
    'benutzer': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf2
     */
    'inviteLink'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf2
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAccountDatenSPEAnyOfAnyOf2
     */
    'verknuepftMitKundennummerSeit': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOns
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOns {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
     */
    'zugeordnetesCommodityProduktProductCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
     */
    'zugeordnetesCommodityProduktProductName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
     */
    'aktivAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
     */
    'aktivBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAddOnsAnyOfInner
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung
     */
    'aenderungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung
     */
    'aenderungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung
     */
    'geaendertDurch'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung
     */
    'relevantFuerKundenkommunikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung
     */
    'bankAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindung
     */
    'bankNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'aenderungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'aenderungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'geaendertDurch'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'relevantFuerKundenkommunikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'bankAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAenderungBankverbindungAnyOf
     */
    'bankNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion
     */
    'prozessHandler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion
     */
    'prozessTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion
     */
    'prozessStatus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktion
     */
    'prozessStatusNachricht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktionAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktionAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktionAnyOf
     */
    'prozessHandler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktionAnyOf
     */
    'prozessTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktionAnyOf
     */
    'prozessStatus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAktionAnyOf
     */
    'prozessStatusNachricht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenArchivDokumente
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenArchivDokumente {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenArchivDokumenteAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenArchivDokumenteAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenArchivDokumenteAnyOfInner
     */
    'referenz': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenArchivDokumenteAnyOfInner
     */
    'inhalt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'kampagne'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'geburtsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'codenummerNetzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'produktBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'produktBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'sofortBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'sofortBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'datumEinzug'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'gewuenschterLieferbeginn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'tarifScheibe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftrag
     */
    'monateMindestlaufzeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'kampagne'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'geburtsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'codenummerNetzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'produktBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'produktBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'sofortBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'sofortBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'datumEinzug'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'gewuenschterLieferbeginn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'tarifScheibe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenAuftragAnyOf
     */
    'monateMindestlaufzeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten
     */
    'lastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten
     */
    'sepaMandat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten
     */
    'kontoinhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdaten
     */
    'gueltigAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdatenAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdatenAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdatenAnyOf
     */
    'lastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdatenAnyOf
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdatenAnyOf
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdatenAnyOf
     */
    'sepaMandat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdatenAnyOf
     */
    'kontoinhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenBankdatenAnyOf
     */
    'gueltigAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDuplikatversandGrund
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDuplikatversandGrund {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'aktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'deaktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'bonusStaffelung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'aktuellerBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'naechsterBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'produktNameAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'produktCodeAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'abrechnungVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'abrechnungBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'rechnungsbetragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'bonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'bonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonus
     */
    'bonusMwSt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'aktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'deaktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'bonusStaffelung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'aktuellerBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'naechsterBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'produktNameAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'produktCodeAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'abrechnungVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'abrechnungBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'rechnungsbetragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'bonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'bonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOf
     */
    'bonusMwSt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelung {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner {
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'vertragsJahr': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'prozentSatz': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'verrechenbarAb': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenDynamischerTreuebonusAnyOfDeaktivierungsGrund {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOfForderung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlung
     */
    'forderung': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOfForderung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlung
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOfForderung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOf
     */
    'forderung': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOfForderung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOf
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOfForderung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOfForderung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKontoZahlungAnyOfForderung
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung
     */
    'kuendigungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung
     */
    'grundTechnischerSchluessel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigung
     */
    'ausloeserKuendigung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigungAnyOf
     */
    'kuendigungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigungAnyOf
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigungAnyOf
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigungAnyOf
     */
    'grundTechnischerSchluessel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKuendigungAnyOf
     */
    'ausloeserKuendigung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'kundennummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'bevorzugteVersandArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'kundengruppe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'kundenVersandArtPraeferenz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'unbekannt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'adresse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'geburtsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKunde
     */
    'bestandskunde'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum = {
    EMail: 'E-Mail',
    Brief: 'Brief',
    Unbekannt: 'Unbekannt'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeKundenVersandArtPraeferenzEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'kundennummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'bevorzugteVersandArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'kundengruppe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'kundenVersandArtPraeferenz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'unbekannt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'adresse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'geburtsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOf
     */
    'bestandskunde'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum = {
    EMail: 'E-Mail',
    Brief: 'Brief',
    Unbekannt: 'Unbekannt'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfKundenVersandArtPraeferenzEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenKundeAnyOfBevorzugteVersandArt {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'aktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'deaktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'maximalBonusErreicht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'maximalerBonusProMonatInKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'maximalerBonusProMonatInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'bonusInCentProKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'bonusMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'bonusJahr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'energieMenge'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'bonusBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'gesamtBonusSeitAktivierungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'bonusSeitLetzterAbrechnungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'gesamtBonusSeitAktivierungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'bonusSeitLetzterAbrechnungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteil
     */
    'standGesamtBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'aktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'deaktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'maximalBonusErreicht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'maximalerBonusProMonatInKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'maximalerBonusProMonatInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusInCentProKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusJahr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'energieMenge'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'gesamtBonusSeitAktivierungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusSeitLetzterAbrechnungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'gesamtBonusSeitAktivierungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'bonusSeitLetzterAbrechnungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOf
     */
    'standGesamtBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLadeVorteilAnyOfDeaktivierungsGrund {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferant
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferant {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferant
     */
    'glaeubigerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferantAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferantAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferantAnyOf
     */
    'glaeubigerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle
     */
    'lagezusatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle
     */
    'lageergaenzung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle
     */
    'strasse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle
     */
    'hausnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle
     */
    'ort'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelle
     */
    'postleitzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelleAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelleAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelleAnyOf
     */
    'lagezusatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelleAnyOf
     */
    'lageergaenzung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelleAnyOf
     */
    'strasse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelleAnyOf
     */
    'hausnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelleAnyOf
     */
    'ort'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenLieferstelleAnyOf
     */
    'postleitzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'benachrichtigungstyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'gesamtMahnfaehigerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'zahlungsfrist'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'mahngebuehr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'mahnstufeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnposten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'mahnposten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnposten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'zusatzforderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnung
     */
    'gesamtForderungsbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'benachrichtigungstyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'gesamtMahnfaehigerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'zahlungsfrist'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'mahngebuehr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'mahnstufeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnposten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'mahnposten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnposten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'zusatzforderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOf
     */
    'gesamtForderungsbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnposten
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnposten {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'faelligkeitsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'verrechneterAbschlagMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'bruttobetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'beglichenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'steuersatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnstufenName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'zahlungsfrist'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnbar'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungen
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungen {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'faelligkeitsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'verrechneterAbschlagMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'bruttobetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'beglichenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'steuersatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'mahnbar'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartner
     */
    'bezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartner
     */
    'kundenId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartnerAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartnerAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartnerAnyOf
     */
    'bezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktpartnerAnyOf
     */
    'kundenId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstruktur
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstruktur {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstruktur
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiber}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstruktur
     */
    'netzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiber;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOf
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiber}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOf
     */
    'netzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiber;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiber
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiber {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiber
     */
    'organisationFirma'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiberAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiberAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMarktstrukturAnyOfNetzbetreiberAnyOf
     */
    'organisationFirma'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata
     */
    'eventId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata
     */
    'correlationId': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadata
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadataAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadataAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadataAnyOf
     */
    'eventId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadataAnyOf
     */
    'correlationId': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenMetadataAnyOf
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenPreisanpassung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenPreisanpassung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenPreisanpassung
     */
    'tarifAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenPreisanpassung
     */
    'tarifNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProdukt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProdukt {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProdukt
     */
    'marke'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProdukt
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktAnyOf
     */
    'marke'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderruf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderrufAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderrufAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenProduktwechselWiderrufAnyOf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan
     */
    'gesamtbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan
     */
    'beendigungsgrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan
     */
    'raten': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplan
     */
    'istLastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplanAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplanAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplanAnyOf
     */
    'gesamtbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplanAnyOf
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplanAnyOf
     */
    'beendigungsgrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplanAnyOf
     */
    'raten': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenRatenplanAnyOf
     */
    'istLastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenSperrung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenSperrung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenSperrung
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzug
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzug {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzug
     */
    'titel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzugAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzugAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenUmzugAnyOf
     */
    'titel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'vertragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'ablehnungsgrundBeschreibung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'ablehnungsgrundTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'datumLieferendeBestaetigt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'datumVertragsbeginn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'datumVertragsende'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'endeDatumGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'endeRechnungsZeitraum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'lieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'lieferbeginnGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'naechsterKuendigungstermin'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'rechnungsDatumGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'statusCodeBezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'vertragsbindungLieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertrag
     */
    'kundenSpezifikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'vertragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'ablehnungsgrundBeschreibung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'ablehnungsgrundTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'datumLieferendeBestaetigt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'datumVertragsbeginn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'datumVertragsende'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'endeDatumGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'endeRechnungsZeitraum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'lieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'lieferbeginnGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'naechsterKuendigungstermin'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'rechnungsDatumGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'statusCodeBezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'vertragsbindungLieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragAnyOf
     */
    'kundenSpezifikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProdukt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProdukt {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProdukt
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProdukt
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProduktAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProduktAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProduktAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsProduktAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler
     */
    'tarifAnzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehler
     */
    'zaehlerTyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehlerAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehlerAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehlerAnyOf
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehlerAnyOf
     */
    'tarifAnzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragsZaehlerAnyOf
     */
    'zaehlerTyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent
     */
    'varianteVertragskonto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPosten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent
     */
    'posten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPosten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent
     */
    'allePosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent
     */
    'werteAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrent
     */
    'saldo'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'varianteVertragskonto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPosten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'posten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPosten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'allePosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'werteAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOf
     */
    'saldo'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPosten
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPosten {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'zahlart'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'buchungsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'zugehoerigeBuchungsnummern'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'betrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'datumZahlungFaelligkeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldatenVertragskontokorrentAnyOfVarianteVertragskonto {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayload {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayload
     */
    'dokumentQuelldaten': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayload
     */
    'versandArt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadVersandArtEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadata}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayload
     */
    'dokumentDienstleisterMetadata': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadata;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayload
     */
    'aussteuerungsInformation': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadVersandArtEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadVersandArtEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadVersandArtEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadVersandArtEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation {
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation
     */
    'valide': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation
     */
    'verworfen': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation
     */
    'ausgesteuert': boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation
     */
    'validierungsNachrichten': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadAussteuerungsInformation
     */
    'unterdrueckungsNachrichten': Array<string>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadata
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadata {
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadataBeilagenInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadata
     */
    'beilagen': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadataBeilagenInner>;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadata
     */
    'template': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadata
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadata
     */
    'prioVersand': boolean | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadataBeilagenInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadataBeilagenInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadataBeilagenInner
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadataBeilagenInner
     */
    'label': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadataBeilagenInner
     */
    'druck': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1SuccessPayloadDokumentDienstleisterMetadataBeilagenInner
     */
    'email': boolean | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'finishedAt': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'fehler': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'schritt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SchrittEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'initialPayload'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2
     */
    'successPayload'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayload;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2StatusEnum = {
    Offen: 'OFFEN',
    InBearbeitung: 'IN_BEARBEITUNG',
    Erledigt: 'ERLEDIGT',
    Fehler: 'FEHLER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2StatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2StatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2StatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SchrittEnum = {
    AntwortVonDokumentdienstleister: 'ANTWORT_VON_DOKUMENTDIENSTLEISTER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload
     */
    'archivierungAktiv'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload
     */
    'archivierungsFortschritt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayload
     */
    'retryInformation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadTypeEnum = {
    Dokument: 'DOKUMENT',
    EMail: 'E-MAIL'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf
     */
    'fileName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf
     */
    'archivierungAktiv'?: boolean | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschritt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf
     */
    'archivierungsFortschritt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschritt;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfTypeEnum = {
    Dokument: 'DOKUMENT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1
     */
    'fileName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1
     */
    'archivierungAktiv'?: boolean | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1
     */
    'archivierungsFortschritt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1
     */
    'retryInformation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1TypeEnum = {
    EMail: 'E-MAIL'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1TypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1TypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1TypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt {
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt
     */
    'version': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittVersionEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittAusfuehrung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt
     */
    'ausfuehrung': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittAusfuehrung;
    /**
     * 
     * @type {{ [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt
     */
    'dokumente': { [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue; };
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittVersionEnum = {
    NUMBER_1: 1
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittVersionEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittVersionEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittVersionEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittAusfuehrung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittAusfuehrung {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittAusfuehrung
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittAusfuehrung
     */
    'schrittId': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittAusfuehrung
     */
    'gueltigBis'?: number;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue
     */
    'fingerprint': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue
     */
    'phase': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValuePhaseEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue
     */
    'archivId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue
     */
    'kundenkommunikationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValue
     */
    'automatischAbgleichen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValuePhaseEnum = {
    Offen: 'OFFEN',
    UploadGestartet: 'UPLOAD_GESTARTET',
    Hochgeladen: 'HOCHGELADEN',
    KommunikationGestartet: 'KOMMUNIKATION_GESTARTET',
    KommunikationAngelegt: 'KOMMUNIKATION_ANGELEGT',
    Abgeschlossen: 'ABGESCHLOSSEN'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValuePhaseEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValuePhaseEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValuePhaseEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum = {
    True: true
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation {
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation
     */
    'emailErfolgreichArchiviert': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation
     */
    'retryCount': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1RetryInformation
     */
    'erfolgreichArchivierteKundenDokumenteZumArchivieren': Array<string>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschritt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschritt {
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschritt
     */
    'version': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittVersionEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittAusfuehrung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschritt
     */
    'ausfuehrung': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittAusfuehrung;
    /**
     * 
     * @type {{ [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschritt
     */
    'dokumente': { [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue; };
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittVersionEnum = {
    NUMBER_1: 1
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittVersionEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittVersionEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittVersionEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittAusfuehrung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittAusfuehrung {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittAusfuehrung
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittAusfuehrung
     */
    'schrittId': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittAusfuehrung
     */
    'gueltigBis'?: number;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue
     */
    'fingerprint': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue
     */
    'phase': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValuePhaseEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue
     */
    'archivId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue
     */
    'kundenkommunikationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValue
     */
    'automatischAbgleichen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValuePhaseEnum = {
    Offen: 'OFFEN',
    UploadGestartet: 'UPLOAD_GESTARTET',
    Hochgeladen: 'HOCHGELADEN',
    KommunikationGestartet: 'KOMMUNIKATION_GESTARTET',
    KommunikationAngelegt: 'KOMMUNIKATION_ANGELEGT',
    Abgeschlossen: 'ABGESCHLOSSEN'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValuePhaseEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValuePhaseEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValuePhaseEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum = {
    True: true
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOfArchivierungsFortschrittDokumenteValueAutomatischAbgleichenEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayload {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayload
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayload
     */
    'archivierungErgebnis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadArchivierungErgebnisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayload
     */
    'fileName': string;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadTypeEnum = {
    Dokument: 'DOKUMENT',
    EMail: 'E-MAIL'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadTypeEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadArchivierungErgebnisEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadArchivierungErgebnisEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadArchivierungErgebnisEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadArchivierungErgebnisEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf
     */
    'archivierungErgebnis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfArchivierungErgebnisEnum;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfTypeEnum = {
    Dokument: 'DOKUMENT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfTypeEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfArchivierungErgebnisEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfArchivierungErgebnisEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfArchivierungErgebnisEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOfArchivierungErgebnisEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1
     */
    'fileName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1
     */
    'archivierungErgebnis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1ArchivierungErgebnisEnum;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1TypeEnum = {
    EMail: 'E-MAIL'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1TypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1TypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1TypeEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1ArchivierungErgebnisEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1ArchivierungErgebnisEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1ArchivierungErgebnisEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2SuccessPayloadAnyOf1ArchivierungErgebnisEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'finishedAt': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'fehler': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'schritt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SchrittEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'initialPayload': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3
     */
    'successPayload'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayload;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3StatusEnum = {
    Offen: 'OFFEN',
    InBearbeitung: 'IN_BEARBEITUNG',
    Erledigt: 'ERLEDIGT',
    Fehler: 'FEHLER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3StatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3StatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3StatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SchrittEnum = {
    Archivierung: 'ARCHIVIERUNG'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload
     */
    'archivierungAktiv'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload
     */
    'archivierungsFortschritt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayload
     */
    'retryInformation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadTypeEnum = {
    Dokument: 'DOKUMENT',
    EMail: 'E-MAIL'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOfTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf
     */
    'archivierungAktiv'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf
     */
    'archivierungsFortschritt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOfTypeEnum = {
    Dokument: 'DOKUMENT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOfTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOfTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOfTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1
     */
    'fileName': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1
     */
    'archivierungAktiv'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1
     */
    'archivierungsFortschritt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf2InitialPayloadAnyOf1ArchivierungsFortschritt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1
     */
    'retryInformation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1TypeEnum = {
    EMail: 'E-MAIL'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1TypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1TypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1TypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation {
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation
     */
    'emailErfolgreichArchiviert': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation
     */
    'retryCount': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3InitialPayloadAnyOf1RetryInformation
     */
    'erfolgreichArchivierteKundenDokumenteZumArchivieren': Array<string>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayload {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayload
     */
    'archivierungErgebnis': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayloadArchivierungErgebnisEnum;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayloadArchivierungErgebnisEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN',
    Wiederholung: 'WIEDERHOLUNG'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayloadArchivierungErgebnisEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayloadArchivierungErgebnisEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf3SuccessPayloadArchivierungErgebnisEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'finishedAt': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'fehler': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'schritt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SchrittEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'initialPayload': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayload;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SuccessPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4
     */
    'successPayload'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SuccessPayload;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4StatusEnum = {
    Offen: 'OFFEN',
    InBearbeitung: 'IN_BEARBEITUNG',
    Erledigt: 'ERLEDIGT',
    Fehler: 'FEHLER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4StatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4StatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4StatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SchrittEnum = {
    WeiterleitungAnDokumentdienstleister: 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayload {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayload
     */
    'dokumentQuelldaten': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf1InitialPayloadDokumentQuelldaten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadata}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayload
     */
    'dokumentDienstleisterMetadata': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadata;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayload
     */
    'versandArt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadVersandArtEnum;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadVersandArtEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadVersandArtEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadVersandArtEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadVersandArtEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadata
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadata {
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadata
     */
    'beilagen': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner>;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadata
     */
    'template': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadata
     */
    'serviceName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadata
     */
    'prioVersand': boolean;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner
     */
    'label': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner
     */
    'druck': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4InitialPayloadDokumentDienstleisterMetadataBeilagenInner
     */
    'email': boolean;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SuccessPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SuccessPayload {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf4SuccessPayload
     */
    'xml': string | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'finishedAt': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'fehler': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'schritt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5SchrittEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5InitialPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'initialPayload': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5InitialPayload;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5
     */
    'successPayload'?: any | null;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5StatusEnum = {
    Offen: 'OFFEN',
    InBearbeitung: 'IN_BEARBEITUNG',
    Erledigt: 'ERLEDIGT',
    Fehler: 'FEHLER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5StatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5StatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5StatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5SchrittEnum = {
    EmailVersand: 'EMAIL_VERSAND'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5SchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5SchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5SchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5InitialPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5InitialPayload {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf5InitialPayload
     */
    'fileName': string | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'status': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'createdAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'startedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'finishedAt': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'fehler': { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'schritt': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6SchrittEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6InitialPayload}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'initialPayload': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6InitialPayload;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6
     */
    'successPayload'?: any | null;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6StatusEnum = {
    Offen: 'OFFEN',
    InBearbeitung: 'IN_BEARBEITUNG',
    Erledigt: 'ERLEDIGT',
    Fehler: 'FEHLER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6StatusEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6StatusEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6StatusEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6SchrittEnum = {
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6SchrittEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6SchrittEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6SchrittEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6InitialPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6InitialPayload {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOf6InitialPayload
     */
    'fileName': string;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'vertragsnummer': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'auftragsnummer': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'kundennummer': string;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'archivDokumentReferenzen': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner>;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'versandart': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadVersandartEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'duplikatversandGrund': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadDuplikatversandGrundEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'powercloudEvent': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2Event}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayload
     */
    'event': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2Event;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadTypeEnum = {
    DuplikatVersand: 'DUPLIKAT_VERSAND',
    PowercloudEvent: 'POWERCLOUD_EVENT',
    CustomContractEvent: 'CUSTOM_CONTRACT_EVENT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadTypeEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadVersandartEnum = {
    Email: 'EMAIL',
    Brief: 'BRIEF'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadVersandartEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadVersandartEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadVersandartEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadDuplikatversandGrundEnum = {
    Rueckpost: 'RUECKPOST',
    Kundenwunsch: 'KUNDENWUNSCH',
    Bounce: 'BOUNCE',
    Unbekannt: 'UNBEKANNT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadDuplikatversandGrundEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadDuplikatversandGrundEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadDuplikatversandGrundEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf
     */
    'vertragsnummer': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf
     */
    'auftragsnummer': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf
     */
    'kundennummer': string | null;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf
     */
    'archivDokumentReferenzen': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner>;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf
     */
    'versandart': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfVersandartEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf
     */
    'duplikatversandGrund': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfDuplikatversandGrundEnum;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfTypeEnum = {
    DuplikatVersand: 'DUPLIKAT_VERSAND'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfTypeEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfVersandartEnum = {
    Email: 'EMAIL',
    Brief: 'BRIEF'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfVersandartEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfVersandartEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfVersandartEnum];
export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfDuplikatversandGrundEnum = {
    Rueckpost: 'RUECKPOST',
    Kundenwunsch: 'KUNDENWUNSCH',
    Bounce: 'BOUNCE',
    Unbekannt: 'UNBEKANNT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfDuplikatversandGrundEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfDuplikatversandGrundEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfDuplikatversandGrundEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1TypeEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1
     */
    'powercloudEvent': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1TypeEnum = {
    PowercloudEvent: 'POWERCLOUD_EVENT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1TypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1TypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1TypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'EventId': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'EventName': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventEventNameEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'Environment'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'TenantId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'CreatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'CreatedFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'Version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'EventInstance'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEvent
     */
    'Content': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventEventNameEnum = {
    InvoiceCreatedElectricity: 'invoice_created_electricity',
    InvoiceCreatedElectricitySimulation: 'invoice_created_electricity_simulation',
    InvoiceCreatedGas: 'invoice_created_gas',
    InvoiceCreatedGasSimulation: 'invoice_created_gas_simulation',
    InvoiceCancelled: 'invoice_cancelled',
    InvoiceCreatedNonCommodity: 'invoice_created_non_commodity',
    InvoiceCreatedNonCommoditySimulation: 'invoice_created_non_commodity_simulation'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventEventNameEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventEventNameEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventEventNameEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'EventId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'EventName': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEventNameEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'Environment'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'TenantId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'CreatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'CreatedFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'Version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'EventInstance'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf
     */
    'Content': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEventNameEnum = {
    OrderConfirmed: 'order_confirmed',
    OrderDenialBlacklist: 'order_denial_blacklist',
    OrderDenialCreditCheck: 'order_denial_credit_check',
    OrderDenialDuplicate: 'order_denial_duplicate',
    OrderRevoked: 'order_revoked',
    OrderStatusRevoked: 'order_status_revoked',
    OrderStatusCancelled: 'order_status_cancelled',
    OrderStatusCheck: 'order_status_check',
    OrderStatusDone: 'order_status_done',
    OrderStatusOpen: 'order_status_open',
    OrderStatusWaiting: 'order_status_waiting'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEventNameEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEventNameEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEventNameEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1 {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'EventId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'EventName': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1EventNameEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'Environment'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'TenantId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'CreatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'CreatedFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'Version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'EventInstance'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1
     */
    'Content': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1EventNameEnum = {
    DebitorAccountReceivableChanged: 'debitor_account_receivable_changed',
    DebitorAccountReceivableSettled: 'debitor_account_receivable_settled',
    DisconnectionAnnouncement: 'disconnection_announcement',
    ContractLegalCaseDebtCollectionAdd: 'contract_legal_case_debt_collection_add',
    DisconnectionDone: 'disconnection_done',
    ContractCancellationVar: 'contract_cancellation_var',
    ContractDenialDuration: 'contract_denial_duration',
    ContractDunning: 'contract_dunning',
    ContractDunlevel2Cancelled: 'contract_dunlevel2_cancelled',
    ContractRequestCustomerReading: 'contract_request_customer_reading',
    ContractRevokeConfirmation: 'contract_revoke_confirmation',
    ContractRevokeRejected: 'contract_revoke_rejected',
    ContractTariffChangeConfirmed: 'contract_tariff_change_confirmed',
    ContractTerminationConfirmed: 'contract_termination_confirmed',
    ContractWelcomeLetter: 'contract_welcome_letter',
    ContractWelcomeLetterDepositChanged: 'contract_welcome_letter_deposit_changed',
    ContractStatusActive: 'contract_status_active',
    ContractStatusCancellationPrevious: 'contract_status_cancellation_previous',
    ContractDunningCounterBlocking: 'contract_dunning_counter_blocking',
    UserInteractionRequired: 'user_interaction_required',
    ContractSmartMeteringSystemBasedOnValuesAccountingStarted: 'contract_smart_metering_system_based_on_values_accounting_started',
    ContractWelcomeLetterNonCommodity: 'contract_welcome_letter_non_commodity',
    ContractStatusCancelled: 'contract_status_cancelled',
    ContractStatusDeliveryNet: 'contract_status_delivery_net',
    ContractStatusExpired: 'contract_status_expired',
    ContractStatusOpen: 'contract_status_open',
    ContractStatusTerminated: 'contract_status_terminated',
    ContractStatusWaiting: 'contract_status_waiting',
    ContractReadingInvoiceCorrectionNeeded: 'contract_reading_invoice_correction_needed',
    ContractReadingSaved: 'contract_reading_saved',
    ContractInvoiceCreated: 'contract_invoice_created',
    CustomerDataChanged: 'customer_data_changed',
    ContractInformationRequired: 'contract_information_required',
    ContractReadingPlausible: 'contract_reading_plausible',
    ContractTariffChangedPriceAdjustment: 'contract_tariff_changed_price_adjustment',
    ContractReadingUnplausible: 'contract_reading_unplausible',
    ContractTariffChangeRevoked: 'contract_tariff_change_revoked',
    ContractDepositChanged: 'contract_deposit_changed',
    ContractChangeCustomerData: 'contract_change_customer_data',
    ContractTariffChangeRevokeRejected: 'contract_tariff_change_revoke_rejected',
    ContractCancellationConfirmed: 'contract_cancellation_confirmed',
    ContractProductsCreated: 'contract_products_created',
    ContractAddOnSelected: 'contract_add_on_selected',
    ContractAddOnCancelled: 'contract_add_on_cancelled',
    ContractDunningCancelled: 'contract_dunning_cancelled',
    ContractCreditRebooked: 'contract_credit_rebooked',
    ContractInstallmentPlanActivated: 'contract_installment_plan_activated',
    ContractInstallmentPlanDeleted: 'contract_installment_plan_deleted',
    ContractInstallmentPlanEnded: 'contract_installment_plan_ended',
    ContractProductChangeConfirmed: 'contract_product_change_confirmed',
    AccountCollectionCreated: 'account_collection_created',
    AccountCollectionClosed: 'account_collection_closed',
    ContractCustomerResearchSuccessful: 'contract_customer_research_successful',
    ContractInvoiceDesiredDateCreated: 'contract_invoice_desired_date_created',
    ContractFlexBonusAdded: 'contract_flex_bonus_added',
    ContractChangeCustomerBankData: 'contract_change_customer_bank_data',
    ContractExtendedDataSaved: 'contract_extended_data_saved',
    ContractInvoiceCreatedNonCommodity: 'contract_invoice_created_non_commodity',
    ContractProductCancelled: 'contract_product_cancelled'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1EventNameEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1EventNameEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1EventNameEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'customer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClient}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'client'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClient;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'product_version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAction}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'action'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAction;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'market_location'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocationNetworkCarrier}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'market_location_network_carrier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocationNetworkCarrier;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'order'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_counter'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_relocation_title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'installmentPlan'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_product'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_deposit_change_process'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_next_deposit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_total_unpaid'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_total_dunned_unpaid'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_cancellation_title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_cancellation_var_reason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_reading_request_reason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'cancellation_triggered_through'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDate}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_tariff_revoke_date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDate;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevoked}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_tariff_revoked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevoked;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_tariff_change_next_product'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'cancelDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'cancellationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'revoking_date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivables}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_dunning_additional_receivables'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivables;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivables}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_dunned_receivables'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivables;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_installment_plan_end_reason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_changed_installment_plan'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'disconnection_fee'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'notificationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_dunnable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevel}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'highest_dunning_level'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevel;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'additional_fee_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'settlement_deadline'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_reading_request_days'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_invoice_date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_days_before_estimation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_read_at_before_invoice_date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_deposit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_change_customer_data_date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_change_customer_data_reason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_change_customer_data_contract_banking_data_direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_change_customer_data_by'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_change_customer_data_relevant_for_communication'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_change_customer_data_old_bank_data'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_change_customer_data_new_bank_data'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'contract_denial_duration_date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountPayment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'account_payment'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountPayment;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountSettledReceivable}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'account_settled_receivable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountSettledReceivable;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOns}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1Content
     */
    'product_addOns'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOns;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountPayment
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountPayment {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountPayment
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountPaymentAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountPaymentAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountPaymentAnyOf
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountSettledReceivable
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountSettledReceivable {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountSettledReceivable
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountSettledReceivableAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountSettledReceivableAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAccountSettledReceivableAnyOf
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAction
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAction {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAction
     */
    'handler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAction
     */
    'handlerTitle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAction
     */
    'handlerState'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentAction
     */
    'handlerStateMessage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentActionAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentActionAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentActionAnyOf
     */
    'handler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentActionAnyOf
     */
    'handlerTitle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentActionAnyOf
     */
    'handlerState'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentActionAnyOf
     */
    'handlerStateMessage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClient
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClient {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClient
     */
    'creditorId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClientAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClientAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClientAnyOf
     */
    'creditorId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'externalContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'bundleContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'authorizedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'isFlatrate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_alternativeAddress'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'relocationPossible'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'relocationContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'relatedContractType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'relatedContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'relocationAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'countryId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'floor'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'fax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancelledBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancellationReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancellationTriggeredDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_careOfRecipient'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'billing_countryAlpha2'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'counterType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'counterTypeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'meterPointIdentifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'marketLocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'meterLocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'complexSystem'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'externalCustomerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'customerCommunicationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'statusCodeTitle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'revocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'dateOfRevocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'lastRevocationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'startDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'desiredStartDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'simulationTurnus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'nextInvoiceInformationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'endDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'desiredEndDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'orderId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'nextPossibleCancellationByLfa'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'customerSpecification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'signatureDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancelledAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'filingDateCancellation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancellationTechKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'netDeliveryStartConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'netDeliveryEndConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'usage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'usageNet'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'usagePrevious'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'brandId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'paymentProviderData'?: Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'replacedBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'bankAccountNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'bankCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'sepaMandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'futureBankingData': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'previousProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'customerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancellationPreviousProviderSent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancellationPreviousProviderConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'netDeliveryStartSent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'minimumRuntime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'minimumRuntimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'extensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'extensionTimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'cancellationPeriodUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'nextCancellationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'latestCancelationByCustomer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'externalOrderId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'desiredInvoiceDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'invoicePeriodStartDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'invoicePeriodEndDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'dunningLocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'dunningLockedUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'dunningLockReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'paymentLockedOut'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'paymentLockedOutUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'paymentLockedIn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'paymentLockedInUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'taxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'taxRateReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'taxRatePermission'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'energyTaxExemptionRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'energyTaxExemptionReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'energyTaxExemptionPermission'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'legalCase'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'desiredInvoiceReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'dunningProcedure'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'meterPricing'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'additionalValues': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'InOutActiveBankingData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContract
     */
    'InOutFutureBankingData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'externalContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'bundleContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'authorizedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'isFlatrate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_alternativeAddress'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'relocationPossible'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'relocationContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'relatedContractType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'relatedContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'relocationAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'countryId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'floor'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'fax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancelledBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancellationReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancellationTriggeredDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_salutation': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_careOfRecipient'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'billing_countryAlpha2'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'counterType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'counterTypeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'meterPointIdentifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'marketLocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'meterLocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'complexSystem'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'externalCustomerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'customerCommunicationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'salutation': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'statusCodeTitle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'revocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'dateOfRevocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'lastRevocationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'startDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'desiredStartDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'simulationTurnus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'nextInvoiceInformationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'endDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'desiredEndDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'orderId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'nextPossibleCancellationByLfa'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'customerSpecification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'signatureDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancelledAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'filingDateCancellation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancellationTechKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'netDeliveryStartConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'netDeliveryEndConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'usage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'usageNet'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'usagePrevious'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'brandId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'paymentProviderData'?: Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'replacedBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'bankAccountNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'bankCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'sepaMandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'futureBankingData': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'previousProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'customerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancellationPreviousProviderSent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancellationPreviousProviderConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'netDeliveryStartSent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'minimumRuntime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'minimumRuntimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'extensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'extensionTimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'cancellationPeriodUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'nextCancellationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'latestCancelationByCustomer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'externalOrderId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'desiredInvoiceDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'invoicePeriodStartDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'invoicePeriodEndDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'dunningLocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'dunningLockedUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'dunningLockReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'paymentLockedOut'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'paymentLockedOutUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'paymentLockedIn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'paymentLockedInUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'taxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'taxRateReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'taxRatePermission'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'energyTaxExemptionRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'energyTaxExemptionReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'energyTaxExemptionPermission'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'legalCase'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'desiredInvoiceReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'dunningProcedure'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'meterPricing'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'additionalValues': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'InOutActiveBankingData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOf
     */
    'InOutFutureBankingData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingData {
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingData
     */
    'in': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingData
     */
    'out': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOf
     */
    'in': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOf
     */
    'out': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'replacedBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfInInner
     */
    'sepaMandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'replacedBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner
     */
    'sepaMandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData {
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData
     */
    'in': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData
     */
    'out': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingDataAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingDataAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingDataAnyOf
     */
    'in': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingDataAnyOf
     */
    'out': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutActiveBankingDataAnyOfOutInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_active_from'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_active_until'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_sepa_mandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_replaced_bank_id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_account_holder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_directdebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_dunning_locked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_dunning_locked_until'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_manual_billing_blocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankData
     */
    'contract_change_customer_data_payment_provider_key'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_active_from'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_active_until'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_sepa_mandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_replaced_bank_id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_account_holder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_directdebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_dunning_locked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_dunning_locked_until'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_manual_billing_blocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataNewBankDataAnyOf
     */
    'contract_change_customer_data_payment_provider_key'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_active_from'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_active_until'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_sepa_mandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_replaced_bank_id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_account_holder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_directdebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_dunning_locked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_dunning_locked_until'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_manual_billing_blocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankData
     */
    'contract_change_customer_data_payment_provider_key'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_active_from'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_active_until'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_sepa_mandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_replaced_bank_id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_account_holder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_directdebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_dunning_locked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_dunning_locked_until'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_manual_billing_blocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangeCustomerDataOldBankDataAnyOf
     */
    'contract_change_customer_data_payment_provider_key'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'isActive'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'useDirectDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'templateId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'total_receivable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'total_overdue_receivable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'total_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'total_settled_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'total_unsettled_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'excluded_receivables': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'installments': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlan
     */
    'receivables': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'isActive'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'useDirectDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'templateId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'total_receivable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'total_overdue_receivable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'total_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'total_settled_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'total_unsettled_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'excluded_receivables': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'installments': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOf
     */
    'receivables': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInner
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'bookingNumber': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'payableAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'settledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'tax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'notice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'dunnable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'dunningLocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'dunningLockedUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'locks'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'deletedLocks'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'nextDunningAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'invoiceId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'unsettledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInner
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData
     */
    'settledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData
     */
    'payableAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfInstallmentsInnerData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInner
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData
     */
    'receivableId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData
     */
    'initialUnsettledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerData
     */
    'account_receivable': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'bookingNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'payableAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'settledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'tax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'notice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'dunnable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'dunningLocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'dunningLockedUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'locks'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'deletedLocks'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'nextDunningAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'invoiceId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractChangedInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'unsettledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'createdByAgent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'counterSize'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'typeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'energyDirection'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'dataAcquisition'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'tariffCount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'exchangeType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'exchangeValue'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegisters}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'registers'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegisters;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounter
     */
    'additionalValues': Array<any>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'createdByAgent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'counterSize'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'typeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'energyDirection'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'dataAcquisition'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'tariffCount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'exchangeType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'exchangeValue'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegisters}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'registers'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegisters;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOf
     */
    'additionalValues': Array<any>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegisters
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegisters {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
     */
    'obis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
     */
    'description'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
     */
    'digits'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
     */
    'precision'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
     */
    'llc'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractCounterAnyOfRegistersAnyOfInner
     */
    'billingrelevant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
     */
    'alternativeDayOfMonth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
     */
    'netAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
     */
    'taxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
     */
    'taxAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecution}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDeposit
     */
    'nextExecution'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecution;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
     */
    'alternativeDayOfMonth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
     */
    'netAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
     */
    'taxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
     */
    'taxAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecution}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOf
     */
    'nextExecution'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecution;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecution
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecution {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecution
     */
    'useAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecutionAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecutionAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDepositAnyOfNextExecutionAnyOf
     */
    'useAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivables
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivables {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'bookingNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'payableAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'settledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'tax': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'notice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'contractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'level'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'levelName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'settlementDeadline'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'unsettledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'chargedDepositForMonth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunnedReceivablesAnyOfInner
     */
    'dunnable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivables
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivables {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'bookingNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'payableAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'chargedDepositForMonth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'settledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInnerTax}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'tax': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInnerTax;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'dunnable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'unsettledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'netAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'taxAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInner
     */
    'notice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInnerTax
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractDunningAdditionalReceivablesAnyOfInnerTax {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
     */
    'alternativeDayOfMonth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
     */
    'netAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
     */
    'taxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
     */
    'taxAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecution}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDeposit
     */
    'nextExecution'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecution;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
     */
    'alternativeDayOfMonth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
     */
    'netAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
     */
    'taxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
     */
    'taxAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecution}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOf
     */
    'nextExecution'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecution;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecution
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecution {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecution
     */
    'useAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecutionAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecutionAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractNextDepositAnyOfNextExecutionAnyOf
     */
    'useAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'contractProductId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'productName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'productVersion'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'productType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'excludedTaxesAndLevies'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'flexibleAddons'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'addOnOf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'mandatoryAddOn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'contractProductStatus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'quantity'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'externalOrderNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'waitForConfirmationUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'confirmedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'overwriteUseUsageSplitForElectricity'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProduct
     */
    'additionalTerminationRightBeforeDelivery'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'contractProductId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'productName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'productVersion'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'productType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'excludedTaxesAndLevies'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'flexibleAddons'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'addOnOf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'mandatoryAddOn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'contractProductStatus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'quantity'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'externalOrderNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'waitForConfirmationUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'confirmedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'overwriteUseUsageSplitForElectricity'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractProductAnyOf
     */
    'additionalTerminationRightBeforeDelivery'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'contractProductId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'productName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'productVersion'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'productType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'excludedTaxesAndLevies'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'flexibleAddons'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'addOnOf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'mandatoryAddOn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'contractProductStatus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'quantity'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'externalOrderNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'waitForConfirmationUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'confirmedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'overwriteUseUsageSplitForElectricity'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProduct
     */
    'additionalTerminationRightBeforeDelivery'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'contractProductId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'productName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'productVersion'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'productType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'excludedTaxesAndLevies'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'flexibleAddons'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'addOnOf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'mandatoryAddOn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'contractProductStatus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'quantity'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'externalOrderNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'waitForConfirmationUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'confirmedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'overwriteUseUsageSplitForElectricity'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffChangeNextProductAnyOf
     */
    'additionalTerminationRightBeforeDelivery'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDate
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDate {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDate
     */
    'date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDate
     */
    'timezone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDate
     */
    'timezone_type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOf
     */
    'date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOf
     */
    'timezone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOf
     */
    'timezone_type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOfAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOfAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOfAnyOf
     */
    'date'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOfAnyOf
     */
    'timezone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokeDateAnyOfAnyOf
     */
    'timezone_type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevoked
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevoked {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevoked
     */
    'product'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevoked
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevoked
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokedAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokedAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokedAnyOf
     */
    'product'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokedAnyOf
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractTariffRevokedAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'authorizedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'countryName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'unknown'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'countryId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'availableSentNotification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'authUserName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'authEnabled'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'accountUsername'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'accountUseremail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'phoneMobileAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'phoneMobile'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'phoneHomeAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'phoneHome'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'phoneBusinessAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'phoneBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'emailPrivate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'emailBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'adsMail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'adsPhone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'adsPost'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'customerCommunicationType': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerCustomerCommunicationTypeEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedData;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'customerGroups': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer
     */
    'customer_insolvencies'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerCustomerCommunicationTypeEnum = {
    _0: '0',
    _1: '1',
    _2: '2'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerCustomerCommunicationTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerCustomerCommunicationTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerCustomerCommunicationTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'authorizedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'countryName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'unknown'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'countryId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'availableSentNotification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'authUserName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'authEnabled'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'accountUsername'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'accountUseremail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'phoneMobileAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'phoneMobile'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'phoneHomeAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'phoneHome'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'phoneBusinessAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'phoneBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'emailPrivate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'emailBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'adsMail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'adsPhone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'adsPost'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'customerCommunicationType': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerCommunicationTypeEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedData;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'customerGroups': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOf
     */
    'customer_insolvencies'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerCommunicationTypeEnum = {
    _0: '0',
    _1: '1',
    _2: '2'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerCommunicationTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerCommunicationTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerCommunicationTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner
     */
    'additionalData': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInnerData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInner
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInnerData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInnerData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInnerData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInnerData
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInnerData
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerDataExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfCustomerGroupsInnerData
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerDataExtendedData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedData {
    [key: string]: any;

    /**
     * 
     * @type {{ [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedData
     */
    'categories': { [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue; };
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedDataValues}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedData
     */
    'values': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedDataValues;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedDataValues
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedDataValues {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomerAnyOfExtendedDataValues
     */
    'VART_KD'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevel
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevel {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevel
     */
    'level'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevel
     */
    'levelName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevelAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevelAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevelAnyOf
     */
    'level'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentHighestDunningLevelAnyOf
     */
    'levelName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'isActive'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'useDirectDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'templateId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'total_receivable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'total_overdue_receivable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'total_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'total_settled_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'total_unsettled_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'excluded_receivables': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'installments': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlan
     */
    'receivables': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'isActive'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'useDirectDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'templateId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'total_receivable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'total_overdue_receivable_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'total_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'total_settled_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'total_unsettled_installment_amount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'excluded_receivables': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'installments': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner>;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOf
     */
    'receivables': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInner
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerDataBookingNumber}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'bookingNumber': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerDataBookingNumber;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'payableAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'settledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'tax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'notice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'dunnable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'dunningLocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'dunningLockedUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'locks'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'deletedLocks'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'nextDunningAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'invoiceId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerData
     */
    'unsettledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerDataBookingNumber
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfExcludedReceivablesInnerDataBookingNumber {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInner
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData
     */
    'settledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData
     */
    'payableAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfInstallmentsInnerData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInner
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData
     */
    'receivableId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData
     */
    'initialUnsettledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerData
     */
    'account_receivable': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivable
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'bookingNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'payableAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'grossAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'settledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'tax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'notice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'dunnable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'dunningLocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'dunningLockedUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'locks'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'deletedLocks'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'nextDunningAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'invoiceId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentInstallmentPlanAnyOfReceivablesInnerDataAccountReceivableData
     */
    'unsettledAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation
     */
    'note'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation
     */
    'identifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocation
     */
    'additionalValues'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocationNetworkCarrier
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocationNetworkCarrier {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocationNetworkCarrier
     */
    'organization'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocationNetworkCarrierAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocationNetworkCarrierAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentMarketLocationNetworkCarrierAnyOf
     */
    'organization'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'orderedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'revokedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'relevantStreet'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'pointOfDeliveryInBasicSupplyArea'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'relocationContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'relatedContractType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'relatedContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'phoneMobileAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'phoneMobile'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'phoneHomeAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'phoneHome'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'phoneBusinessAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'phoneBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'emailPrivate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'emailBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'researchedCustomer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_alternativeAddress'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_careOfRecipient'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_countryAlpha2'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_fax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'billing_email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'relocationAddressTransfer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'paymentProviderData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'campaign'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'campaignId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'exportAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'salesChannel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'inputChannel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'adsMail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'adsPhone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'adsPost'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'previousProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'previousProduct'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'previousProviderCodeNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'previousProviderCodeNumberProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'netCodeNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'netCodeNumberProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'customerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'customerSpecification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'relocationAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'desiredDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'terminatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'basicSupplyAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'provider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'providerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'product'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productEco'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'variant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'priceKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'marketLocationIdentifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'usageInclusive'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'usage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'complexPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'complexPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productWorkingPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productBasePrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'overConsumptionWorkingPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productWorkingPriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productBasePriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productInstantBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'energyTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productWorkingPriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productBasePriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productBonusTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productInstantBonusTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productBonusPercent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'productInstantBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'fixedPriceType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'fixedPriceMonths'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'fixedPriceDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'cancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'cancellationPeriodUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'minimumRuntime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'minimumRuntimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'extensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'extensionTimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'ediProcessId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'vpCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'uvpCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'createdBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'signatureDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'notifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'waitForConfirmationUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'confirmedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'additionalValues'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'flexbonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrder
     */
    'brand'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOf
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOf
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData
     */
    'isDeleted'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData
     */
    'createdBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrandAnyOfData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices
     */
    'data'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOf
     */
    'data'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOf
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfData {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPrice}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfData
     */
    'complexPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPrice;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfData
     */
    'meterPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPrice}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOf
     */
    'complexPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPrice;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOf
     */
    'meterPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPrice
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPrice {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'usageFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'usageUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'basePriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'basePriceBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'basePriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'basePriceTaxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPrices}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'workingPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPrices;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPrices
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPrices {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'registerName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'workingPriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'workingPriceBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'workingPriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'workingPriceTaxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOns
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOns {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
     */
    'productName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
     */
    'commodityProductCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
     */
    'commodityProductName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
     */
    'validFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductAddOnsAnyOfInner
     */
    'validUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'productId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'supplyType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'consumptionType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'priceType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'pricingType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'usageNtPercentage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'updatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'releaseRequestedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'releasedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'deprecatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'lockedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'validFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'validUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'kind'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'eco'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'invoiceBase'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractInvoiceCycle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractInvoiceCycleInterval'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractInvoiceCycleIntervalType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractInitialDuration'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractInitialDurationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractExtensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractExtensionTimeType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractCancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'contractCancellationPeriodType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpExternalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpWeight'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpStatisticGroup'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpVolume'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpVariantGroupCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpProductLink'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpManufacturer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpManufacturerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpAccount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'erpAllowSplitAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'cmsAgb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'cmsProperties'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'cmsDescriptionInternal'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'cmsDescriptionExternal'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'cmsFileId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'noteFreetext'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'everyTimeCancellable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'relocationProhibited'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'meterPricing'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'brand': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'additionalTerminationRightBeforeDelivery'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion
     */
    'billingRuleTemplateId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'productId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'supplyType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'consumptionType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'priceType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'pricingType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'usageNtPercentage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'updatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'releaseRequestedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'releasedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'deprecatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'lockedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'validFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'validUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'kind'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'eco'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'invoiceBase'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractInvoiceCycle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractInvoiceCycleInterval'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractInvoiceCycleIntervalType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractInitialDuration'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractInitialDurationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractExtensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractExtensionTimeType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractCancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'contractCancellationPeriodType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpExternalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpWeight'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpStatisticGroup'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpVolume'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpVariantGroupCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpProductLink'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpManufacturer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpManufacturerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpAccount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'erpAllowSplitAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'cmsAgb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'cmsProperties'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'cmsDescriptionInternal'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'cmsDescriptionExternal'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'cmsFileId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'noteFreetext'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'everyTimeCancellable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'relocationProhibited'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'meterPricing'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'brand': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'additionalTerminationRightBeforeDelivery'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOf
     */
    'billingRuleTemplateId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand
     */
    'data'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrand
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandDataName}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandDataName;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData
     */
    'isDeleted'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData
     */
    'createdBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandDataName
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersionAnyOfBrandDataName {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2 {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'EventId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'EventName': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2EventNameEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'Environment'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'TenantId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'CreatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'CreatedFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'Version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'EventInstance'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2
     */
    'Content': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2EventNameEnum = {
    InvoiceCreatedElectricity: 'invoice_created_electricity',
    InvoiceCreatedElectricitySimulation: 'invoice_created_electricity_simulation',
    InvoiceCreatedGas: 'invoice_created_gas',
    InvoiceCreatedGasSimulation: 'invoice_created_gas_simulation',
    InvoiceCancelled: 'invoice_cancelled',
    InvoiceCreatedNonCommodity: 'invoice_created_non_commodity',
    InvoiceCreatedNonCommoditySimulation: 'invoice_created_non_commodity_simulation'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2EventNameEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2EventNameEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2EventNameEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content
     */
    'customer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentCustomer;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClient}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content
     */
    'client'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentClient;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2Content
     */
    'contracts'?: Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner
     */
    'contract'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner
     */
    'contract_counter'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner
     */
    'market_location'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner
     */
    'product_version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentProductVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInner
     */
    'order'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'externalContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'bundleContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'authorizedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'isFlatrate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_alternativeAddress'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'relocationPossible'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'relocationContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'relatedContractType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'relatedContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'relocationAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'countryId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'floor'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'fax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancelledBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancellationReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancellationTriggeredDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_careOfRecipient'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'billing_countryAlpha2'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'counterType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'counterTypeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'meterPointIdentifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'marketLocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'meterLocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'complexSystem'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'externalCustomerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'customerCommunicationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'statusCodeTitle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'revocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'dateOfRevocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'lastRevocationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'startDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'desiredStartDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'simulationTurnus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'nextInvoiceInformationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'endDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'desiredEndDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'orderId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'nextPossibleCancellationByLfa'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'customerSpecification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'signatureDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancelledAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'filingDateCancellation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancellationTechKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'netDeliveryStartConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'netDeliveryEndConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'usage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'usageNet'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'usagePrevious'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'brandId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'paymentProviderData'?: Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'replacedBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'bankAccountNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'bankCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'sepaMandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'futureBankingData': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'previousProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'customerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancellationPreviousProviderSent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancellationPreviousProviderConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'netDeliveryStartSent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'minimumRuntime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'minimumRuntimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'extensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'extensionTimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'cancellationPeriodUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'nextCancellationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'latestCancelationByCustomer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'externalOrderId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'desiredInvoiceDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'invoicePeriodStartDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'invoicePeriodEndDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'dunningLocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'dunningLockedUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'dunningLockReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'paymentLockedOut'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'paymentLockedOutUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'paymentLockedIn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'paymentLockedInUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'taxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'taxRateReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'taxRatePermission'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'energyTaxExemptionRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'energyTaxExemptionReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'energyTaxExemptionPermission'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'legalCase'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'desiredInvoiceReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'dunningProcedure'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'meterPricing'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'additionalValues': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'InOutActiveBankingData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContract
     */
    'InOutFutureBankingData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'accountId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'externalContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'bundleContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'authorizedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'isFlatrate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_alternativeAddress'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'relocationPossible'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'relocationContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'relatedContractType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'relatedContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'relocationAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'countryId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'floor'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'fax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancelledBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancellationReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancellationTriggeredDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_careOfRecipient'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'billing_countryAlpha2'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'counterType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'counterTypeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'meterPointIdentifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'marketLocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'meterLocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'complexSystem'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'externalCustomerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'customerCommunicationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'statusCodeTitle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'revocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'dateOfRevocation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'lastRevocationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'startDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'desiredStartDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'simulationTurnus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'nextInvoiceInformationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'endDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'desiredEndDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'orderId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'nextPossibleCancellationByLfa'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'customerSpecification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'signatureDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancelledAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'filingDateCancellation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancellationTechKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'netDeliveryStartConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'netDeliveryEndConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'usage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'usageNet'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'usagePrevious'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'brandId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'direction'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'paymentProviderData'?: Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'replacedBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'bankAccountNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'bankCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'sepaMandate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'futureBankingData': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'previousProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'customerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancellationPreviousProviderSent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancellationPreviousProviderConfirmed'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'netDeliveryStartSent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'minimumRuntime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'minimumRuntimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'extensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'extensionTimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'cancellationPeriodUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'nextCancellationDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'latestCancelationByCustomer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'externalOrderId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'desiredInvoiceDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'invoicePeriodStartDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'invoicePeriodEndDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'dunningLocked'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'dunningLockedUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'dunningLockReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'paymentLockedOut'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'paymentLockedOutUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'paymentLockedIn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'paymentLockedInUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'taxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'taxRateReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'taxRatePermission'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'energyTaxExemptionRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'energyTaxExemptionReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'energyTaxExemptionPermission'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'legalCase'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'desiredInvoiceReason'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'dunningProcedure'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'meterPricing'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'additionalValues': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'InOutActiveBankingData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractAnyOf
     */
    'InOutFutureBankingData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentContractAnyOfInOutFutureBankingData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'createdByAgent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'counterSize'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'typeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'energyDirection'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'dataAcquisition'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'tariffCount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'exchangeType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'exchangeValue'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegisters}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'registers'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegisters;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounter
     */
    'additionalValues': Array<any>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'createdByAgent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'counterSize'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'typeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'energyDirection'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'dataAcquisition'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'tariffCount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'exchangeType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'exchangeValue'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegisters}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'registers'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegisters;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOf
     */
    'additionalValues': Array<any>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegisters
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegisters {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
     */
    'activeFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
     */
    'activeUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
     */
    'obis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
     */
    'description'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
     */
    'digits'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
     */
    'precision'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
     */
    'llc'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerContractCounterAnyOfRegistersAnyOfInner
     */
    'billingrelevant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation
     */
    'clientId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation
     */
    'note'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation
     */
    'identifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerMarketLocation
     */
    'additionalValues'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'orderedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'revokedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'relevantStreet'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'pointOfDeliveryInBasicSupplyArea'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'relocationContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'relatedContractType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'relatedContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'phoneMobileAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'phoneMobile'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'phoneHomeAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'phoneHome'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'phoneBusinessAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'phoneBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'emailPrivate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'emailBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'researchedCustomer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_alternativeAddress'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_careOfRecipient'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_countryAlpha2'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_fax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'billing_email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'relocationAddressTransfer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'paymentProviderData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'campaign'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'campaignId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'exportAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'salesChannel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'inputChannel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'adsMail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'adsPhone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'adsPost'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'previousProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'previousProduct'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'previousProviderCodeNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'previousProviderCodeNumberProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'netCodeNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'netCodeNumberProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'customerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'customerSpecification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'relocationAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'desiredDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'terminatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'basicSupplyAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'provider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'providerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'product'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productEco'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'variant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'priceKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'marketLocationIdentifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'usageInclusive'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'usage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'complexPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'complexPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderComplexPrices;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productWorkingPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productBasePrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'overConsumptionWorkingPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productWorkingPriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productBasePriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productInstantBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'energyTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productWorkingPriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productBasePriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productBonusTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productInstantBonusTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productBonusPercent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'productInstantBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'fixedPriceType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'fixedPriceMonths'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'fixedPriceDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'cancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'cancellationPeriodUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'minimumRuntime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'minimumRuntimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'extensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'extensionTimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'ediProcessId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'vpCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'uvpCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'createdBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'signatureDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'notifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'waitForConfirmationUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'confirmedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'additionalValues'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'flexbonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf2ContentContractsInnerOrder
     */
    'brand'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOf1ContentOrderBrand;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent
     */
    'customer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentClient}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent
     */
    'client'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentClient;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent
     */
    'product_version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContent
     */
    'order'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentClient
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentClient {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentClient
     */
    'creditorId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentClientAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentClientAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentClientAnyOf
     */
    'creditorId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfAuthorizedAt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'authorizedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfAuthorizedAt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'countryName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'unknown'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'countryId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'availableSentNotification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'authUserName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'authEnabled'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'accountUsername'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'accountUseremail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'phoneMobileAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'phoneMobile'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'phoneHomeAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'phoneHome'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'phoneBusinessAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'phoneBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'emailPrivate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'emailBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'adsMail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'adsPhone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'adsPost'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'customerCommunicationType': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerCustomerCommunicationTypeEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedData;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'customerGroups': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfVARTKD}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomer
     */
    'customer_insolvencies'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfVARTKD;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerCustomerCommunicationTypeEnum = {
    _0: '0',
    _1: '1',
    _2: '2'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerCustomerCommunicationTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerCustomerCommunicationTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerCustomerCommunicationTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfAuthorizedAt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'authorizedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfAuthorizedAt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'countryName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'unknown'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'countryId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'salutation': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'title'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'availableSentNotification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'authUserName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'authEnabled'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'accountUsername'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'accountUseremail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'phoneMobileAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'phoneMobile'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'phoneHomeAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'phoneHome'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'phoneBusinessAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'phoneBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'emailPrivate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'emailBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'adsMail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'adsPhone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'adsPost'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'customerCommunicationType': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerCommunicationTypeEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedData;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'customerGroups': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfVARTKD}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOf
     */
    'customer_insolvencies'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfVARTKD;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerCommunicationTypeEnum = {
    _0: '0',
    _1: '1',
    _2: '2'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerCommunicationTypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerCommunicationTypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerCommunicationTypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfAuthorizedAt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfAuthorizedAt {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner
     */
    'additionalData': Array<any>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInner
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerData
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerData
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerDataExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerData
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerDataExtendedData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerDataExtendedData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerDataExtendedData {
    [key: string]: any;

    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerDataExtendedData
     */
    'categories': any;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfCustomerGroupsInnerDataExtendedData
     */
    'values': any;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedData {
    [key: string]: any;

    /**
     * 
     * @type {{ [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataCategoriesValue; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedData
     */
    'categories': { [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataCategoriesValue; };
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValues}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedData
     */
    'values': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValues;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataCategoriesValue
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataCategoriesValue {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataCategoriesValue
     */
    'technicalKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataCategoriesValue
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataCategoriesValue
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataCategoriesValue
     */
    'position'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValues
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValues {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfVARTKD}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValues
     */
    'VART_KD'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfVARTKD;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfVARTKD
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfVARTKD {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner
     */
    'technicalKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner
     */
    'value'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner
     */
    'position'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentCustomerAnyOfExtendedDataValuesAllOfValueInner
     */
    'fieldValueId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'orderedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'revokedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'relevantStreet'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'pointOfDeliveryInBasicSupplyArea'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'relocationContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'relatedContractType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'relatedContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'phoneMobileAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'phoneMobile'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'phoneHomeAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'phoneHome'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'phoneBusinessAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'phoneBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'emailPrivate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'emailBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'researchedCustomer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_alternativeAddress'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_salutation': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_careOfRecipient'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_countryAlpha2'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_fax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'billing_email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'relocationAddressTransfer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'paymentProviderData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'campaign'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'campaignId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'exportAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'salesChannel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'inputChannel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'adsMail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'adsPhone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'adsPost'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'previousProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'previousProduct'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'previousProviderCodeNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'previousProviderCodeNumberProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'netCodeNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'netCodeNumberProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'customerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'customerSpecification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'relocationAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'desiredDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'terminatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'basicSupplyAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'provider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'providerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'product'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productEco'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'variant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'priceKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'marketLocationIdentifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'usageInclusive'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'usage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'complexPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'complexPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productWorkingPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productBasePrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'overConsumptionWorkingPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productWorkingPriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productBasePriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productInstantBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'energyTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productWorkingPriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productBasePriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productBonusTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productInstantBonusTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productBonusPercent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'productInstantBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'fixedPriceType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'fixedPriceMonths'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'fixedPriceDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'cancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'cancellationPeriodUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'minimumRuntime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'minimumRuntimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'extensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'extensionTimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'ediProcessId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'vpCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'uvpCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'createdBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'signatureDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'notifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'waitForConfirmationUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'confirmedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'additionalValues'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'flexbonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrder
     */
    'brand'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'orderedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'revokedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'relevantStreet'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'customerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'salutation': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'dateOfBirth'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'pointOfDeliveryInBasicSupplyArea'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'externalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'relocationContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'relatedContractType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'relatedContractId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'phoneMobileAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'phoneMobile'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'phoneHomeAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'phoneHome'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'phoneBusinessAreaCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'phoneBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'emailPrivate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'emailBusiness'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'researchedCustomer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'energy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_alternativeAddress'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_company'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_salutation': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_firstname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_surname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_careOfRecipient'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_zip'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_country'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_countryAlpha2'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_city'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_street'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_houseNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_fax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_phone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'billing_email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'relocationAddressTransfer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'bank'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'alternativeAccountHolder'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'directDebit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'paymentProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'paymentProviderData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'campaign'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'campaignId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'exportAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'salesChannel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'inputChannel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'adsMail'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'adsPhone'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'adsPost'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'previousProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'previousProduct'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'previousProviderCodeNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'previousProviderCodeNumberProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'netCodeNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'netCodeNumberProvider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'customerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'customerSpecification'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'relocationAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'desiredDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'terminatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'basicSupplyAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'provider'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'providerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'product'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productEco'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'variant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'priceKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'counterNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'marketLocationIdentifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'usageInclusive'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'usage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'complexPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'complexPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productWorkingPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productBasePrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'overConsumptionWorkingPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productWorkingPriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productBasePriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productInstantBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'energyTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productWorkingPriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productBasePriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productBonusTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productInstantBonusTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productBonusPercent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'productInstantBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'fixedPriceType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'fixedPriceMonths'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'fixedPriceDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'cancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'cancellationPeriodUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'minimumRuntime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'minimumRuntimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'extensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'extensionTimeUnit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'ediProcessId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'vpCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'uvpCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'extendedData': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'createdBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'signatureDate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'notifier'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'waitForConfirmationUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'confirmedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'additionalValues'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'flexbonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOf
     */
    'brand'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrand
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOf
     */
    'data': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOf
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData
     */
    'isDeleted'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData
     */
    'createdBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfBrandAnyOfData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices
     */
    'data'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPrices
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOf
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOf
     */
    'data'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOf
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfData {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPrice}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfData
     */
    'complexPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPrice;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfData
     */
    'meterPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPrice}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOf
     */
    'complexPrice'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPrice;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOf
     */
    'meterPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPrice
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPrice {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'usageFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'usageUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'basePriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'basePriceBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'basePriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'basePriceTaxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPrices}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInner
     */
    'workingPrices'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPrices;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPrices
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPrices {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'registerName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'workingPriceNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'workingPriceBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'workingPriceTax'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfComplexPricesAnyOfDataAnyOfComplexPriceAnyOfInnerWorkingPricesAnyOfInner
     */
    'workingPriceTaxRate'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData {
    [key: string]: any;

    /**
     * 
     * @type {{ [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue; }}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData
     */
    'categories': { [key: string]: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue; };
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValues}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedData
     */
    'values': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValues;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue
     */
    'technicalKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataCategoriesValue
     */
    'position'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValues
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValues {
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValues
     */
    'VART'?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValues
     */
    'ZSTURVORHANDEN'?: Array<any>;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner
     */
    'technicalKey'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner
     */
    'type'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner
     */
    'value'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner
     */
    'position'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfExtendedDataValuesAllOfValueInner
     */
    'fieldValueId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'productId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'supplyType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'consumptionType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'priceType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'pricingType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'usageNtPercentage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'updatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'releaseRequestedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'releasedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'deprecatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'lockedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'validFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'validUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'kind'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'eco'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'invoiceBase'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractInvoiceCycle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractInvoiceCycleInterval'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractInvoiceCycleIntervalType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractInitialDuration'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractInitialDurationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractExtensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractExtensionTimeType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractCancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'contractCancellationPeriodType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpExternalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpWeight'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpStatisticGroup'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpVolume'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpVariantGroupCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpProductLink'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpManufacturer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpManufacturerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpAccount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'erpAllowSplitAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'cmsAgb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'cmsProperties'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'cmsDescriptionInternal'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'cmsDescriptionExternal'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'cmsFileId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'noteFreetext'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'everyTimeCancellable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'relocationProhibited'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'meterPricing'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'brand': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfAdditionalTerminationRightBeforeDelivery}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'additionalTerminationRightBeforeDelivery'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfAdditionalTerminationRightBeforeDelivery;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersion
     */
    'billingRuleTemplateId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'productId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'supplyType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'consumptionType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'priceType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'business'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'pricingType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'usageNtPercentage'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'updatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'releaseRequestedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'releasedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'deprecatedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'lockedAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'validFrom'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'validUntil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'kind'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'eco'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'invoiceBase'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractInvoiceCycle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractInvoiceCycleInterval'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractInvoiceCycleIntervalType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractInitialDuration'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractInitialDurationType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractExtensionTime'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractExtensionTimeType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractCancellationPeriod'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'contractCancellationPeriodType'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpExternalId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpWeight'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpStatisticGroup'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpVolume'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpVariantGroupCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpProductLink'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpManufacturer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpManufacturerNumber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpAccount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'erpAllowSplitAmount'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'cmsAgb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'cmsProperties'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'cmsDescriptionInternal'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'cmsDescriptionExternal'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'cmsFileId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'noteFreetext'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'everyTimeCancellable'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'relocationProhibited'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'meterPricing'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'brand': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfAdditionalTerminationRightBeforeDelivery}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'additionalTerminationRightBeforeDelivery'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfAdditionalTerminationRightBeforeDelivery;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOf
     */
    'billingRuleTemplateId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfAdditionalTerminationRightBeforeDelivery
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfAdditionalTerminationRightBeforeDelivery {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand
     */
    'data'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrand
     */
    'additionalData'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData {
    [key: string]: any;

    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData
     */
    'id'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandDataName}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData
     */
    'name'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandDataName;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData
     */
    'isDeleted'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData
     */
    'createdBy'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandData
     */
    'createdAt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandDataName
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandDataName {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfVersion
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfVersion {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2
     */
    'type': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2TypeEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2Event}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2
     */
    'event': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2Event;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2TypeEnum = {
    CustomContractEvent: 'CUSTOM_CONTRACT_EVENT'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2TypeEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2TypeEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2TypeEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2Event
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2Event {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2Event
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf2Event
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner
     */
    'archivId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner
     */
    'titel': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOfArchivDokumentReferenzenInner
     */
    'erstellDatum': any;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'dokumentTyp': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAntwortfrist}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'antwortfrist'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAntwortfrist;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'accountDatenSPE'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProdukt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'produkt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProdukt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'postAnschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'kunde'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'lieferstelle'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'bankdaten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'auftrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'vertrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'aktion'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProdukt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'vertragsProdukt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProdukt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadata}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'metadata'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadata;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'preisanpassung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'aktiveBankverbindungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'zukuenftigeBankverbindungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehler}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'vertragsZaehler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehler;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadUmzug}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'umzug'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadUmzug;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'kuendigung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'ablesung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'produktwechselWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstruktur}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'marktstruktur'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstruktur;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartner}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'marktpartner'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartner;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'mahnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadSperrung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'sperrung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadSperrung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'ratenplan'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'abschlag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'abschlagNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplan}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'abschlagsplan'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplan;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferant}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'lieferant'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferant;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumente}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'archivDokumente'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumente;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'postversandDeaktiviert'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDuplikatversandGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'duplikatversandGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDuplikatversandGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'aenderungBankverbindung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'stornoMaLoIdentProzess'?: boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'todesfall'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'vertragskontokorrent'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'kontoZahlung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOns}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'addOns'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOns;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'ladeVorteil'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayload
     */
    'dynamischerTreuebonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesung
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesung
     */
    'messwertVorhanden'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesungAnyOf
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAblesungAnyOf
     */
    'messwertVorhanden'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfFaelligkeitAlternativ}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfFaelligkeitAlternativ;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
     */
    'faelligkeitNaechste'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfForderungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfForderungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlag
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfFaelligkeitAlternativ}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfFaelligkeitAlternativ;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
     */
    'faelligkeitNaechste'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfForderungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfForderungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOf
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfFaelligkeitAlternativ
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfFaelligkeitAlternativ {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfForderungen
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagAnyOfForderungen {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'faelligkeitNaechste'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeu
     */
    'prozessAbschlagsaenderung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'ausgeglicheneAbschlaegeGesamt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'betragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'betragNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'faelligkeitAlternativ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'faelligkeitNaechste'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'forderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'betragMehrwertsteuer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagNeuAnyOf
     */
    'prozessAbschlagsaenderung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplan
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplan {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplan
     */
    'naechsteRechnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaege}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplan
     */
    'abschlaege'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaege;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOf
     */
    'naechsteRechnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaege}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOf
     */
    'abschlaege'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaege;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaege
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaege {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaegeAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaegeAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaegeAnyOfInner
     */
    'bruttoBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAbschlagsplanAnyOfAbschlaegeAnyOfInner
     */
    'datumZahlungFaelligkeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE
     */
    'status': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE
     */
    'inviteLink': any;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE
     */
    'benutzer': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPE
     */
    'verknuepftMitKundennummerSeit': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOf
     */
    'status': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOf
     */
    'inviteLink': any;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOf
     */
    'benutzer': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOf
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOf
     */
    'verknuepftMitKundennummerSeit': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf
     */
    'inviteLink': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf
     */
    'benutzer'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf
     */
    'verknuepftMitKundennummerSeit': any | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1
     */
    'status': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1Benutzer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1
     */
    'benutzer': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1Benutzer;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1
     */
    'inviteLink'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1
     */
    'verknuepfungMitKundennummer': boolean;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1
     */
    'verknuepftMitKundennummerSeit': any | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1Benutzer
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1Benutzer {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1Benutzer
     */
    'email': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1Benutzer
     */
    'letzterLogin': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1Benutzer
     */
    'sub': string;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2
     */
    'status': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2
     */
    'benutzer': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2
     */
    'inviteLink'?: any;
    /**
     * 
     * @type {boolean}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2
     */
    'verknuepfungMitKundennummer': boolean | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2
     */
    'verknuepftMitKundennummerSeit': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer
     */
    'email': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer
     */
    'letzterLogin': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf2Benutzer
     */
    'sub': string;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOns
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOns {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
     */
    'zugeordnetesCommodityProduktProductCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
     */
    'zugeordnetesCommodityProduktProductName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
     */
    'aktivAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
     */
    'aktivBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAddOnsAnyOfInner
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung
     */
    'aenderungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung
     */
    'aenderungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung
     */
    'geaendertDurch'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung
     */
    'relevantFuerKundenkommunikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung
     */
    'bankAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindung
     */
    'bankNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOf
     */
    'aenderungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOf
     */
    'aenderungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOf
     */
    'geaendertDurch'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOf
     */
    'relevantFuerKundenkommunikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOf
     */
    'bankAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOf
     */
    'bankNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'ersatzBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'sepaLastschriftAutorisiert'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'kontoInhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'sepaMandatId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'zahlungsDienstleister'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankAlt
     */
    'zahlungsRichtung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'ersatzBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'sepaLastschriftAutorisiert'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'kontoInhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'sepaMandatId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'zahlungsDienstleister'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAenderungBankverbindungAnyOfBankNeu
     */
    'zahlungsRichtung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktion
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktion {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktion
     */
    'prozessHandler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktion
     */
    'prozessTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktion
     */
    'prozessStatus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktion
     */
    'prozessStatusNachricht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktionAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktionAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktionAnyOf
     */
    'prozessHandler'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktionAnyOf
     */
    'prozessTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktionAnyOf
     */
    'prozessStatus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktionAnyOf
     */
    'prozessStatusNachricht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungen
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungen {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehend}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungen
     */
    'ausgehend'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehend;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungen
     */
    'eingehend'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehend}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOf
     */
    'ausgehend'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehend;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOf
     */
    'eingehend'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehend
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehend {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'ersatzBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'sepaLastschriftAutorisiert'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'kontoInhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'sepaMandatId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'zahlungsDienstleister'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfAusgehendAnyOfInner
     */
    'zahlungsRichtung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'bic'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'ersatzBankId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'sepaLastschriftAutorisiert'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'kontoInhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'sepaMandatId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'zahlungsDienstleister'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehendAnyOfInner
     */
    'zahlungsRichtung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAntwortfrist
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAntwortfrist {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAntwortfristAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAntwortfristAnyOf {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumente
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumente {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInner
     */
    'referenz': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInner
     */
    'inhalt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz
     */
    'archivId': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz
     */
    'titel': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadArchivDokumenteAnyOfInnerReferenz
     */
    'erstellDatum': any;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'kampagne'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'geburtsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'codenummerNetzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfProduktBonusBrutto}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'produktBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfProduktBonusBrutto;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'produktBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'sofortBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'sofortBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'datumEinzug'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'gewuenschterLieferbeginn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'tarifScheibe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftrag
     */
    'monateMindestlaufzeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'kampagne'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'geburtsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'codenummerNetzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfProduktBonusBrutto}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'produktBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfProduktBonusBrutto;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'produktBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'sofortBonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'sofortBonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'datumEinzug'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'gewuenschterLieferbeginn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'tarifScheibe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOf
     */
    'monateMindestlaufzeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfProduktBonusBrutto
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfProduktBonusBrutto {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfProduktBonusBruttoAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfProduktBonusBruttoAnyOf {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreise}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe
     */
    'komplexePreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe
     */
    'simpelPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibe
     */
    'istKomplexPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreise}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf
     */
    'komplexePreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf
     */
    'simpelPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOf
     */
    'istKomplexPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreise
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreise {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerEnergieMengeVon}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInner
     */
    'energieMengeVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerEnergieMengeVon;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInner
     */
    'energieMengeBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreise}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInner
     */
    'arbeitsPreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInner
     */
    'grundPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreis;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreise
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreise {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'bruttoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'nettoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'mehrwertsteuerPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'registerName': string | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerEnergieMengeVon
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerEnergieMengeVon {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerEnergieMengeVonAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerEnergieMengeVonAnyOf {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreis
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreis {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreis
     */
    'bruttoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreis
     */
    'nettoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreis
     */
    'mehrwertsteuerPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreis
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreisAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreisAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreisAnyOf
     */
    'bruttoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreisAnyOf
     */
    'nettoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreisAnyOf
     */
    'mehrwertsteuerPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfKomplexePreiseAnyOfInnerGrundPreisAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreis
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreis {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreis
     */
    'grundPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreis
     */
    'arbeitsPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOf
     */
    'grundPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOf
     */
    'arbeitsPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis
     */
    'bruttoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis
     */
    'nettoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis
     */
    'mehrwertsteuerPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten
     */
    'lastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten
     */
    'sepaMandat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten
     */
    'kontoinhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdaten
     */
    'gueltigAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdatenAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdatenAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdatenAnyOf
     */
    'lastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdatenAnyOf
     */
    'iban'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdatenAnyOf
     */
    'bankName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdatenAnyOf
     */
    'sepaMandat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdatenAnyOf
     */
    'kontoinhaber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadBankdatenAnyOf
     */
    'gueltigAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDuplikatversandGrund
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDuplikatversandGrund {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'aktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'deaktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfDeaktivierungsGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'bonusStaffelung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'aktuellerBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'naechsterBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'produktNameAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'produktCodeAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'abrechnungVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'abrechnungBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'rechnungsbetragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'bonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'bonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonus
     */
    'bonusMwSt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'aktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'deaktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfDeaktivierungsGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'bonusStaffelung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'aktuellerBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'naechsterBonusProzentSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'produktNameAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'produktCodeAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'abrechnungVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'abrechnungBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'rechnungsbetragBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'bonusNetto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'bonusBrutto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOf
     */
    'bonusMwSt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelung {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner {
    /**
     * 
     * @type {number}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'vertragsJahr': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'prozentSatz': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfBonusStaffelungAnyOfInner
     */
    'verrechenbarAb': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfDeaktivierungsGrund
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadDynamischerTreuebonusAnyOfDeaktivierungsGrund {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOfForderung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlung
     */
    'forderung': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOfForderung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlung
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOfForderung}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOf
     */
    'forderung': GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOfForderung;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOf
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOfForderung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOfForderung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKontoZahlungAnyOfForderung
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung
     */
    'kuendigungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung
     */
    'grundTechnischerSchluessel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigung
     */
    'ausloeserKuendigung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigungAnyOf
     */
    'kuendigungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigungAnyOf
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigungAnyOf
     */
    'grund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigungAnyOf
     */
    'grundTechnischerSchluessel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKuendigungAnyOf
     */
    'ausloeserKuendigung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'kundennummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfBevorzugteVersandArt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'bevorzugteVersandArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfBevorzugteVersandArt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'kundengruppe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'kundenVersandArtPraeferenz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeKundenVersandArtPraeferenzEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'unbekannt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'adresse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'geburtsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKunde
     */
    'bestandskunde'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeKundenVersandArtPraeferenzEnum = {
    EMail: 'E-Mail',
    Brief: 'Brief',
    Unbekannt: 'Unbekannt'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeKundenVersandArtPraeferenzEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeKundenVersandArtPraeferenzEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeKundenVersandArtPraeferenzEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'kundennummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfBevorzugteVersandArt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'bevorzugteVersandArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfBevorzugteVersandArt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'kundengruppe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'kundenVersandArtPraeferenz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfKundenVersandArtPraeferenzEnum;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'email'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'unbekannt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'adresse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'telefonFirmaVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'telefonPrivatVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'telefonFirmaRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'telefonPrivatRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'telefonMobilVorwahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'telefonMobilRufnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'geburtsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOf
     */
    'bestandskunde'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}

export const GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfKundenVersandArtPraeferenzEnum = {
    EMail: 'E-Mail',
    Brief: 'Brief',
    Unbekannt: 'Unbekannt'
} as const;

export type GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfKundenVersandArtPraeferenzEnum = typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfKundenVersandArtPraeferenzEnum[keyof typeof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfKundenVersandArtPraeferenzEnum];

/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'firma'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'titel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'anrede'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'vorname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'nachname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'careOf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'strasse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'hausnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'ort'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'postleitzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'land'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresse
     */
    'postfach'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'firma'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'titel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'anrede'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'vorname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'nachname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'careOf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'strasse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'hausnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'ort'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'postleitzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'land'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfAdresseAnyOf
     */
    'postfach'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfBevorzugteVersandArt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadKundeAnyOfBevorzugteVersandArt {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'aktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'deaktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOfDeaktivierungsGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'maximalBonusErreicht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'maximalerBonusProMonatInKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'maximalerBonusProMonatInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'bonusInCentProKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'bonusMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'bonusJahr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'energieMenge'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'bonusBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'gesamtBonusSeitAktivierungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'bonusSeitLetzterAbrechnungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'gesamtBonusSeitAktivierungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'bonusSeitLetzterAbrechnungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteil
     */
    'standGesamtBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'aktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'deaktivierungsDatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOfDeaktivierungsGrund}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'deaktivierungsGrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOfDeaktivierungsGrund;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'maximalBonusErreicht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'maximalerBonusProMonatInKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'maximalerBonusProMonatInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'bonusInCentProKwh'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'bonusMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'bonusJahr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'energieMenge'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'bonusBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'gesamtBonusSeitAktivierungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'bonusSeitLetzterAbrechnungInCents'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'gesamtBonusSeitAktivierungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'bonusSeitLetzterAbrechnungInEuro'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOf
     */
    'standGesamtBonus'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOfDeaktivierungsGrund
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLadeVorteilAnyOfDeaktivierungsGrund {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferant
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferant {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferant
     */
    'glaeubigerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferantAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferantAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferantAnyOf
     */
    'glaeubigerId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle
     */
    'lagezusatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle
     */
    'lageergaenzung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle
     */
    'strasse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle
     */
    'hausnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle
     */
    'ort'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelle
     */
    'postleitzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelleAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelleAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelleAnyOf
     */
    'lagezusatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelleAnyOf
     */
    'lageergaenzung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelleAnyOf
     */
    'strasse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelleAnyOf
     */
    'hausnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelleAnyOf
     */
    'ort'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadLieferstelleAnyOf
     */
    'postleitzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'benachrichtigungstyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'gesamtMahnfaehigerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'zahlungsfrist'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'mahngebuehr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'mahnstufeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnposten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'mahnposten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnposten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'zusatzforderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnung
     */
    'gesamtForderungsbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'benachrichtigungstyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'gesamtMahnfaehigerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'zahlungsfrist'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'mahngebuehr'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'mahnstufeName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnposten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'mahnposten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnposten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungen}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'zusatzforderungen'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungen;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOf
     */
    'gesamtForderungsbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnposten
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnposten {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'faelligkeitsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'verrechneterAbschlagMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'bruttobetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'beglichenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'steuersatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnstufe'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnstufenName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'zahlungsfrist'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfMahnpostenAnyOfInner
     */
    'mahnbar'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungen
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungen {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'faelligkeitsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'verrechneterAbschlagMonat'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'typ'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'bruttobetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'beglichenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'steuersatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'mahnbar'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMahnungAnyOfZusatzforderungenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartner
     */
    'bezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartner
     */
    'kundenId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartnerAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartnerAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartnerAnyOf
     */
    'bezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktpartnerAnyOf
     */
    'kundenId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstruktur
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstruktur {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstruktur
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiber}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstruktur
     */
    'netzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiber;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOf
     */
    'marktlokation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiber}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOf
     */
    'netzbetreiber'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiber;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiber
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiber {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiber
     */
    'organisationFirma'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiberAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiberAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMarktstrukturAnyOfNetzbetreiberAnyOf
     */
    'organisationFirma'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadata
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadata {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadata
     */
    'eventId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadata
     */
    'correlationId': string;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadata
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadataAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadataAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadataAnyOf
     */
    'eventId'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadataAnyOf
     */
    'correlationId': string | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadMetadataAnyOf
     */
    'version'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'firma'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'titel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'anrede'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'vorname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'nachname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'careOf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'strasse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'hausnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'ort'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'postleitzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'land'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschrift
     */
    'postfach'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'firma'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'titel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'anrede'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'vorname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'nachname'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'careOf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'strasse'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'hausnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'ort'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'postleitzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'land'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPostAnschriftAnyOf
     */
    'postfach'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassung
     */
    'tarifAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassung
     */
    'tarifNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOf
     */
    'tarifAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOf
     */
    'tarifNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt
     */
    'komplexePreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt
     */
    'simpelPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAlt
     */
    'istKomplexPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf
     */
    'gueltigVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf
     */
    'gueltigBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf
     */
    'komplexePreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf
     */
    'simpelPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOf
     */
    'istKomplexPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreise {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInner
     */
    'energieMengeVon'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInner
     */
    'energieMengeBis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreise}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInner
     */
    'arbeitsPreise'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreise;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInner
     */
    'grundPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreise
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreise {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'bruttoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'nettoPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'mehrwertsteuerPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'mehrwertsteuerSatz'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentVersion;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfKomplexePreiseAnyOfInnerArbeitsPreiseAnyOfInner
     */
    'registerName': string;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis
     */
    'grundPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadPreisanpassungAnyOfTarifAltAnyOfSimpelPreis
     */
    'arbeitsPreis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAuftragAnyOfTarifScheibeAnyOfSimpelPreisAnyOfGrundPreis;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProdukt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProdukt {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProdukt
     */
    'marke'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProdukt
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktAnyOf
     */
    'marke'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderruf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderrufAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderrufAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderrufAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderrufAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderrufAnyOf
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderrufAnyOf
     */
    'produktNameNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadProduktwechselWiderrufAnyOf
     */
    'produktCodeNeu'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan
     */
    'gesamtbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan
     */
    'beendigungsgrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan
     */
    'raten': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplan
     */
    'istLastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOf
     */
    'gesamtbetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOf
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOf
     */
    'beendigungsgrund'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner>}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOf
     */
    'raten': Array<GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner>;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOf
     */
    'istLastschrift'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner
     */
    'betrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadRatenplanAnyOfRatenInner
     */
    'faelligkeitsdatum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadSperrung
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadSperrung {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadSperrung
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadSperrungAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadSperrungAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadSperrungAnyOf
     */
    'sperrkosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadUmzug
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadUmzug {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadUmzug
     */
    'titel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadUmzugAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadUmzugAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadUmzugAnyOf
     */
    'titel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'vertragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'ablehnungsgrundBeschreibung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'ablehnungsgrundTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'datumLieferendeBestaetigt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'datumVertragsbeginn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'datumVertragsende'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'endeDatumGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'endeRechnungsZeitraum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'lieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'lieferbeginnGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'naechsterKuendigungstermin'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'rechnungsDatumGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'statusCodeBezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'vertragsbindungLieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertrag
     */
    'kundenSpezifikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'vertragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'auftragsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'energieArt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'ablehnungsgrundBeschreibung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'ablehnungsgrundTitel'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'datumLieferendeBestaetigt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'datumVertragsbeginn'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'datumVertragsende'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'datumWiderruf'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'endeDatumGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'endeRechnungsZeitraum'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'lieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'lieferbeginnGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'naechsterKuendigungstermin'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'rechnungsDatumGewuenscht'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'status'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'statusCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'statusCodeBezeichnung'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'vertragsbindungLieferantAlt'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragAnyOf
     */
    'kundenSpezifikation'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProdukt
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProdukt {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProdukt
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProdukt
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProduktAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProduktAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProduktAnyOf
     */
    'produktName'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsProduktAnyOf
     */
    'produktCode'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehler
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehler {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehler
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehler
     */
    'tarifAnzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehler
     */
    'zaehlerTyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehlerAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehlerAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehlerAnyOf
     */
    'zaehlerNummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehlerAnyOf
     */
    'tarifAnzahl'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragsZaehlerAnyOf
     */
    'zaehlerTyp'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfVarianteVertragskonto}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent
     */
    'varianteVertragskonto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfVarianteVertragskonto;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPosten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent
     */
    'posten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPosten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent
     */
    'allePosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent
     */
    'werteAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrent
     */
    'saldo'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfVarianteVertragskonto}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOf
     */
    'varianteVertragskonto'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfVarianteVertragskonto;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPosten}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOf
     */
    'posten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPosten;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOf
     */
    'allePosten'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentOrderAnyOfDirectDebit | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOf
     */
    'werteAb'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOf
     */
    'saldo'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPosten
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPosten {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'zahlart'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'hinweis'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'buchungsnummer'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfEnvironment | null;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'zugehoerigeBuchungsnummern'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfInitialPayloadAnyOf1PowercloudEventAnyOfContentProductVersionAnyOfBrandAdditionalData;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'betrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'offenerBetrag'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfPostenAnyOfInner
     */
    'datumZahlungFaelligkeit'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAccountDatenSPEAnyOfAnyOf1BenutzerLetzterLogin;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfVarianteVertragskonto
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfVarianteVertragskonto {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfVarianteVertragskontoAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadVertragskontokorrentAnyOfVarianteVertragskontoAnyOf {
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen
     */
    'ausgehend'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungen
     */
    'eingehend'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungenAnyOf
 */
export interface GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungenAnyOf {
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungenAnyOf
     */
    'ausgehend'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend;
    /**
     * 
     * @type {GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend}
     * @memberof GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadZukuenftigeBankverbindungenAnyOf
     */
    'eingehend'?: GetVorgang200ResponseVorgangAbarbeitungenInnerSchritteInnerAnyOfSuccessPayloadAktiveBankverbindungenAnyOfEingehend;
}
/**
 * 
 * @export
 * @interface GetVorgang200ResponseVorgangProtokollInner
 */
export interface GetVorgang200ResponseVorgangProtokollInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangProtokollInner
     */
    'action': GetVorgang200ResponseVorgangProtokollInnerActionEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangProtokollInner
     */
    'user': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang200ResponseVorgangProtokollInner
     */
    'date': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetVorgang200ResponseVorgangProtokollInner
     */
    'details': { [key: string]: any; } | null;
}

export const GetVorgang200ResponseVorgangProtokollInnerActionEnum = {
    Locked: 'LOCKED',
    Unlocked: 'UNLOCKED',
    Deleted: 'DELETED',
    Restored: 'RESTORED',
    SchrittZwischenspeichern: 'SCHRITT_ZWISCHENSPEICHERN',
    VorgangZurueckgestellt: 'VORGANG_ZURUECKGESTELLT',
    PersistenceReconciled: 'PERSISTENCE_RECONCILED',
    ArchivierungAbgeglichen: 'ARCHIVIERUNG_ABGEGLICHEN'
} as const;

export type GetVorgang200ResponseVorgangProtokollInnerActionEnum = typeof GetVorgang200ResponseVorgangProtokollInnerActionEnum[keyof typeof GetVorgang200ResponseVorgangProtokollInnerActionEnum];

/**
 * 
 * @export
 * @interface GetVorgang400Response
 */
export interface GetVorgang400Response {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400Response
     */
    'instance'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400Response
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400Response
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400Response
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400Response
     */
    'errorCode': GetVorgang400ResponseErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400Response
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400Response
     */
    'data': any | null;
}

export const GetVorgang400ResponseErrorCodeEnum = {
    OpmCockpitBackendClientErrorStreamserveProjektInUse: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-STREAMSERVE_PROJEKT_IN_USE'
} as const;

export type GetVorgang400ResponseErrorCodeEnum = typeof GetVorgang400ResponseErrorCodeEnum[keyof typeof GetVorgang400ResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf
 */
export interface GetVorgang400ResponseAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf
     */
    'errorCode': GetVorgang400ResponseAnyOfErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf
     */
    'title': string;
    /**
     * 
     * @type {GetVorgang400ResponseAnyOfData}
     * @memberof GetVorgang400ResponseAnyOf
     */
    'data': GetVorgang400ResponseAnyOfData;
}

export const GetVorgang400ResponseAnyOfErrorCodeEnum = {
    OpmCockpitBackendClientErrorInvalidContentType: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-INVALID_CONTENT_TYPE'
} as const;

export type GetVorgang400ResponseAnyOfErrorCodeEnum = typeof GetVorgang400ResponseAnyOfErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOfErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf1
 */
export interface GetVorgang400ResponseAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf1
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf1
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf1
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf1
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf1
     */
    'errorCode': GetVorgang400ResponseAnyOf1ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf1
     */
    'title': string;
    /**
     * 
     * @type {Array<GetVorgang400ResponseAnyOf1DataInner>}
     * @memberof GetVorgang400ResponseAnyOf1
     */
    'data': Array<GetVorgang400ResponseAnyOf1DataInner>;
}

export const GetVorgang400ResponseAnyOf1ErrorCodeEnum = {
    OpmCockpitBackendClientErrorValidationError: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VALIDATION_ERROR'
} as const;

export type GetVorgang400ResponseAnyOf1ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf1ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf1ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf10
 */
export interface GetVorgang400ResponseAnyOf10 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf10
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf10
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf10
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf10
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf10
     */
    'errorCode': GetVorgang400ResponseAnyOf10ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf10
     */
    'title': string;
    /**
     * 
     * @type {Array<GetPingPongByPing400ResponseAnyOf12DataInner>}
     * @memberof GetVorgang400ResponseAnyOf10
     */
    'data': Array<GetPingPongByPing400ResponseAnyOf12DataInner>;
}

export const GetVorgang400ResponseAnyOf10ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDokumentTypAlreadyExists: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DOKUMENT_TYP_ALREADY_EXISTS'
} as const;

export type GetVorgang400ResponseAnyOf10ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf10ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf10ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf11
 */
export interface GetVorgang400ResponseAnyOf11 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf11
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf11
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf11
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf11
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf11
     */
    'errorCode': GetVorgang400ResponseAnyOf11ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf11
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf11
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf11ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDokumenttypMappingIsDeleted: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DOKUMENTTYP_MAPPING_IS_DELETED'
} as const;

export type GetVorgang400ResponseAnyOf11ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf11ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf11ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf12
 */
export interface GetVorgang400ResponseAnyOf12 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf12
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf12
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf12
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf12
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf12
     */
    'errorCode': GetVorgang400ResponseAnyOf12ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf12
     */
    'title': string;
    /**
     * 
     * @type {Array<GetPingPongByPing400ResponseAnyOf12DataInner>}
     * @memberof GetVorgang400ResponseAnyOf12
     */
    'data': Array<GetPingPongByPing400ResponseAnyOf12DataInner>;
}

export const GetVorgang400ResponseAnyOf12ErrorCodeEnum = {
    OpmCockpitBackendClientErrorStreamserveProjektNotFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-STREAMSERVE_PROJEKT_NOT_FOUND'
} as const;

export type GetVorgang400ResponseAnyOf12ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf12ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf12ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf13
 */
export interface GetVorgang400ResponseAnyOf13 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf13
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf13
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf13
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf13
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf13
     */
    'errorCode': GetVorgang400ResponseAnyOf13ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf13
     */
    'title': string;
    /**
     * 
     * @type {Array<GetPingPongByPing400ResponseAnyOf12DataInner>}
     * @memberof GetVorgang400ResponseAnyOf13
     */
    'data': Array<GetPingPongByPing400ResponseAnyOf12DataInner>;
}

export const GetVorgang400ResponseAnyOf13ErrorCodeEnum = {
    OpmCockpitBackendClientErrorStreamserveProjektAlreadyExists: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-STREAMSERVE_PROJEKT_ALREADY_EXISTS'
} as const;

export type GetVorgang400ResponseAnyOf13ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf13ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf13ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf14
 */
export interface GetVorgang400ResponseAnyOf14 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf14
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf14
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf14
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf14
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf14
     */
    'errorCode': GetVorgang400ResponseAnyOf14ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf14
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf14
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf14ErrorCodeEnum = {
    OpmCockpitBackendClientErrorStreamserveProjektInUse: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-STREAMSERVE_PROJEKT_IN_USE'
} as const;

export type GetVorgang400ResponseAnyOf14ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf14ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf14ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf1DataInner
 */
export interface GetVorgang400ResponseAnyOf1DataInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf1DataInner
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf1DataInner
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf2
 */
export interface GetVorgang400ResponseAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf2
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf2
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf2
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf2
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf2
     */
    'errorCode': GetVorgang400ResponseAnyOf2ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf2
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf2
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf2ErrorCodeEnum = {
    OpmCockpitBackendClientErrorNoStartStepFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NO_START_STEP_FOUND'
} as const;

export type GetVorgang400ResponseAnyOf2ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf2ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf2ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf3
 */
export interface GetVorgang400ResponseAnyOf3 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf3
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf3
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf3
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf3
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf3
     */
    'errorCode': GetVorgang400ResponseAnyOf3ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf3
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf3
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf3ErrorCodeEnum = {
    OpmCockpitBackendClientErrorNoLastProcessingFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NO_LAST_PROCESSING_FOUND'
} as const;

export type GetVorgang400ResponseAnyOf3ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf3ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf3ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf4
 */
export interface GetVorgang400ResponseAnyOf4 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf4
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf4
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf4
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf4
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf4
     */
    'errorCode': GetVorgang400ResponseAnyOf4ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf4
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf4
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf4ErrorCodeEnum = {
    OpmCockpitBackendClientErrorVorgangNotInErrorState: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VORGANG_NOT_IN_ERROR_STATE'
} as const;

export type GetVorgang400ResponseAnyOf4ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf4ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf4ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf5
 */
export interface GetVorgang400ResponseAnyOf5 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf5
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf5
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf5
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf5
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf5
     */
    'errorCode': GetVorgang400ResponseAnyOf5ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf5
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf5
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf5ErrorCodeEnum = {
    OpmCockpitBackendClientErrorNoCurrentStepFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NO_CURRENT_STEP_FOUND'
} as const;

export type GetVorgang400ResponseAnyOf5ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf5ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf5ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf6
 */
export interface GetVorgang400ResponseAnyOf6 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf6
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf6
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf6
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf6
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf6
     */
    'errorCode': GetVorgang400ResponseAnyOf6ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf6
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf6
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf6ErrorCodeEnum = {
    OpmCockpitBackendClientErrorNoInitialPayloadFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NO_INITIAL_PAYLOAD_FOUND'
} as const;

export type GetVorgang400ResponseAnyOf6ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf6ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf6ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf7
 */
export interface GetVorgang400ResponseAnyOf7 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf7
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf7
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf7
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf7
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf7
     */
    'errorCode': GetVorgang400ResponseAnyOf7ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf7
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf7
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf7ErrorCodeEnum = {
    OpmCockpitBackendClientErrorVorgangDeleteWaitingPeriodNotReached: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VORGANG_DELETE_WAITING_PERIOD_NOT_REACHED'
} as const;

export type GetVorgang400ResponseAnyOf7ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf7ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf7ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf8
 */
export interface GetVorgang400ResponseAnyOf8 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf8
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf8
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf8
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf8
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf8
     */
    'errorCode': GetVorgang400ResponseAnyOf8ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf8
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf8
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf8ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDokumentTypMappingNotFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DOKUMENT_TYP_MAPPING_NOT_FOUND'
} as const;

export type GetVorgang400ResponseAnyOf8ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf8ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf8ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOf9
 */
export interface GetVorgang400ResponseAnyOf9 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf9
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf9
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang400ResponseAnyOf9
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf9
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf9
     */
    'errorCode': GetVorgang400ResponseAnyOf9ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOf9
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang400ResponseAnyOf9
     */
    'data': any | null;
}

export const GetVorgang400ResponseAnyOf9ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDokumentTypMappingNotCreated: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DOKUMENT_TYP_MAPPING_NOT_CREATED'
} as const;

export type GetVorgang400ResponseAnyOf9ErrorCodeEnum = typeof GetVorgang400ResponseAnyOf9ErrorCodeEnum[keyof typeof GetVorgang400ResponseAnyOf9ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang400ResponseAnyOfData
 */
export interface GetVorgang400ResponseAnyOfData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetVorgang400ResponseAnyOfData
     */
    'expectedContentTypes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang400ResponseAnyOfData
     */
    'receivedContentType': string;
}
/**
 * 
 * @export
 * @interface GetVorgang404Response
 */
export interface GetVorgang404Response {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang404Response
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang404Response
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang404Response
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang404Response
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang404Response
     */
    'errorCode': GetVorgang404ResponseErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang404Response
     */
    'title': string | null;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang404Response
     */
    'data': any | null;
}

export const GetVorgang404ResponseErrorCodeEnum = {
    OpmCockpitBackendClientErrorNotFound: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-NOT_FOUND'
} as const;

export type GetVorgang404ResponseErrorCodeEnum = typeof GetVorgang404ResponseErrorCodeEnum[keyof typeof GetVorgang404ResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang500Response
 */
export interface GetVorgang500Response {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500Response
     */
    'instance'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500Response
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang500Response
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500Response
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500Response
     */
    'errorCode': GetVorgang500ResponseErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500Response
     */
    'title': string;
    /**
     * 
     * @type {GetVorgang500ResponseAnyOf4Data}
     * @memberof GetVorgang500Response
     */
    'data': GetVorgang500ResponseAnyOf4Data;
}

export const GetVorgang500ResponseErrorCodeEnum = {
    OpmCockpitBackendClientErrorDurableFunctionError: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DURABLE_FUNCTION_ERROR'
} as const;

export type GetVorgang500ResponseErrorCodeEnum = typeof GetVorgang500ResponseErrorCodeEnum[keyof typeof GetVorgang500ResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf
 */
export interface GetVorgang500ResponseAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang500ResponseAnyOf
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf
     */
    'errorCode': GetVorgang500ResponseAnyOfErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf
     */
    'title': string;
    /**
     * 
     * @type {GetPingPongByPing500ResponseAnyOfData}
     * @memberof GetVorgang500ResponseAnyOf
     */
    'data': GetPingPongByPing500ResponseAnyOfData;
}

export const GetVorgang500ResponseAnyOfErrorCodeEnum = {
    OpmCockpitBackendExternalErrorDokumentVorschauNoResult: 'OPM_COCKPIT_BACKEND-EXTERNAL_ERROR-DOKUMENT_VORSCHAU_NO_RESULT'
} as const;

export type GetVorgang500ResponseAnyOfErrorCodeEnum = typeof GetVorgang500ResponseAnyOfErrorCodeEnum[keyof typeof GetVorgang500ResponseAnyOfErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf1
 */
export interface GetVorgang500ResponseAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf1
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf1
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang500ResponseAnyOf1
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf1
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf1
     */
    'errorCode': GetVorgang500ResponseAnyOf1ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf1
     */
    'title': string;
    /**
     * 
     * @type {GetVorgang500ResponseAnyOf1Data}
     * @memberof GetVorgang500ResponseAnyOf1
     */
    'data': GetVorgang500ResponseAnyOf1Data;
}

export const GetVorgang500ResponseAnyOf1ErrorCodeEnum = {
    OpmCockpitBackendInternalErrorPersistenceError: 'OPM_COCKPIT_BACKEND-INTERNAL_ERROR-PERSISTENCE_ERROR'
} as const;

export type GetVorgang500ResponseAnyOf1ErrorCodeEnum = typeof GetVorgang500ResponseAnyOf1ErrorCodeEnum[keyof typeof GetVorgang500ResponseAnyOf1ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf1Data
 */
export interface GetVorgang500ResponseAnyOf1Data {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf1Data
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf1DataAnyOf
 */
export interface GetVorgang500ResponseAnyOf1DataAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf1DataAnyOf
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf2
 */
export interface GetVorgang500ResponseAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf2
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf2
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang500ResponseAnyOf2
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf2
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf2
     */
    'errorCode': GetVorgang500ResponseAnyOf2ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf2
     */
    'title': string;
    /**
     * 
     * @type {any}
     * @memberof GetVorgang500ResponseAnyOf2
     */
    'data': any | null;
}

export const GetVorgang500ResponseAnyOf2ErrorCodeEnum = {
    OpmCockpitBackendInternalErrorUnknown: 'OPM_COCKPIT_BACKEND-INTERNAL_ERROR-UNKNOWN'
} as const;

export type GetVorgang500ResponseAnyOf2ErrorCodeEnum = typeof GetVorgang500ResponseAnyOf2ErrorCodeEnum[keyof typeof GetVorgang500ResponseAnyOf2ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf3
 */
export interface GetVorgang500ResponseAnyOf3 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf3
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf3
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang500ResponseAnyOf3
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf3
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf3
     */
    'errorCode': GetVorgang500ResponseAnyOf3ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf3
     */
    'title': string;
    /**
     * 
     * @type {GetVorgang500ResponseAnyOf3Data}
     * @memberof GetVorgang500ResponseAnyOf3
     */
    'data': GetVorgang500ResponseAnyOf3Data;
}

export const GetVorgang500ResponseAnyOf3ErrorCodeEnum = {
    OpmCockpitBackendClientErrorSqsError: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-SQS_ERROR'
} as const;

export type GetVorgang500ResponseAnyOf3ErrorCodeEnum = typeof GetVorgang500ResponseAnyOf3ErrorCodeEnum[keyof typeof GetVorgang500ResponseAnyOf3ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf3Data
 */
export interface GetVorgang500ResponseAnyOf3Data {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf3Data
     */
    'vorgangId': string;
}
/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf4
 */
export interface GetVorgang500ResponseAnyOf4 {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf4
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf4
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetVorgang500ResponseAnyOf4
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf4
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf4
     */
    'errorCode': GetVorgang500ResponseAnyOf4ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf4
     */
    'title': string;
    /**
     * 
     * @type {GetVorgang500ResponseAnyOf4Data}
     * @memberof GetVorgang500ResponseAnyOf4
     */
    'data': GetVorgang500ResponseAnyOf4Data;
}

export const GetVorgang500ResponseAnyOf4ErrorCodeEnum = {
    OpmCockpitBackendClientErrorDurableFunctionError: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-DURABLE_FUNCTION_ERROR'
} as const;

export type GetVorgang500ResponseAnyOf4ErrorCodeEnum = typeof GetVorgang500ResponseAnyOf4ErrorCodeEnum[keyof typeof GetVorgang500ResponseAnyOf4ErrorCodeEnum];

/**
 * 
 * @export
 * @interface GetVorgang500ResponseAnyOf4Data
 */
export interface GetVorgang500ResponseAnyOf4Data {
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf4Data
     */
    'activationRequestId': string;
    /**
     * 
     * @type {string}
     * @memberof GetVorgang500ResponseAnyOf4Data
     */
    'externalId': string;
}
/**
 * 
 * @export
 * @interface GetVorgangKommentare200ResponseInner
 */
export interface GetVorgangKommentare200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetVorgangKommentare200ResponseInner
     */
    'benutzer': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgangKommentare200ResponseInner
     */
    'datum': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgangKommentare200ResponseInner
     */
    'kommentar': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetVorgangKommentare200ResponseInner
     */
    'action': string | null;
}
/**
 * 
 * @export
 * @interface LockEvent409Response
 */
export interface LockEvent409Response {
    /**
     * 
     * @type {string}
     * @memberof LockEvent409Response
     */
    'instance'?: string;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409Response
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof LockEvent409Response
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409Response
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409Response
     */
    'errorCode': LockEvent409ResponseErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409Response
     */
    'title': string;
    /**
     * 
     * @type {GetVorgang500ResponseAnyOf3Data}
     * @memberof LockEvent409Response
     */
    'data': GetVorgang500ResponseAnyOf3Data;
}

export const LockEvent409ResponseErrorCodeEnum = {
    OpmCockpitBackendClientErrorVorgangNotRetryable: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VORGANG_NOT_RETRYABLE'
} as const;

export type LockEvent409ResponseErrorCodeEnum = typeof LockEvent409ResponseErrorCodeEnum[keyof typeof LockEvent409ResponseErrorCodeEnum];

/**
 * 
 * @export
 * @interface LockEvent409ResponseAnyOf
 */
export interface LockEvent409ResponseAnyOf {
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof LockEvent409ResponseAnyOf
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf
     */
    'errorCode': LockEvent409ResponseAnyOfErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf
     */
    'title': string | null;
    /**
     * 
     * @type {LockEvent409ResponseAnyOfData}
     * @memberof LockEvent409ResponseAnyOf
     */
    'data': LockEvent409ResponseAnyOfData;
}

export const LockEvent409ResponseAnyOfErrorCodeEnum = {
    OpmCockpitBackendClientErrorVorgangAlreadyLocked: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VORGANG_ALREADY_LOCKED'
} as const;

export type LockEvent409ResponseAnyOfErrorCodeEnum = typeof LockEvent409ResponseAnyOfErrorCodeEnum[keyof typeof LockEvent409ResponseAnyOfErrorCodeEnum];

/**
 * 
 * @export
 * @interface LockEvent409ResponseAnyOf1
 */
export interface LockEvent409ResponseAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf1
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf1
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof LockEvent409ResponseAnyOf1
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf1
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf1
     */
    'errorCode': LockEvent409ResponseAnyOf1ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf1
     */
    'title': string | null;
    /**
     * 
     * @type {GetVorgang500ResponseAnyOf3Data}
     * @memberof LockEvent409ResponseAnyOf1
     */
    'data': GetVorgang500ResponseAnyOf3Data;
}

export const LockEvent409ResponseAnyOf1ErrorCodeEnum = {
    OpmCockpitBackendClientErrorVorgangNotLocked: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VORGANG_NOT_LOCKED'
} as const;

export type LockEvent409ResponseAnyOf1ErrorCodeEnum = typeof LockEvent409ResponseAnyOf1ErrorCodeEnum[keyof typeof LockEvent409ResponseAnyOf1ErrorCodeEnum];

/**
 * 
 * @export
 * @interface LockEvent409ResponseAnyOf2
 */
export interface LockEvent409ResponseAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf2
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf2
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof LockEvent409ResponseAnyOf2
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf2
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf2
     */
    'errorCode': LockEvent409ResponseAnyOf2ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf2
     */
    'title': string | null;
    /**
     * 
     * @type {GetVorgang500ResponseAnyOf3Data}
     * @memberof LockEvent409ResponseAnyOf2
     */
    'data': GetVorgang500ResponseAnyOf3Data;
}

export const LockEvent409ResponseAnyOf2ErrorCodeEnum = {
    OpmCockpitBackendClientErrorArchivierungAbgleichErforderlich: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-ARCHIVIERUNG_ABGLEICH_ERFORDERLICH'
} as const;

export type LockEvent409ResponseAnyOf2ErrorCodeEnum = typeof LockEvent409ResponseAnyOf2ErrorCodeEnum[keyof typeof LockEvent409ResponseAnyOf2ErrorCodeEnum];

/**
 * 
 * @export
 * @interface LockEvent409ResponseAnyOf3
 */
export interface LockEvent409ResponseAnyOf3 {
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf3
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf3
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof LockEvent409ResponseAnyOf3
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf3
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf3
     */
    'errorCode': LockEvent409ResponseAnyOf3ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf3
     */
    'title': string | null;
    /**
     * 
     * @type {LockEvent409ResponseAnyOf3Data}
     * @memberof LockEvent409ResponseAnyOf3
     */
    'data': LockEvent409ResponseAnyOf3Data;
}

export const LockEvent409ResponseAnyOf3ErrorCodeEnum = {
    OpmCockpitBackendClientErrorEmailVersandBereitsBegonnen: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-EMAIL_VERSAND_BEREITS_BEGONNEN'
} as const;

export type LockEvent409ResponseAnyOf3ErrorCodeEnum = typeof LockEvent409ResponseAnyOf3ErrorCodeEnum[keyof typeof LockEvent409ResponseAnyOf3ErrorCodeEnum];

/**
 * 
 * @export
 * @interface LockEvent409ResponseAnyOf3Data
 */
export interface LockEvent409ResponseAnyOf3Data {
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf3Data
     */
    'vorgangId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LockEvent409ResponseAnyOf3Data
     */
    'versandBestaetigt': boolean | null;
}
/**
 * 
 * @export
 * @interface LockEvent409ResponseAnyOf4
 */
export interface LockEvent409ResponseAnyOf4 {
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf4
     */
    'instance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf4
     */
    'type': string | null;
    /**
     * 
     * @type {number}
     * @memberof LockEvent409ResponseAnyOf4
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf4
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf4
     */
    'errorCode': LockEvent409ResponseAnyOf4ErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOf4
     */
    'title': string | null;
    /**
     * 
     * @type {GetVorgang500ResponseAnyOf3Data}
     * @memberof LockEvent409ResponseAnyOf4
     */
    'data': GetVorgang500ResponseAnyOf3Data;
}

export const LockEvent409ResponseAnyOf4ErrorCodeEnum = {
    OpmCockpitBackendClientErrorVorgangNotRetryable: 'OPM_COCKPIT_BACKEND-CLIENT_ERROR-VORGANG_NOT_RETRYABLE'
} as const;

export type LockEvent409ResponseAnyOf4ErrorCodeEnum = typeof LockEvent409ResponseAnyOf4ErrorCodeEnum[keyof typeof LockEvent409ResponseAnyOf4ErrorCodeEnum];

/**
 * 
 * @export
 * @interface LockEvent409ResponseAnyOfData
 */
export interface LockEvent409ResponseAnyOfData {
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOfData
     */
    'lockedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof LockEvent409ResponseAnyOfData
     */
    'vorgangId': string | null;
}
/**
 * 
 * @export
 * @interface LockEventRequest
 */
export interface LockEventRequest {
    /**
     * 
     * @type {string}
     * @memberof LockEventRequest
     */
    'user': string | null;
}
/**
 * 
 * @export
 * @interface RetryEventRequest
 */
export interface RetryEventRequest {
    /**
     * 
     * @type {string}
     * @memberof RetryEventRequest
     */
    'eventData': string | null;
    /**
     * 
     * @type {string}
     * @memberof RetryEventRequest
     */
    'errorType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RetryEventRequest
     */
    'initiator': string | null;
    /**
     * 
     * @type {string}
     * @memberof RetryEventRequest
     */
    'startSchritt'?: RetryEventRequestStartSchrittEnum;
}

export const RetryEventRequestStartSchrittEnum = {
    Transformation: 'TRANSFORMATION',
    FachlicheValidierung: 'FACHLICHE_VALIDIERUNG',
    WeiterleitungAnDokumentdienstleister: 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER',
    AntwortVonDokumentdienstleister: 'ANTWORT_VON_DOKUMENTDIENSTLEISTER',
    Archivierung: 'ARCHIVIERUNG',
    EmailVersand: 'EMAIL_VERSAND',
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER',
    WarteAufReaktivierungDesDokumenttyps: 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'
} as const;

export type RetryEventRequestStartSchrittEnum = typeof RetryEventRequestStartSchrittEnum[keyof typeof RetryEventRequestStartSchrittEnum];

/**
 * 
 * @export
 * @interface SaveEventRequest
 */
export interface SaveEventRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveEventRequest
     */
    'eventData': string;
    /**
     * 
     * @type {string}
     * @memberof SaveEventRequest
     */
    'errorType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveEventRequest
     */
    'initiator': string;
    /**
     * 
     * @type {string}
     * @memberof SaveEventRequest
     */
    'startSchritt'?: SaveEventRequestStartSchrittEnum;
}

export const SaveEventRequestStartSchrittEnum = {
    Transformation: 'TRANSFORMATION',
    FachlicheValidierung: 'FACHLICHE_VALIDIERUNG',
    WeiterleitungAnDokumentdienstleister: 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER',
    AntwortVonDokumentdienstleister: 'ANTWORT_VON_DOKUMENTDIENSTLEISTER',
    Archivierung: 'ARCHIVIERUNG',
    EmailVersand: 'EMAIL_VERSAND',
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER',
    WarteAufReaktivierungDesDokumenttyps: 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'
} as const;

export type SaveEventRequestStartSchrittEnum = typeof SaveEventRequestStartSchrittEnum[keyof typeof SaveEventRequestStartSchrittEnum];

/**
 * 
 * @export
 * @interface StelleVorgangZurueckRequest
 */
export interface StelleVorgangZurueckRequest {
    /**
     * 
     * @type {string}
     * @memberof StelleVorgangZurueckRequest
     */
    'kommentar': string;
}

/**
 * DokumenteApi - axios parameter creator
 * @export
 */
export const DokumenteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Erzeugt eine Vorschau für ein Dokument über den Streamserve-REST-Adapter.
         * @summary Erstellt eine Dokumentenvorschau über Streamserve
         * @param {ErstelleDokumentVorschauRequest} erstelleDokumentVorschauRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erstelleDokumentVorschau: async (erstelleDokumentVorschauRequest: ErstelleDokumentVorschauRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'erstelleDokumentVorschauRequest' is not null or undefined
            assertParamExists('erstelleDokumentVorschau', 'erstelleDokumentVorschauRequest', erstelleDokumentVorschauRequest)
            const localVarPath = `/dokumente/vorschau`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(erstelleDokumentVorschauRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DokumenteApi - functional programming interface
 * @export
 */
export const DokumenteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DokumenteApiAxiosParamCreator(configuration)
    return {
        /**
         * Erzeugt eine Vorschau für ein Dokument über den Streamserve-REST-Adapter.
         * @summary Erstellt eine Dokumentenvorschau über Streamserve
         * @param {ErstelleDokumentVorschauRequest} erstelleDokumentVorschauRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async erstelleDokumentVorschau(erstelleDokumentVorschauRequest: ErstelleDokumentVorschauRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErstelleDokumentVorschau200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.erstelleDokumentVorschau(erstelleDokumentVorschauRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DokumenteApi.erstelleDokumentVorschau']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DokumenteApi - factory interface
 * @export
 */
export const DokumenteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DokumenteApiFp(configuration)
    return {
        /**
         * Erzeugt eine Vorschau für ein Dokument über den Streamserve-REST-Adapter.
         * @summary Erstellt eine Dokumentenvorschau über Streamserve
         * @param {DokumenteApiErstelleDokumentVorschauRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erstelleDokumentVorschau(requestParameters: DokumenteApiErstelleDokumentVorschauRequest, options?: RawAxiosRequestConfig): AxiosPromise<ErstelleDokumentVorschau200Response> {
            return localVarFp.erstelleDokumentVorschau(requestParameters.erstelleDokumentVorschauRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for erstelleDokumentVorschau operation in DokumenteApi.
 * @export
 * @interface DokumenteApiErstelleDokumentVorschauRequest
 */
export interface DokumenteApiErstelleDokumentVorschauRequest {
    /**
     * 
     * @type {ErstelleDokumentVorschauRequest}
     * @memberof DokumenteApiErstelleDokumentVorschau
     */
    readonly erstelleDokumentVorschauRequest: ErstelleDokumentVorschauRequest
}

/**
 * DokumenteApi - object-oriented interface
 * @export
 * @class DokumenteApi
 * @extends {BaseAPI}
 */
export class DokumenteApi extends BaseAPI {
    /**
     * Erzeugt eine Vorschau für ein Dokument über den Streamserve-REST-Adapter.
     * @summary Erstellt eine Dokumentenvorschau über Streamserve
     * @param {DokumenteApiErstelleDokumentVorschauRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DokumenteApi
     */
    public erstelleDokumentVorschau(requestParameters: DokumenteApiErstelleDokumentVorschauRequest, options?: RawAxiosRequestConfig) {
        return DokumenteApiFp(this.configuration).erstelleDokumentVorschau(requestParameters.erstelleDokumentVorschauRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventDokumentTypMappingsApi - axios parameter creator
 * @export
 */
export const EventDokumentTypMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Idempotant Update of Activation for the Dokumenttyp
         * @summary Saves the Activation of the Event DokumentTyp Mapping by External Id
         * @param {boolean | null} aktiviert 
         * @param {string} user 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOrDisableEventDokumentTypMappingByExternalId: async (aktiviert: boolean | null, user: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aktiviert' is not null or undefined
            assertParamExists('activateOrDisableEventDokumentTypMappingByExternalId', 'aktiviert', aktiviert)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('activateOrDisableEventDokumentTypMappingByExternalId', 'user', user)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('activateOrDisableEventDokumentTypMappingByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}/activation`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aktiviert !== undefined) {
                localVarQueryParameter['aktiviert'] = aktiviert;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the created Event DokumentTyp Mapping
         * @summary Creates Event DokumentTyp Mapping
         * @param {string} user 
         * @param {CreateEventDokumentTypMappingRequest} createEventDokumentTypMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventDokumentTypMapping: async (user: string, createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('createEventDokumentTypMapping', 'user', user)
            // verify required parameter 'createEventDokumentTypMappingRequest' is not null or undefined
            assertParamExists('createEventDokumentTypMapping', 'createEventDokumentTypMappingRequest', createEventDokumentTypMappingRequest)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventDokumentTypMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the Event DokumentTyp Mapping that matches the externalId
         * @summary Deletes Event DokumentTyp Mapping
         * @param {string} externalId 
         * @param {string} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventDokumentTypMapping: async (externalId: string, user: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('deleteEventDokumentTypMapping', 'externalId', externalId)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('deleteEventDokumentTypMapping', 'user', user)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get global transformation Debug settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatentransformationDebugSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/debug/datentransformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mapping by External Id
         * @param {string | null} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappingByExternalId: async (externalId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('getEventDokumentTypMappingByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific Event DokumentTyp Mapping Protocol
         * @summary Get the DokumentTyp Mapping Protocol by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappingProtocolByExternalId: async (externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('getEventDokumentTypMappingProtocolByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}/protokolle`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an array of Event DokumentTyp Mappings that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mappings
         * @param {boolean | null} [aktiviert] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappings: async (aktiviert?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/eventdokumenttypmappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aktiviert !== undefined) {
                localVarQueryParameter['aktiviert'] = aktiviert;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restores the deleted Event Dokumenttyp Mapping by ExternalId and activates the Dokumenttyp Mapping
         * @summary Restores a deleted Event Dokumenttyp Mapping by ExternalId
         * @param {string} user 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreEventDokumentTypMappingByExternalId: async (user: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('restoreEventDokumentTypMappingByExternalId', 'user', user)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('restoreEventDokumentTypMappingByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}/restore`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies to all current and future powercloud document types on Dev and Stage.
         * @summary Update global transformation Debug settings
         * @param {string} user 
         * @param {GetDatentransformationDebugSettings200Response} getDatentransformationDebugSettings200Response 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatentransformationDebugSettings: async (user: string, getDatentransformationDebugSettings200Response: GetDatentransformationDebugSettings200Response, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('updateDatentransformationDebugSettings', 'user', user)
            // verify required parameter 'getDatentransformationDebugSettings200Response' is not null or undefined
            assertParamExists('updateDatentransformationDebugSettings', 'getDatentransformationDebugSettings200Response', getDatentransformationDebugSettings200Response)
            const localVarPath = `/konfigurationen/debug/datentransformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDatentransformationDebugSettings200Response, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Updates Event DokumentTyp Mapping by External Id
         * @param {string} externalId 
         * @param {string} user 
         * @param {CreateEventDokumentTypMappingRequest} createEventDokumentTypMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventDokumentTypMappingByExternalId: async (externalId: string, user: string, createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('updateEventDokumentTypMappingByExternalId', 'externalId', externalId)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('updateEventDokumentTypMappingByExternalId', 'user', user)
            // verify required parameter 'createEventDokumentTypMappingRequest' is not null or undefined
            assertParamExists('updateEventDokumentTypMappingByExternalId', 'createEventDokumentTypMappingRequest', createEventDokumentTypMappingRequest)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventDokumentTypMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventDokumentTypMappingsApi - functional programming interface
 * @export
 */
export const EventDokumentTypMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventDokumentTypMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Idempotant Update of Activation for the Dokumenttyp
         * @summary Saves the Activation of the Event DokumentTyp Mapping by External Id
         * @param {boolean | null} aktiviert 
         * @param {string} user 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateOrDisableEventDokumentTypMappingByExternalId(aktiviert: boolean | null, user: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivateOrDisableEventDokumentTypMappingByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateOrDisableEventDokumentTypMappingByExternalId(aktiviert, user, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.activateOrDisableEventDokumentTypMappingByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the created Event DokumentTyp Mapping
         * @summary Creates Event DokumentTyp Mapping
         * @param {string} user 
         * @param {CreateEventDokumentTypMappingRequest} createEventDokumentTypMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventDokumentTypMapping(user: string, createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventDokumentTypMapping(user, createEventDokumentTypMappingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.createEventDokumentTypMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the Event DokumentTyp Mapping that matches the externalId
         * @summary Deletes Event DokumentTyp Mapping
         * @param {string} externalId 
         * @param {string} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventDokumentTypMapping(externalId: string, user: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteEventDokumentTypMapping200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventDokumentTypMapping(externalId, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.deleteEventDokumentTypMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get global transformation Debug settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatentransformationDebugSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatentransformationDebugSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatentransformationDebugSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.getDatentransformationDebugSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mapping by External Id
         * @param {string | null} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventDokumentTypMappingByExternalId(externalId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventDokumentTypMappingByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventDokumentTypMappingByExternalId(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.getEventDokumentTypMappingByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific Event DokumentTyp Mapping Protocol
         * @summary Get the DokumentTyp Mapping Protocol by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventDokumentTypMappingProtocolByExternalId(externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEventDokumentTypMappingProtocolByExternalId200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventDokumentTypMappingProtocolByExternalId(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.getEventDokumentTypMappingProtocolByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an array of Event DokumentTyp Mappings that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mappings
         * @param {boolean | null} [aktiviert] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventDokumentTypMappings(aktiviert?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventDokumentTypMappings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventDokumentTypMappings(aktiviert, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.getEventDokumentTypMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restores the deleted Event Dokumenttyp Mapping by ExternalId and activates the Dokumenttyp Mapping
         * @summary Restores a deleted Event Dokumenttyp Mapping by ExternalId
         * @param {string} user 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreEventDokumentTypMappingByExternalId(user: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventDokumentTypMappingByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreEventDokumentTypMappingByExternalId(user, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.restoreEventDokumentTypMappingByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies to all current and future powercloud document types on Dev and Stage.
         * @summary Update global transformation Debug settings
         * @param {string} user 
         * @param {GetDatentransformationDebugSettings200Response} getDatentransformationDebugSettings200Response 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatentransformationDebugSettings(user: string, getDatentransformationDebugSettings200Response: GetDatentransformationDebugSettings200Response, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatentransformationDebugSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatentransformationDebugSettings(user, getDatentransformationDebugSettings200Response, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.updateDatentransformationDebugSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Updates Event DokumentTyp Mapping by External Id
         * @param {string} externalId 
         * @param {string} user 
         * @param {CreateEventDokumentTypMappingRequest} createEventDokumentTypMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventDokumentTypMappingByExternalId(externalId: string, user: string, createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventDokumentTypMappingByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventDokumentTypMappingByExternalId(externalId, user, createEventDokumentTypMappingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventDokumentTypMappingsApi.updateEventDokumentTypMappingByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventDokumentTypMappingsApi - factory interface
 * @export
 */
export const EventDokumentTypMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventDokumentTypMappingsApiFp(configuration)
    return {
        /**
         * Idempotant Update of Activation for the Dokumenttyp
         * @summary Saves the Activation of the Event DokumentTyp Mapping by External Id
         * @param {EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOrDisableEventDokumentTypMappingByExternalId(requestParameters: EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActivateOrDisableEventDokumentTypMappingByExternalId200Response> {
            return localVarFp.activateOrDisableEventDokumentTypMappingByExternalId(requestParameters.aktiviert, requestParameters.user, requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the created Event DokumentTyp Mapping
         * @summary Creates Event DokumentTyp Mapping
         * @param {EventDokumentTypMappingsApiCreateEventDokumentTypMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventDokumentTypMapping(requestParameters: EventDokumentTypMappingsApiCreateEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createEventDokumentTypMapping(requestParameters.user, requestParameters.createEventDokumentTypMappingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the Event DokumentTyp Mapping that matches the externalId
         * @summary Deletes Event DokumentTyp Mapping
         * @param {EventDokumentTypMappingsApiDeleteEventDokumentTypMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventDokumentTypMapping(requestParameters: EventDokumentTypMappingsApiDeleteEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteEventDokumentTypMapping200Response> {
            return localVarFp.deleteEventDokumentTypMapping(requestParameters.externalId, requestParameters.user, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get global transformation Debug settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatentransformationDebugSettings(options?: RawAxiosRequestConfig): AxiosPromise<GetDatentransformationDebugSettings200Response> {
            return localVarFp.getDatentransformationDebugSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mapping by External Id
         * @param {EventDokumentTypMappingsApiGetEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappingByExternalId(requestParameters: EventDokumentTypMappingsApiGetEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEventDokumentTypMappingByExternalId200Response> {
            return localVarFp.getEventDokumentTypMappingByExternalId(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific Event DokumentTyp Mapping Protocol
         * @summary Get the DokumentTyp Mapping Protocol by External Id
         * @param {EventDokumentTypMappingsApiGetEventDokumentTypMappingProtocolByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappingProtocolByExternalId(requestParameters: EventDokumentTypMappingsApiGetEventDokumentTypMappingProtocolByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetEventDokumentTypMappingProtocolByExternalId200ResponseInner>> {
            return localVarFp.getEventDokumentTypMappingProtocolByExternalId(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an array of Event DokumentTyp Mappings that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mappings
         * @param {EventDokumentTypMappingsApiGetEventDokumentTypMappingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappings(requestParameters: EventDokumentTypMappingsApiGetEventDokumentTypMappingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetEventDokumentTypMappings200Response> {
            return localVarFp.getEventDokumentTypMappings(requestParameters.aktiviert, options).then((request) => request(axios, basePath));
        },
        /**
         * Restores the deleted Event Dokumenttyp Mapping by ExternalId and activates the Dokumenttyp Mapping
         * @summary Restores a deleted Event Dokumenttyp Mapping by ExternalId
         * @param {EventDokumentTypMappingsApiRestoreEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreEventDokumentTypMappingByExternalId(requestParameters: EventDokumentTypMappingsApiRestoreEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEventDokumentTypMappingByExternalId200Response> {
            return localVarFp.restoreEventDokumentTypMappingByExternalId(requestParameters.user, requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies to all current and future powercloud document types on Dev and Stage.
         * @summary Update global transformation Debug settings
         * @param {EventDokumentTypMappingsApiUpdateDatentransformationDebugSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatentransformationDebugSettings(requestParameters: EventDokumentTypMappingsApiUpdateDatentransformationDebugSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDatentransformationDebugSettings200Response> {
            return localVarFp.updateDatentransformationDebugSettings(requestParameters.user, requestParameters.getDatentransformationDebugSettings200Response, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Updates Event DokumentTyp Mapping by External Id
         * @param {EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventDokumentTypMappingByExternalId(requestParameters: EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEventDokumentTypMappingByExternalId200Response> {
            return localVarFp.updateEventDokumentTypMappingByExternalId(requestParameters.externalId, requestParameters.user, requestParameters.createEventDokumentTypMappingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateOrDisableEventDokumentTypMappingByExternalId operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest
 */
export interface EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest {
    /**
     * 
     * @type {boolean}
     * @memberof EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalId
     */
    readonly aktiviert: boolean | null

    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalId
     */
    readonly user: string

    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for createEventDokumentTypMapping operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiCreateEventDokumentTypMappingRequest
 */
export interface EventDokumentTypMappingsApiCreateEventDokumentTypMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiCreateEventDokumentTypMapping
     */
    readonly user: string

    /**
     * 
     * @type {CreateEventDokumentTypMappingRequest}
     * @memberof EventDokumentTypMappingsApiCreateEventDokumentTypMapping
     */
    readonly createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest
}

/**
 * Request parameters for deleteEventDokumentTypMapping operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiDeleteEventDokumentTypMappingRequest
 */
export interface EventDokumentTypMappingsApiDeleteEventDokumentTypMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiDeleteEventDokumentTypMapping
     */
    readonly externalId: string

    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiDeleteEventDokumentTypMapping
     */
    readonly user: string
}

/**
 * Request parameters for getEventDokumentTypMappingByExternalId operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiGetEventDokumentTypMappingByExternalIdRequest
 */
export interface EventDokumentTypMappingsApiGetEventDokumentTypMappingByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiGetEventDokumentTypMappingByExternalId
     */
    readonly externalId: string | null
}

/**
 * Request parameters for getEventDokumentTypMappingProtocolByExternalId operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiGetEventDokumentTypMappingProtocolByExternalIdRequest
 */
export interface EventDokumentTypMappingsApiGetEventDokumentTypMappingProtocolByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiGetEventDokumentTypMappingProtocolByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for getEventDokumentTypMappings operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiGetEventDokumentTypMappingsRequest
 */
export interface EventDokumentTypMappingsApiGetEventDokumentTypMappingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof EventDokumentTypMappingsApiGetEventDokumentTypMappings
     */
    readonly aktiviert?: boolean | null
}

/**
 * Request parameters for restoreEventDokumentTypMappingByExternalId operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiRestoreEventDokumentTypMappingByExternalIdRequest
 */
export interface EventDokumentTypMappingsApiRestoreEventDokumentTypMappingByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiRestoreEventDokumentTypMappingByExternalId
     */
    readonly user: string

    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiRestoreEventDokumentTypMappingByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for updateDatentransformationDebugSettings operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiUpdateDatentransformationDebugSettingsRequest
 */
export interface EventDokumentTypMappingsApiUpdateDatentransformationDebugSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiUpdateDatentransformationDebugSettings
     */
    readonly user: string

    /**
     * 
     * @type {GetDatentransformationDebugSettings200Response}
     * @memberof EventDokumentTypMappingsApiUpdateDatentransformationDebugSettings
     */
    readonly getDatentransformationDebugSettings200Response: GetDatentransformationDebugSettings200Response
}

/**
 * Request parameters for updateEventDokumentTypMappingByExternalId operation in EventDokumentTypMappingsApi.
 * @export
 * @interface EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalIdRequest
 */
export interface EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalId
     */
    readonly externalId: string

    /**
     * 
     * @type {string}
     * @memberof EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalId
     */
    readonly user: string

    /**
     * 
     * @type {CreateEventDokumentTypMappingRequest}
     * @memberof EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalId
     */
    readonly createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest
}

/**
 * EventDokumentTypMappingsApi - object-oriented interface
 * @export
 * @class EventDokumentTypMappingsApi
 * @extends {BaseAPI}
 */
export class EventDokumentTypMappingsApi extends BaseAPI {
    /**
     * Idempotant Update of Activation for the Dokumenttyp
     * @summary Saves the Activation of the Event DokumentTyp Mapping by External Id
     * @param {EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public activateOrDisableEventDokumentTypMappingByExternalId(requestParameters: EventDokumentTypMappingsApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).activateOrDisableEventDokumentTypMappingByExternalId(requestParameters.aktiviert, requestParameters.user, requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the created Event DokumentTyp Mapping
     * @summary Creates Event DokumentTyp Mapping
     * @param {EventDokumentTypMappingsApiCreateEventDokumentTypMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public createEventDokumentTypMapping(requestParameters: EventDokumentTypMappingsApiCreateEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).createEventDokumentTypMapping(requestParameters.user, requestParameters.createEventDokumentTypMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the Event DokumentTyp Mapping that matches the externalId
     * @summary Deletes Event DokumentTyp Mapping
     * @param {EventDokumentTypMappingsApiDeleteEventDokumentTypMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public deleteEventDokumentTypMapping(requestParameters: EventDokumentTypMappingsApiDeleteEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).deleteEventDokumentTypMapping(requestParameters.externalId, requestParameters.user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get global transformation Debug settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public getDatentransformationDebugSettings(options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).getDatentransformationDebugSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
     * @summary Get Event DokumentTyp Mapping by External Id
     * @param {EventDokumentTypMappingsApiGetEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public getEventDokumentTypMappingByExternalId(requestParameters: EventDokumentTypMappingsApiGetEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).getEventDokumentTypMappingByExternalId(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific Event DokumentTyp Mapping Protocol
     * @summary Get the DokumentTyp Mapping Protocol by External Id
     * @param {EventDokumentTypMappingsApiGetEventDokumentTypMappingProtocolByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public getEventDokumentTypMappingProtocolByExternalId(requestParameters: EventDokumentTypMappingsApiGetEventDokumentTypMappingProtocolByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).getEventDokumentTypMappingProtocolByExternalId(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an array of Event DokumentTyp Mappings that are configured in the Configuration Section of OPM
     * @summary Get Event DokumentTyp Mappings
     * @param {EventDokumentTypMappingsApiGetEventDokumentTypMappingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public getEventDokumentTypMappings(requestParameters: EventDokumentTypMappingsApiGetEventDokumentTypMappingsRequest = {}, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).getEventDokumentTypMappings(requestParameters.aktiviert, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restores the deleted Event Dokumenttyp Mapping by ExternalId and activates the Dokumenttyp Mapping
     * @summary Restores a deleted Event Dokumenttyp Mapping by ExternalId
     * @param {EventDokumentTypMappingsApiRestoreEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public restoreEventDokumentTypMappingByExternalId(requestParameters: EventDokumentTypMappingsApiRestoreEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).restoreEventDokumentTypMappingByExternalId(requestParameters.user, requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies to all current and future powercloud document types on Dev and Stage.
     * @summary Update global transformation Debug settings
     * @param {EventDokumentTypMappingsApiUpdateDatentransformationDebugSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public updateDatentransformationDebugSettings(requestParameters: EventDokumentTypMappingsApiUpdateDatentransformationDebugSettingsRequest, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).updateDatentransformationDebugSettings(requestParameters.user, requestParameters.getDatentransformationDebugSettings200Response, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
     * @summary Updates Event DokumentTyp Mapping by External Id
     * @param {EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventDokumentTypMappingsApi
     */
    public updateEventDokumentTypMappingByExternalId(requestParameters: EventDokumentTypMappingsApiUpdateEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return EventDokumentTypMappingsApiFp(this.configuration).updateEventDokumentTypMappingByExternalId(requestParameters.externalId, requestParameters.user, requestParameters.createEventDokumentTypMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KonfigurationenApi - axios parameter creator
 * @export
 */
export const KonfigurationenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Idempotant Update of Activation for the Dokumenttyp
         * @summary Saves the Activation of the Event DokumentTyp Mapping by External Id
         * @param {boolean | null} aktiviert 
         * @param {string} user 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOrDisableEventDokumentTypMappingByExternalId: async (aktiviert: boolean | null, user: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aktiviert' is not null or undefined
            assertParamExists('activateOrDisableEventDokumentTypMappingByExternalId', 'aktiviert', aktiviert)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('activateOrDisableEventDokumentTypMappingByExternalId', 'user', user)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('activateOrDisableEventDokumentTypMappingByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}/activation`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aktiviert !== undefined) {
                localVarQueryParameter['aktiviert'] = aktiviert;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the created Event DokumentTyp Mapping
         * @summary Creates Event DokumentTyp Mapping
         * @param {string} user 
         * @param {CreateEventDokumentTypMappingRequest} createEventDokumentTypMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventDokumentTypMapping: async (user: string, createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('createEventDokumentTypMapping', 'user', user)
            // verify required parameter 'createEventDokumentTypMappingRequest' is not null or undefined
            assertParamExists('createEventDokumentTypMapping', 'createEventDokumentTypMappingRequest', createEventDokumentTypMappingRequest)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventDokumentTypMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a StreamServe-Projekt
         * @param {CreateStreamServeProjektRequest} createStreamServeProjektRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStreamServeProjekt: async (createStreamServeProjektRequest: CreateStreamServeProjektRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStreamServeProjektRequest' is not null or undefined
            assertParamExists('createStreamServeProjekt', 'createStreamServeProjektRequest', createStreamServeProjektRequest)
            const localVarPath = `/konfigurationen/streamserveprojekte`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStreamServeProjektRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the Event DokumentTyp Mapping that matches the externalId
         * @summary Deletes Event DokumentTyp Mapping
         * @param {string} externalId 
         * @param {string} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventDokumentTypMapping: async (externalId: string, user: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('deleteEventDokumentTypMapping', 'externalId', externalId)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('deleteEventDokumentTypMapping', 'user', user)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStreamServeProjektByExternalId: async (externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('deleteStreamServeProjektByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/streamserveprojekte/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get global transformation Debug settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatentransformationDebugSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/debug/datentransformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mapping by External Id
         * @param {string | null} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappingByExternalId: async (externalId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('getEventDokumentTypMappingByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific Event DokumentTyp Mapping Protocol
         * @summary Get the DokumentTyp Mapping Protocol by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappingProtocolByExternalId: async (externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('getEventDokumentTypMappingProtocolByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}/protokolle`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an array of Event DokumentTyp Mappings that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mappings
         * @param {boolean | null} [aktiviert] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappings: async (aktiviert?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/eventdokumenttypmappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (aktiviert !== undefined) {
                localVarQueryParameter['aktiviert'] = aktiviert;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamServeProjektByExternalId: async (externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('getStreamServeProjektByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/streamserveprojekte/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle StreamServe-Projekte, die im Konfigurations-Bereich gepflegt werden.
         * @summary Get StreamServe-Projekte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamServeProjekte: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/streamserveprojekte`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restores the deleted Event Dokumenttyp Mapping by ExternalId and activates the Dokumenttyp Mapping
         * @summary Restores a deleted Event Dokumenttyp Mapping by ExternalId
         * @param {string} user 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreEventDokumentTypMappingByExternalId: async (user: string, externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('restoreEventDokumentTypMappingByExternalId', 'user', user)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('restoreEventDokumentTypMappingByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}/restore`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies to all current and future powercloud document types on Dev and Stage.
         * @summary Update global transformation Debug settings
         * @param {string} user 
         * @param {GetDatentransformationDebugSettings200Response} getDatentransformationDebugSettings200Response 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatentransformationDebugSettings: async (user: string, getDatentransformationDebugSettings200Response: GetDatentransformationDebugSettings200Response, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('updateDatentransformationDebugSettings', 'user', user)
            // verify required parameter 'getDatentransformationDebugSettings200Response' is not null or undefined
            assertParamExists('updateDatentransformationDebugSettings', 'getDatentransformationDebugSettings200Response', getDatentransformationDebugSettings200Response)
            const localVarPath = `/konfigurationen/debug/datentransformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDatentransformationDebugSettings200Response, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Updates Event DokumentTyp Mapping by External Id
         * @param {string} externalId 
         * @param {string} user 
         * @param {CreateEventDokumentTypMappingRequest} createEventDokumentTypMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventDokumentTypMappingByExternalId: async (externalId: string, user: string, createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('updateEventDokumentTypMappingByExternalId', 'externalId', externalId)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('updateEventDokumentTypMappingByExternalId', 'user', user)
            // verify required parameter 'createEventDokumentTypMappingRequest' is not null or undefined
            assertParamExists('updateEventDokumentTypMappingByExternalId', 'createEventDokumentTypMappingRequest', createEventDokumentTypMappingRequest)
            const localVarPath = `/konfigurationen/eventdokumenttypmappings/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventDokumentTypMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {CreateStreamServeProjektRequest} createStreamServeProjektRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStreamServeProjektByExternalId: async (externalId: string, createStreamServeProjektRequest: CreateStreamServeProjektRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('updateStreamServeProjektByExternalId', 'externalId', externalId)
            // verify required parameter 'createStreamServeProjektRequest' is not null or undefined
            assertParamExists('updateStreamServeProjektByExternalId', 'createStreamServeProjektRequest', createStreamServeProjektRequest)
            const localVarPath = `/konfigurationen/streamserveprojekte/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStreamServeProjektRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KonfigurationenApi - functional programming interface
 * @export
 */
export const KonfigurationenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KonfigurationenApiAxiosParamCreator(configuration)
    return {
        /**
         * Idempotant Update of Activation for the Dokumenttyp
         * @summary Saves the Activation of the Event DokumentTyp Mapping by External Id
         * @param {boolean | null} aktiviert 
         * @param {string} user 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateOrDisableEventDokumentTypMappingByExternalId(aktiviert: boolean | null, user: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivateOrDisableEventDokumentTypMappingByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateOrDisableEventDokumentTypMappingByExternalId(aktiviert, user, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.activateOrDisableEventDokumentTypMappingByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the created Event DokumentTyp Mapping
         * @summary Creates Event DokumentTyp Mapping
         * @param {string} user 
         * @param {CreateEventDokumentTypMappingRequest} createEventDokumentTypMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventDokumentTypMapping(user: string, createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventDokumentTypMapping(user, createEventDokumentTypMappingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.createEventDokumentTypMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a StreamServe-Projekt
         * @param {CreateStreamServeProjektRequest} createStreamServeProjektRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStreamServeProjekt(createStreamServeProjektRequest: CreateStreamServeProjektRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStreamServeProjekt(createStreamServeProjektRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.createStreamServeProjekt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the Event DokumentTyp Mapping that matches the externalId
         * @summary Deletes Event DokumentTyp Mapping
         * @param {string} externalId 
         * @param {string} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventDokumentTypMapping(externalId: string, user: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteEventDokumentTypMapping200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventDokumentTypMapping(externalId, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.deleteEventDokumentTypMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStreamServeProjektByExternalId(externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStreamServeProjektByExternalId(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.deleteStreamServeProjektByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get global transformation Debug settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatentransformationDebugSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatentransformationDebugSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatentransformationDebugSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.getDatentransformationDebugSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mapping by External Id
         * @param {string | null} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventDokumentTypMappingByExternalId(externalId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventDokumentTypMappingByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventDokumentTypMappingByExternalId(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.getEventDokumentTypMappingByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific Event DokumentTyp Mapping Protocol
         * @summary Get the DokumentTyp Mapping Protocol by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventDokumentTypMappingProtocolByExternalId(externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetEventDokumentTypMappingProtocolByExternalId200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventDokumentTypMappingProtocolByExternalId(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.getEventDokumentTypMappingProtocolByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an array of Event DokumentTyp Mappings that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mappings
         * @param {boolean | null} [aktiviert] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventDokumentTypMappings(aktiviert?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventDokumentTypMappings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventDokumentTypMappings(aktiviert, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.getEventDokumentTypMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStreamServeProjektByExternalId(externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStreamServeProjektByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStreamServeProjektByExternalId(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.getStreamServeProjektByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Liefert alle StreamServe-Projekte, die im Konfigurations-Bereich gepflegt werden.
         * @summary Get StreamServe-Projekte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStreamServeProjekte(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStreamServeProjekte200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStreamServeProjekte(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.getStreamServeProjekte']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restores the deleted Event Dokumenttyp Mapping by ExternalId and activates the Dokumenttyp Mapping
         * @summary Restores a deleted Event Dokumenttyp Mapping by ExternalId
         * @param {string} user 
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreEventDokumentTypMappingByExternalId(user: string, externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventDokumentTypMappingByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreEventDokumentTypMappingByExternalId(user, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.restoreEventDokumentTypMappingByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies to all current and future powercloud document types on Dev and Stage.
         * @summary Update global transformation Debug settings
         * @param {string} user 
         * @param {GetDatentransformationDebugSettings200Response} getDatentransformationDebugSettings200Response 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatentransformationDebugSettings(user: string, getDatentransformationDebugSettings200Response: GetDatentransformationDebugSettings200Response, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDatentransformationDebugSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatentransformationDebugSettings(user, getDatentransformationDebugSettings200Response, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.updateDatentransformationDebugSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Updates Event DokumentTyp Mapping by External Id
         * @param {string} externalId 
         * @param {string} user 
         * @param {CreateEventDokumentTypMappingRequest} createEventDokumentTypMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventDokumentTypMappingByExternalId(externalId: string, user: string, createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEventDokumentTypMappingByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventDokumentTypMappingByExternalId(externalId, user, createEventDokumentTypMappingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.updateEventDokumentTypMappingByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {CreateStreamServeProjektRequest} createStreamServeProjektRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStreamServeProjektByExternalId(externalId: string, createStreamServeProjektRequest: CreateStreamServeProjektRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStreamServeProjektByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStreamServeProjektByExternalId(externalId, createStreamServeProjektRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KonfigurationenApi.updateStreamServeProjektByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KonfigurationenApi - factory interface
 * @export
 */
export const KonfigurationenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KonfigurationenApiFp(configuration)
    return {
        /**
         * Idempotant Update of Activation for the Dokumenttyp
         * @summary Saves the Activation of the Event DokumentTyp Mapping by External Id
         * @param {KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateOrDisableEventDokumentTypMappingByExternalId(requestParameters: KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActivateOrDisableEventDokumentTypMappingByExternalId200Response> {
            return localVarFp.activateOrDisableEventDokumentTypMappingByExternalId(requestParameters.aktiviert, requestParameters.user, requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the created Event DokumentTyp Mapping
         * @summary Creates Event DokumentTyp Mapping
         * @param {KonfigurationenApiCreateEventDokumentTypMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventDokumentTypMapping(requestParameters: KonfigurationenApiCreateEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createEventDokumentTypMapping(requestParameters.user, requestParameters.createEventDokumentTypMappingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a StreamServe-Projekt
         * @param {KonfigurationenApiCreateStreamServeProjektRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStreamServeProjekt(requestParameters: KonfigurationenApiCreateStreamServeProjektRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createStreamServeProjekt(requestParameters.createStreamServeProjektRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the Event DokumentTyp Mapping that matches the externalId
         * @summary Deletes Event DokumentTyp Mapping
         * @param {KonfigurationenApiDeleteEventDokumentTypMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventDokumentTypMapping(requestParameters: KonfigurationenApiDeleteEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteEventDokumentTypMapping200Response> {
            return localVarFp.deleteEventDokumentTypMapping(requestParameters.externalId, requestParameters.user, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a StreamServe-Projekt by External Id
         * @param {KonfigurationenApiDeleteStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStreamServeProjektByExternalId(requestParameters: KonfigurationenApiDeleteStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStreamServeProjektByExternalId(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get global transformation Debug settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatentransformationDebugSettings(options?: RawAxiosRequestConfig): AxiosPromise<GetDatentransformationDebugSettings200Response> {
            return localVarFp.getDatentransformationDebugSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mapping by External Id
         * @param {KonfigurationenApiGetEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappingByExternalId(requestParameters: KonfigurationenApiGetEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEventDokumentTypMappingByExternalId200Response> {
            return localVarFp.getEventDokumentTypMappingByExternalId(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific Event DokumentTyp Mapping Protocol
         * @summary Get the DokumentTyp Mapping Protocol by External Id
         * @param {KonfigurationenApiGetEventDokumentTypMappingProtocolByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappingProtocolByExternalId(requestParameters: KonfigurationenApiGetEventDokumentTypMappingProtocolByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetEventDokumentTypMappingProtocolByExternalId200ResponseInner>> {
            return localVarFp.getEventDokumentTypMappingProtocolByExternalId(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an array of Event DokumentTyp Mappings that are configured in the Configuration Section of OPM
         * @summary Get Event DokumentTyp Mappings
         * @param {KonfigurationenApiGetEventDokumentTypMappingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventDokumentTypMappings(requestParameters: KonfigurationenApiGetEventDokumentTypMappingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetEventDokumentTypMappings200Response> {
            return localVarFp.getEventDokumentTypMappings(requestParameters.aktiviert, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get StreamServe-Projekt by External Id
         * @param {KonfigurationenApiGetStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamServeProjektByExternalId(requestParameters: KonfigurationenApiGetStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStreamServeProjektByExternalId200Response> {
            return localVarFp.getStreamServeProjektByExternalId(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle StreamServe-Projekte, die im Konfigurations-Bereich gepflegt werden.
         * @summary Get StreamServe-Projekte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamServeProjekte(options?: RawAxiosRequestConfig): AxiosPromise<GetStreamServeProjekte200Response> {
            return localVarFp.getStreamServeProjekte(options).then((request) => request(axios, basePath));
        },
        /**
         * Restores the deleted Event Dokumenttyp Mapping by ExternalId and activates the Dokumenttyp Mapping
         * @summary Restores a deleted Event Dokumenttyp Mapping by ExternalId
         * @param {KonfigurationenApiRestoreEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreEventDokumentTypMappingByExternalId(requestParameters: KonfigurationenApiRestoreEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEventDokumentTypMappingByExternalId200Response> {
            return localVarFp.restoreEventDokumentTypMappingByExternalId(requestParameters.user, requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies to all current and future powercloud document types on Dev and Stage.
         * @summary Update global transformation Debug settings
         * @param {KonfigurationenApiUpdateDatentransformationDebugSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatentransformationDebugSettings(requestParameters: KonfigurationenApiUpdateDatentransformationDebugSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDatentransformationDebugSettings200Response> {
            return localVarFp.updateDatentransformationDebugSettings(requestParameters.user, requestParameters.getDatentransformationDebugSettings200Response, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
         * @summary Updates Event DokumentTyp Mapping by External Id
         * @param {KonfigurationenApiUpdateEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventDokumentTypMappingByExternalId(requestParameters: KonfigurationenApiUpdateEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEventDokumentTypMappingByExternalId200Response> {
            return localVarFp.updateEventDokumentTypMappingByExternalId(requestParameters.externalId, requestParameters.user, requestParameters.createEventDokumentTypMappingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a StreamServe-Projekt by External Id
         * @param {KonfigurationenApiUpdateStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStreamServeProjektByExternalId(requestParameters: KonfigurationenApiUpdateStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStreamServeProjektByExternalId200Response> {
            return localVarFp.updateStreamServeProjektByExternalId(requestParameters.externalId, requestParameters.createStreamServeProjektRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateOrDisableEventDokumentTypMappingByExternalId operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest
 */
export interface KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest {
    /**
     * 
     * @type {boolean}
     * @memberof KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalId
     */
    readonly aktiviert: boolean | null

    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalId
     */
    readonly user: string

    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for createEventDokumentTypMapping operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiCreateEventDokumentTypMappingRequest
 */
export interface KonfigurationenApiCreateEventDokumentTypMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiCreateEventDokumentTypMapping
     */
    readonly user: string

    /**
     * 
     * @type {CreateEventDokumentTypMappingRequest}
     * @memberof KonfigurationenApiCreateEventDokumentTypMapping
     */
    readonly createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest
}

/**
 * Request parameters for createStreamServeProjekt operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiCreateStreamServeProjektRequest
 */
export interface KonfigurationenApiCreateStreamServeProjektRequest {
    /**
     * 
     * @type {CreateStreamServeProjektRequest}
     * @memberof KonfigurationenApiCreateStreamServeProjekt
     */
    readonly createStreamServeProjektRequest: CreateStreamServeProjektRequest
}

/**
 * Request parameters for deleteEventDokumentTypMapping operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiDeleteEventDokumentTypMappingRequest
 */
export interface KonfigurationenApiDeleteEventDokumentTypMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiDeleteEventDokumentTypMapping
     */
    readonly externalId: string

    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiDeleteEventDokumentTypMapping
     */
    readonly user: string
}

/**
 * Request parameters for deleteStreamServeProjektByExternalId operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiDeleteStreamServeProjektByExternalIdRequest
 */
export interface KonfigurationenApiDeleteStreamServeProjektByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiDeleteStreamServeProjektByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for getEventDokumentTypMappingByExternalId operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiGetEventDokumentTypMappingByExternalIdRequest
 */
export interface KonfigurationenApiGetEventDokumentTypMappingByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiGetEventDokumentTypMappingByExternalId
     */
    readonly externalId: string | null
}

/**
 * Request parameters for getEventDokumentTypMappingProtocolByExternalId operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiGetEventDokumentTypMappingProtocolByExternalIdRequest
 */
export interface KonfigurationenApiGetEventDokumentTypMappingProtocolByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiGetEventDokumentTypMappingProtocolByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for getEventDokumentTypMappings operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiGetEventDokumentTypMappingsRequest
 */
export interface KonfigurationenApiGetEventDokumentTypMappingsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof KonfigurationenApiGetEventDokumentTypMappings
     */
    readonly aktiviert?: boolean | null
}

/**
 * Request parameters for getStreamServeProjektByExternalId operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiGetStreamServeProjektByExternalIdRequest
 */
export interface KonfigurationenApiGetStreamServeProjektByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiGetStreamServeProjektByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for restoreEventDokumentTypMappingByExternalId operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiRestoreEventDokumentTypMappingByExternalIdRequest
 */
export interface KonfigurationenApiRestoreEventDokumentTypMappingByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiRestoreEventDokumentTypMappingByExternalId
     */
    readonly user: string

    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiRestoreEventDokumentTypMappingByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for updateDatentransformationDebugSettings operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiUpdateDatentransformationDebugSettingsRequest
 */
export interface KonfigurationenApiUpdateDatentransformationDebugSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiUpdateDatentransformationDebugSettings
     */
    readonly user: string

    /**
     * 
     * @type {GetDatentransformationDebugSettings200Response}
     * @memberof KonfigurationenApiUpdateDatentransformationDebugSettings
     */
    readonly getDatentransformationDebugSettings200Response: GetDatentransformationDebugSettings200Response
}

/**
 * Request parameters for updateEventDokumentTypMappingByExternalId operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiUpdateEventDokumentTypMappingByExternalIdRequest
 */
export interface KonfigurationenApiUpdateEventDokumentTypMappingByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiUpdateEventDokumentTypMappingByExternalId
     */
    readonly externalId: string

    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiUpdateEventDokumentTypMappingByExternalId
     */
    readonly user: string

    /**
     * 
     * @type {CreateEventDokumentTypMappingRequest}
     * @memberof KonfigurationenApiUpdateEventDokumentTypMappingByExternalId
     */
    readonly createEventDokumentTypMappingRequest: CreateEventDokumentTypMappingRequest
}

/**
 * Request parameters for updateStreamServeProjektByExternalId operation in KonfigurationenApi.
 * @export
 * @interface KonfigurationenApiUpdateStreamServeProjektByExternalIdRequest
 */
export interface KonfigurationenApiUpdateStreamServeProjektByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof KonfigurationenApiUpdateStreamServeProjektByExternalId
     */
    readonly externalId: string

    /**
     * 
     * @type {CreateStreamServeProjektRequest}
     * @memberof KonfigurationenApiUpdateStreamServeProjektByExternalId
     */
    readonly createStreamServeProjektRequest: CreateStreamServeProjektRequest
}

/**
 * KonfigurationenApi - object-oriented interface
 * @export
 * @class KonfigurationenApi
 * @extends {BaseAPI}
 */
export class KonfigurationenApi extends BaseAPI {
    /**
     * Idempotant Update of Activation for the Dokumenttyp
     * @summary Saves the Activation of the Event DokumentTyp Mapping by External Id
     * @param {KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public activateOrDisableEventDokumentTypMappingByExternalId(requestParameters: KonfigurationenApiActivateOrDisableEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).activateOrDisableEventDokumentTypMappingByExternalId(requestParameters.aktiviert, requestParameters.user, requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the created Event DokumentTyp Mapping
     * @summary Creates Event DokumentTyp Mapping
     * @param {KonfigurationenApiCreateEventDokumentTypMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public createEventDokumentTypMapping(requestParameters: KonfigurationenApiCreateEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).createEventDokumentTypMapping(requestParameters.user, requestParameters.createEventDokumentTypMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a StreamServe-Projekt
     * @param {KonfigurationenApiCreateStreamServeProjektRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public createStreamServeProjekt(requestParameters: KonfigurationenApiCreateStreamServeProjektRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).createStreamServeProjekt(requestParameters.createStreamServeProjektRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the Event DokumentTyp Mapping that matches the externalId
     * @summary Deletes Event DokumentTyp Mapping
     * @param {KonfigurationenApiDeleteEventDokumentTypMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public deleteEventDokumentTypMapping(requestParameters: KonfigurationenApiDeleteEventDokumentTypMappingRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).deleteEventDokumentTypMapping(requestParameters.externalId, requestParameters.user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a StreamServe-Projekt by External Id
     * @param {KonfigurationenApiDeleteStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public deleteStreamServeProjektByExternalId(requestParameters: KonfigurationenApiDeleteStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).deleteStreamServeProjektByExternalId(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get global transformation Debug settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public getDatentransformationDebugSettings(options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).getDatentransformationDebugSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
     * @summary Get Event DokumentTyp Mapping by External Id
     * @param {KonfigurationenApiGetEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public getEventDokumentTypMappingByExternalId(requestParameters: KonfigurationenApiGetEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).getEventDokumentTypMappingByExternalId(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific Event DokumentTyp Mapping Protocol
     * @summary Get the DokumentTyp Mapping Protocol by External Id
     * @param {KonfigurationenApiGetEventDokumentTypMappingProtocolByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public getEventDokumentTypMappingProtocolByExternalId(requestParameters: KonfigurationenApiGetEventDokumentTypMappingProtocolByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).getEventDokumentTypMappingProtocolByExternalId(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an array of Event DokumentTyp Mappings that are configured in the Configuration Section of OPM
     * @summary Get Event DokumentTyp Mappings
     * @param {KonfigurationenApiGetEventDokumentTypMappingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public getEventDokumentTypMappings(requestParameters: KonfigurationenApiGetEventDokumentTypMappingsRequest = {}, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).getEventDokumentTypMappings(requestParameters.aktiviert, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get StreamServe-Projekt by External Id
     * @param {KonfigurationenApiGetStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public getStreamServeProjektByExternalId(requestParameters: KonfigurationenApiGetStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).getStreamServeProjektByExternalId(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle StreamServe-Projekte, die im Konfigurations-Bereich gepflegt werden.
     * @summary Get StreamServe-Projekte
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public getStreamServeProjekte(options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).getStreamServeProjekte(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restores the deleted Event Dokumenttyp Mapping by ExternalId and activates the Dokumenttyp Mapping
     * @summary Restores a deleted Event Dokumenttyp Mapping by ExternalId
     * @param {KonfigurationenApiRestoreEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public restoreEventDokumentTypMappingByExternalId(requestParameters: KonfigurationenApiRestoreEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).restoreEventDokumentTypMappingByExternalId(requestParameters.user, requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies to all current and future powercloud document types on Dev and Stage.
     * @summary Update global transformation Debug settings
     * @param {KonfigurationenApiUpdateDatentransformationDebugSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public updateDatentransformationDebugSettings(requestParameters: KonfigurationenApiUpdateDatentransformationDebugSettingsRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).updateDatentransformationDebugSettings(requestParameters.user, requestParameters.getDatentransformationDebugSettings200Response, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific Event DokumentTyp Mapping that are configured in the Configuration Section of OPM
     * @summary Updates Event DokumentTyp Mapping by External Id
     * @param {KonfigurationenApiUpdateEventDokumentTypMappingByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public updateEventDokumentTypMappingByExternalId(requestParameters: KonfigurationenApiUpdateEventDokumentTypMappingByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).updateEventDokumentTypMappingByExternalId(requestParameters.externalId, requestParameters.user, requestParameters.createEventDokumentTypMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a StreamServe-Projekt by External Id
     * @param {KonfigurationenApiUpdateStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KonfigurationenApi
     */
    public updateStreamServeProjektByExternalId(requestParameters: KonfigurationenApiUpdateStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return KonfigurationenApiFp(this.configuration).updateStreamServeProjektByExternalId(requestParameters.externalId, requestParameters.createStreamServeProjektRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OpmCockpitBackendApi - axios parameter creator
 * @export
 */
export const OpmCockpitBackendApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Antwortet mit dem gesendeten parameter pong
         * @summary Ping-Pong
         * @param {string} ping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPingPongByPing: async (ping: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ping' is not null or undefined
            assertParamExists('getPingPongByPing', 'ping', ping)
            const localVarPath = `/ping-pong/{ping}`
                .replace(`{${"ping"}}`, encodeURIComponent(String(ping)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpmCockpitBackendApi - functional programming interface
 * @export
 */
export const OpmCockpitBackendApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpmCockpitBackendApiAxiosParamCreator(configuration)
    return {
        /**
         * Antwortet mit dem gesendeten parameter pong
         * @summary Ping-Pong
         * @param {string} ping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPingPongByPing(ping: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPingPongByPing200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPingPongByPing(ping, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpmCockpitBackendApi.getPingPongByPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OpmCockpitBackendApi - factory interface
 * @export
 */
export const OpmCockpitBackendApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpmCockpitBackendApiFp(configuration)
    return {
        /**
         * Antwortet mit dem gesendeten parameter pong
         * @summary Ping-Pong
         * @param {OpmCockpitBackendApiGetPingPongByPingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPingPongByPing(requestParameters: OpmCockpitBackendApiGetPingPongByPingRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPingPongByPing200Response> {
            return localVarFp.getPingPongByPing(requestParameters.ping, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPingPongByPing operation in OpmCockpitBackendApi.
 * @export
 * @interface OpmCockpitBackendApiGetPingPongByPingRequest
 */
export interface OpmCockpitBackendApiGetPingPongByPingRequest {
    /**
     * 
     * @type {string}
     * @memberof OpmCockpitBackendApiGetPingPongByPing
     */
    readonly ping: string
}

/**
 * OpmCockpitBackendApi - object-oriented interface
 * @export
 * @class OpmCockpitBackendApi
 * @extends {BaseAPI}
 */
export class OpmCockpitBackendApi extends BaseAPI {
    /**
     * Antwortet mit dem gesendeten parameter pong
     * @summary Ping-Pong
     * @param {OpmCockpitBackendApiGetPingPongByPingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpmCockpitBackendApi
     */
    public getPingPongByPing(requestParameters: OpmCockpitBackendApiGetPingPongByPingRequest, options?: RawAxiosRequestConfig) {
        return OpmCockpitBackendApiFp(this.configuration).getPingPongByPing(requestParameters.ping, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StreamServeProjekteApi - axios parameter creator
 * @export
 */
export const StreamServeProjekteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates a StreamServe-Projekt
         * @param {CreateStreamServeProjektRequest} createStreamServeProjektRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStreamServeProjekt: async (createStreamServeProjektRequest: CreateStreamServeProjektRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStreamServeProjektRequest' is not null or undefined
            assertParamExists('createStreamServeProjekt', 'createStreamServeProjektRequest', createStreamServeProjektRequest)
            const localVarPath = `/konfigurationen/streamserveprojekte`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStreamServeProjektRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStreamServeProjektByExternalId: async (externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('deleteStreamServeProjektByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/streamserveprojekte/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamServeProjektByExternalId: async (externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('getStreamServeProjektByExternalId', 'externalId', externalId)
            const localVarPath = `/konfigurationen/streamserveprojekte/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle StreamServe-Projekte, die im Konfigurations-Bereich gepflegt werden.
         * @summary Get StreamServe-Projekte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamServeProjekte: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/streamserveprojekte`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {CreateStreamServeProjektRequest} createStreamServeProjektRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStreamServeProjektByExternalId: async (externalId: string, createStreamServeProjektRequest: CreateStreamServeProjektRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('updateStreamServeProjektByExternalId', 'externalId', externalId)
            // verify required parameter 'createStreamServeProjektRequest' is not null or undefined
            assertParamExists('updateStreamServeProjektByExternalId', 'createStreamServeProjektRequest', createStreamServeProjektRequest)
            const localVarPath = `/konfigurationen/streamserveprojekte/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStreamServeProjektRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StreamServeProjekteApi - functional programming interface
 * @export
 */
export const StreamServeProjekteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StreamServeProjekteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates a StreamServe-Projekt
         * @param {CreateStreamServeProjektRequest} createStreamServeProjektRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStreamServeProjekt(createStreamServeProjektRequest: CreateStreamServeProjektRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStreamServeProjekt(createStreamServeProjektRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreamServeProjekteApi.createStreamServeProjekt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStreamServeProjektByExternalId(externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStreamServeProjektByExternalId(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreamServeProjekteApi.deleteStreamServeProjektByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStreamServeProjektByExternalId(externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStreamServeProjektByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStreamServeProjektByExternalId(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreamServeProjekteApi.getStreamServeProjektByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Liefert alle StreamServe-Projekte, die im Konfigurations-Bereich gepflegt werden.
         * @summary Get StreamServe-Projekte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStreamServeProjekte(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStreamServeProjekte200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStreamServeProjekte(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreamServeProjekteApi.getStreamServeProjekte']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a StreamServe-Projekt by External Id
         * @param {string} externalId 
         * @param {CreateStreamServeProjektRequest} createStreamServeProjektRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStreamServeProjektByExternalId(externalId: string, createStreamServeProjektRequest: CreateStreamServeProjektRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStreamServeProjektByExternalId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStreamServeProjektByExternalId(externalId, createStreamServeProjektRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StreamServeProjekteApi.updateStreamServeProjektByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StreamServeProjekteApi - factory interface
 * @export
 */
export const StreamServeProjekteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StreamServeProjekteApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates a StreamServe-Projekt
         * @param {StreamServeProjekteApiCreateStreamServeProjektRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStreamServeProjekt(requestParameters: StreamServeProjekteApiCreateStreamServeProjektRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createStreamServeProjekt(requestParameters.createStreamServeProjektRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a StreamServe-Projekt by External Id
         * @param {StreamServeProjekteApiDeleteStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStreamServeProjektByExternalId(requestParameters: StreamServeProjekteApiDeleteStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStreamServeProjektByExternalId(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get StreamServe-Projekt by External Id
         * @param {StreamServeProjekteApiGetStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamServeProjektByExternalId(requestParameters: StreamServeProjekteApiGetStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStreamServeProjektByExternalId200Response> {
            return localVarFp.getStreamServeProjektByExternalId(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle StreamServe-Projekte, die im Konfigurations-Bereich gepflegt werden.
         * @summary Get StreamServe-Projekte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamServeProjekte(options?: RawAxiosRequestConfig): AxiosPromise<GetStreamServeProjekte200Response> {
            return localVarFp.getStreamServeProjekte(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a StreamServe-Projekt by External Id
         * @param {StreamServeProjekteApiUpdateStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStreamServeProjektByExternalId(requestParameters: StreamServeProjekteApiUpdateStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStreamServeProjektByExternalId200Response> {
            return localVarFp.updateStreamServeProjektByExternalId(requestParameters.externalId, requestParameters.createStreamServeProjektRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createStreamServeProjekt operation in StreamServeProjekteApi.
 * @export
 * @interface StreamServeProjekteApiCreateStreamServeProjektRequest
 */
export interface StreamServeProjekteApiCreateStreamServeProjektRequest {
    /**
     * 
     * @type {CreateStreamServeProjektRequest}
     * @memberof StreamServeProjekteApiCreateStreamServeProjekt
     */
    readonly createStreamServeProjektRequest: CreateStreamServeProjektRequest
}

/**
 * Request parameters for deleteStreamServeProjektByExternalId operation in StreamServeProjekteApi.
 * @export
 * @interface StreamServeProjekteApiDeleteStreamServeProjektByExternalIdRequest
 */
export interface StreamServeProjekteApiDeleteStreamServeProjektByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof StreamServeProjekteApiDeleteStreamServeProjektByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for getStreamServeProjektByExternalId operation in StreamServeProjekteApi.
 * @export
 * @interface StreamServeProjekteApiGetStreamServeProjektByExternalIdRequest
 */
export interface StreamServeProjekteApiGetStreamServeProjektByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof StreamServeProjekteApiGetStreamServeProjektByExternalId
     */
    readonly externalId: string
}

/**
 * Request parameters for updateStreamServeProjektByExternalId operation in StreamServeProjekteApi.
 * @export
 * @interface StreamServeProjekteApiUpdateStreamServeProjektByExternalIdRequest
 */
export interface StreamServeProjekteApiUpdateStreamServeProjektByExternalIdRequest {
    /**
     * 
     * @type {string}
     * @memberof StreamServeProjekteApiUpdateStreamServeProjektByExternalId
     */
    readonly externalId: string

    /**
     * 
     * @type {CreateStreamServeProjektRequest}
     * @memberof StreamServeProjekteApiUpdateStreamServeProjektByExternalId
     */
    readonly createStreamServeProjektRequest: CreateStreamServeProjektRequest
}

/**
 * StreamServeProjekteApi - object-oriented interface
 * @export
 * @class StreamServeProjekteApi
 * @extends {BaseAPI}
 */
export class StreamServeProjekteApi extends BaseAPI {
    /**
     * 
     * @summary Creates a StreamServe-Projekt
     * @param {StreamServeProjekteApiCreateStreamServeProjektRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamServeProjekteApi
     */
    public createStreamServeProjekt(requestParameters: StreamServeProjekteApiCreateStreamServeProjektRequest, options?: RawAxiosRequestConfig) {
        return StreamServeProjekteApiFp(this.configuration).createStreamServeProjekt(requestParameters.createStreamServeProjektRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a StreamServe-Projekt by External Id
     * @param {StreamServeProjekteApiDeleteStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamServeProjekteApi
     */
    public deleteStreamServeProjektByExternalId(requestParameters: StreamServeProjekteApiDeleteStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return StreamServeProjekteApiFp(this.configuration).deleteStreamServeProjektByExternalId(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get StreamServe-Projekt by External Id
     * @param {StreamServeProjekteApiGetStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamServeProjekteApi
     */
    public getStreamServeProjektByExternalId(requestParameters: StreamServeProjekteApiGetStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return StreamServeProjekteApiFp(this.configuration).getStreamServeProjektByExternalId(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle StreamServe-Projekte, die im Konfigurations-Bereich gepflegt werden.
     * @summary Get StreamServe-Projekte
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamServeProjekteApi
     */
    public getStreamServeProjekte(options?: RawAxiosRequestConfig) {
        return StreamServeProjekteApiFp(this.configuration).getStreamServeProjekte(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a StreamServe-Projekt by External Id
     * @param {StreamServeProjekteApiUpdateStreamServeProjektByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamServeProjekteApi
     */
    public updateStreamServeProjektByExternalId(requestParameters: StreamServeProjekteApiUpdateStreamServeProjektByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return StreamServeProjekteApiFp(this.configuration).updateStreamServeProjektByExternalId(requestParameters.externalId, requestParameters.createStreamServeProjektRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VorgngeApi - axios parameter creator
 * @export
 */
export const VorgngeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes multiple vorgang items by their IDs
         * @summary Bulk delete vorgang items
         * @param {BulkDeleteVorgaengeRequest} bulkDeleteVorgaengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteVorgaenge: async (bulkDeleteVorgaengeRequest: BulkDeleteVorgaengeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDeleteVorgaengeRequest' is not null or undefined
            assertParamExists('bulkDeleteVorgaenge', 'bulkDeleteVorgaengeRequest', bulkDeleteVorgaengeRequest)
            const localVarPath = `/vorgaenge/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteVorgaengeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retries processing of multiple vorgang items
         * @summary Bulk retry event processing
         * @param {BulkRetryVorgaengeRequest} bulkRetryVorgaengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRetryVorgaenge: async (bulkRetryVorgaengeRequest: BulkRetryVorgaengeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkRetryVorgaengeRequest' is not null or undefined
            assertParamExists('bulkRetryVorgaenge', 'bulkRetryVorgaengeRequest', bulkRetryVorgaengeRequest)
            const localVarPath = `/vorgaenge/bulk-retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkRetryVorgaengeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stellt mehrere Vorgänge gleichzeitig zurück
         * @summary Bulk zurückstellen
         * @param {BulkZurueckstellenVorgaengeRequest} bulkZurueckstellenVorgaengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkZurueckstellenVorgaenge: async (bulkZurueckstellenVorgaengeRequest: BulkZurueckstellenVorgaengeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkZurueckstellenVorgaengeRequest' is not null or undefined
            assertParamExists('bulkZurueckstellenVorgaenge', 'bulkZurueckstellenVorgaengeRequest', bulkZurueckstellenVorgaengeRequest)
            const localVarPath = `/vorgaenge/bulk-zurueckstellen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkZurueckstellenVorgaengeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a specific vorgang item by ID
         * @summary Delete vorgang item
         * @param {string} id 
         * @param {string | null} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVorgang: async (id: string, user: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteVorgang', 'id', id)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('deleteVorgang', 'user', user)
            const localVarPath = `/vorgaenge/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exports the filtered and sorted Vorgänge as CSV and returns a presigned download URL which expires after 1 hour.
         * @summary Export Vorgaenge as CSV
         * @param {ExportVorgaengeArchivierungsstatusEnum} [archivierungsstatus] 
         * @param {string | null} [status] 
         * @param {string | null} [createdAtFrom] 
         * @param {string | null} [createdAtTo] 
         * @param {string | null} [currentGestartedAmFrom] 
         * @param {string | null} [currentGestartedAmTo] 
         * @param {string} [auftragsnummer] 
         * @param {string} [vertragsnummer] 
         * @param {string} [kundennummer] 
         * @param {string} [correlationId] 
         * @param {string} [externeId] 
         * @param {string} [vorgangType] 
         * @param {ExportVorgaengeCurrentStepEnum} [currentStep] 
         * @param {string} [externerName] 
         * @param {string} [error] 
         * @param {string} [lockedBy] 
         * @param {string | null} [fehlertyp] 
         * @param {string} [dokumentTyp] 
         * @param {string} [unterdrueckung] 
         * @param {string} [searchText] 
         * @param {ExportVorgaengeSearchOperatorEnum} [searchOperator] 
         * @param {ExportVorgaengeStale24hEnum} [stale24h] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {string | null} [sortBy] 
         * @param {ExportVorgaengeSortOrderEnum} [sortOrder] 
         * @param {string | null} [columns] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportVorgaenge: async (archivierungsstatus?: ExportVorgaengeArchivierungsstatusEnum, status?: string | null, createdAtFrom?: string | null, createdAtTo?: string | null, currentGestartedAmFrom?: string | null, currentGestartedAmTo?: string | null, auftragsnummer?: string, vertragsnummer?: string, kundennummer?: string, correlationId?: string, externeId?: string, vorgangType?: string, currentStep?: ExportVorgaengeCurrentStepEnum, externerName?: string, error?: string, lockedBy?: string, fehlertyp?: string | null, dokumentTyp?: string, unterdrueckung?: string, searchText?: string, searchOperator?: ExportVorgaengeSearchOperatorEnum, stale24h?: ExportVorgaengeStale24hEnum, offset?: string, limit?: string, sortBy?: string | null, sortOrder?: ExportVorgaengeSortOrderEnum, columns?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vorgaenge/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (archivierungsstatus !== undefined) {
                localVarQueryParameter['archivierungsstatus'] = archivierungsstatus;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = createdAtTo;
            }

            if (currentGestartedAmFrom !== undefined) {
                localVarQueryParameter['currentGestartedAmFrom'] = currentGestartedAmFrom;
            }

            if (currentGestartedAmTo !== undefined) {
                localVarQueryParameter['currentGestartedAmTo'] = currentGestartedAmTo;
            }

            if (auftragsnummer !== undefined) {
                localVarQueryParameter['auftragsnummer'] = auftragsnummer;
            }

            if (vertragsnummer !== undefined) {
                localVarQueryParameter['vertragsnummer'] = vertragsnummer;
            }

            if (kundennummer !== undefined) {
                localVarQueryParameter['kundennummer'] = kundennummer;
            }

            if (correlationId !== undefined) {
                localVarQueryParameter['correlationId'] = correlationId;
            }

            if (externeId !== undefined) {
                localVarQueryParameter['externeId'] = externeId;
            }

            if (vorgangType !== undefined) {
                localVarQueryParameter['vorgangType'] = vorgangType;
            }

            if (currentStep !== undefined) {
                localVarQueryParameter['currentStep'] = currentStep;
            }

            if (externerName !== undefined) {
                localVarQueryParameter['externerName'] = externerName;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (lockedBy !== undefined) {
                localVarQueryParameter['lockedBy'] = lockedBy;
            }

            if (fehlertyp !== undefined) {
                localVarQueryParameter['fehlertyp'] = fehlertyp;
            }

            if (dokumentTyp !== undefined) {
                localVarQueryParameter['dokumentTyp'] = dokumentTyp;
            }

            if (unterdrueckung !== undefined) {
                localVarQueryParameter['unterdrueckung'] = unterdrueckung;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (searchOperator !== undefined) {
                localVarQueryParameter['searchOperator'] = searchOperator;
            }

            if (stale24h !== undefined) {
                localVarQueryParameter['stale24h'] = stale24h;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (columns !== undefined) {
                localVarQueryParameter['columns'] = columns;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exports filtered and sorted rows from the archive (same query shape as GET /vorgaenge-archiv) as CSV; returns a presigned download URL.
         * @summary Export archived Vorgänge as CSV
         * @param {ExportVorgaengeArchivArchivierungsstatusEnum} [archivierungsstatus] 
         * @param {string} [status] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {string} [currentGestartedAmFrom] 
         * @param {string} [currentGestartedAmTo] 
         * @param {string} [auftragsnummer] 
         * @param {string} [vertragsnummer] 
         * @param {string} [kundennummer] 
         * @param {string} [correlationId] 
         * @param {string} [externeId] 
         * @param {string} [vorgangType] 
         * @param {ExportVorgaengeArchivCurrentStepEnum} [currentStep] 
         * @param {string} [externerName] 
         * @param {string} [error] 
         * @param {string} [lockedBy] 
         * @param {string} [fehlertyp] 
         * @param {string} [dokumentTyp] 
         * @param {string} [unterdrueckung] 
         * @param {string} [searchText] 
         * @param {ExportVorgaengeArchivSearchOperatorEnum} [searchOperator] 
         * @param {ExportVorgaengeArchivStale24hEnum} [stale24h] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {string} [sortBy] 
         * @param {ExportVorgaengeArchivSortOrderEnum} [sortOrder] 
         * @param {string} [columns] 
         * @param {string} [searchFields] 
         * @param {ExportVorgaengeArchivAuftragsnummerOperatorEnum} [auftragsnummerOperator] 
         * @param {ExportVorgaengeArchivVertragsnummerOperatorEnum} [vertragsnummerOperator] 
         * @param {ExportVorgaengeArchivExternerNameOperatorEnum} [externerNameOperator] 
         * @param {ExportVorgaengeArchivDokumentTypOperatorEnum} [dokumentTypOperator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportVorgaengeArchiv: async (archivierungsstatus?: ExportVorgaengeArchivArchivierungsstatusEnum, status?: string, createdAtFrom?: string, createdAtTo?: string, currentGestartedAmFrom?: string, currentGestartedAmTo?: string, auftragsnummer?: string, vertragsnummer?: string, kundennummer?: string, correlationId?: string, externeId?: string, vorgangType?: string, currentStep?: ExportVorgaengeArchivCurrentStepEnum, externerName?: string, error?: string, lockedBy?: string, fehlertyp?: string, dokumentTyp?: string, unterdrueckung?: string, searchText?: string, searchOperator?: ExportVorgaengeArchivSearchOperatorEnum, stale24h?: ExportVorgaengeArchivStale24hEnum, offset?: string, limit?: string, sortBy?: string, sortOrder?: ExportVorgaengeArchivSortOrderEnum, columns?: string, searchFields?: string, auftragsnummerOperator?: ExportVorgaengeArchivAuftragsnummerOperatorEnum, vertragsnummerOperator?: ExportVorgaengeArchivVertragsnummerOperatorEnum, externerNameOperator?: ExportVorgaengeArchivExternerNameOperatorEnum, dokumentTypOperator?: ExportVorgaengeArchivDokumentTypOperatorEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vorgaenge-archiv/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (archivierungsstatus !== undefined) {
                localVarQueryParameter['archivierungsstatus'] = archivierungsstatus;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = createdAtTo;
            }

            if (currentGestartedAmFrom !== undefined) {
                localVarQueryParameter['currentGestartedAmFrom'] = currentGestartedAmFrom;
            }

            if (currentGestartedAmTo !== undefined) {
                localVarQueryParameter['currentGestartedAmTo'] = currentGestartedAmTo;
            }

            if (auftragsnummer !== undefined) {
                localVarQueryParameter['auftragsnummer'] = auftragsnummer;
            }

            if (vertragsnummer !== undefined) {
                localVarQueryParameter['vertragsnummer'] = vertragsnummer;
            }

            if (kundennummer !== undefined) {
                localVarQueryParameter['kundennummer'] = kundennummer;
            }

            if (correlationId !== undefined) {
                localVarQueryParameter['correlationId'] = correlationId;
            }

            if (externeId !== undefined) {
                localVarQueryParameter['externeId'] = externeId;
            }

            if (vorgangType !== undefined) {
                localVarQueryParameter['vorgangType'] = vorgangType;
            }

            if (currentStep !== undefined) {
                localVarQueryParameter['currentStep'] = currentStep;
            }

            if (externerName !== undefined) {
                localVarQueryParameter['externerName'] = externerName;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (lockedBy !== undefined) {
                localVarQueryParameter['lockedBy'] = lockedBy;
            }

            if (fehlertyp !== undefined) {
                localVarQueryParameter['fehlertyp'] = fehlertyp;
            }

            if (dokumentTyp !== undefined) {
                localVarQueryParameter['dokumentTyp'] = dokumentTyp;
            }

            if (unterdrueckung !== undefined) {
                localVarQueryParameter['unterdrueckung'] = unterdrueckung;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (searchOperator !== undefined) {
                localVarQueryParameter['searchOperator'] = searchOperator;
            }

            if (stale24h !== undefined) {
                localVarQueryParameter['stale24h'] = stale24h;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (columns !== undefined) {
                localVarQueryParameter['columns'] = columns;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['searchFields'] = searchFields;
            }

            if (auftragsnummerOperator !== undefined) {
                localVarQueryParameter['auftragsnummerOperator'] = auftragsnummerOperator;
            }

            if (vertragsnummerOperator !== undefined) {
                localVarQueryParameter['vertragsnummerOperator'] = vertragsnummerOperator;
            }

            if (externerNameOperator !== undefined) {
                localVarQueryParameter['externerNameOperator'] = externerNameOperator;
            }

            if (dokumentTypOperator !== undefined) {
                localVarQueryParameter['dokumentTypOperator'] = dokumentTypOperator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an array of vorgänge containing event data and optional document information
         * @summary Get Vorgänge
         * @param {GetVorgaengeArchivierungsstatusEnum} [archivierungsstatus] 
         * @param {string} [status] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {string} [currentGestartedAmFrom] 
         * @param {string} [currentGestartedAmTo] 
         * @param {string} [auftragsnummer] 
         * @param {string} [vertragsnummer] 
         * @param {string} [kundennummer] 
         * @param {string} [correlationId] 
         * @param {string} [externeId] 
         * @param {string} [vorgangType] 
         * @param {GetVorgaengeCurrentStepEnum} [currentStep] 
         * @param {string} [externerName] 
         * @param {string} [error] 
         * @param {string} [lockedBy] 
         * @param {string} [fehlertyp] 
         * @param {string} [dokumentTyp] 
         * @param {string} [unterdrueckung] 
         * @param {string} [searchText] 
         * @param {GetVorgaengeSearchOperatorEnum} [searchOperator] 
         * @param {GetVorgaengeStale24hEnum} [stale24h] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {string} [sortBy] 
         * @param {GetVorgaengeSortOrderEnum} [sortOrder] 
         * @param {string} [columns] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgaenge: async (archivierungsstatus?: GetVorgaengeArchivierungsstatusEnum, status?: string, createdAtFrom?: string, createdAtTo?: string, currentGestartedAmFrom?: string, currentGestartedAmTo?: string, auftragsnummer?: string, vertragsnummer?: string, kundennummer?: string, correlationId?: string, externeId?: string, vorgangType?: string, currentStep?: GetVorgaengeCurrentStepEnum, externerName?: string, error?: string, lockedBy?: string, fehlertyp?: string, dokumentTyp?: string, unterdrueckung?: string, searchText?: string, searchOperator?: GetVorgaengeSearchOperatorEnum, stale24h?: GetVorgaengeStale24hEnum, offset?: string, limit?: string, sortBy?: string, sortOrder?: GetVorgaengeSortOrderEnum, columns?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vorgaenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (archivierungsstatus !== undefined) {
                localVarQueryParameter['archivierungsstatus'] = archivierungsstatus;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = createdAtTo;
            }

            if (currentGestartedAmFrom !== undefined) {
                localVarQueryParameter['currentGestartedAmFrom'] = currentGestartedAmFrom;
            }

            if (currentGestartedAmTo !== undefined) {
                localVarQueryParameter['currentGestartedAmTo'] = currentGestartedAmTo;
            }

            if (auftragsnummer !== undefined) {
                localVarQueryParameter['auftragsnummer'] = auftragsnummer;
            }

            if (vertragsnummer !== undefined) {
                localVarQueryParameter['vertragsnummer'] = vertragsnummer;
            }

            if (kundennummer !== undefined) {
                localVarQueryParameter['kundennummer'] = kundennummer;
            }

            if (correlationId !== undefined) {
                localVarQueryParameter['correlationId'] = correlationId;
            }

            if (externeId !== undefined) {
                localVarQueryParameter['externeId'] = externeId;
            }

            if (vorgangType !== undefined) {
                localVarQueryParameter['vorgangType'] = vorgangType;
            }

            if (currentStep !== undefined) {
                localVarQueryParameter['currentStep'] = currentStep;
            }

            if (externerName !== undefined) {
                localVarQueryParameter['externerName'] = externerName;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (lockedBy !== undefined) {
                localVarQueryParameter['lockedBy'] = lockedBy;
            }

            if (fehlertyp !== undefined) {
                localVarQueryParameter['fehlertyp'] = fehlertyp;
            }

            if (dokumentTyp !== undefined) {
                localVarQueryParameter['dokumentTyp'] = dokumentTyp;
            }

            if (unterdrueckung !== undefined) {
                localVarQueryParameter['unterdrueckung'] = unterdrueckung;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (searchOperator !== undefined) {
                localVarQueryParameter['searchOperator'] = searchOperator;
            }

            if (stale24h !== undefined) {
                localVarQueryParameter['stale24h'] = stale24h;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (columns !== undefined) {
                localVarQueryParameter['columns'] = columns;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns counts of non-deleted Vorgänge in status WARTEND or LAUFEND that have exceeded the configured staleness threshold in their current process step.
         * @summary Get stale Vorgang alerting counts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgaengeAlerting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vorgaenge-alerting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns completed and soft-deleted Vorgänge from archive storage with the same filters as the main list.
         * @summary Get archived Vorgänge
         * @param {GetVorgaengeArchivArchivierungsstatusEnum} [archivierungsstatus] 
         * @param {string} [status] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {string} [currentGestartedAmFrom] 
         * @param {string} [currentGestartedAmTo] 
         * @param {string} [auftragsnummer] 
         * @param {string} [vertragsnummer] 
         * @param {string} [kundennummer] 
         * @param {string} [correlationId] 
         * @param {string} [externeId] 
         * @param {string} [vorgangType] 
         * @param {GetVorgaengeArchivCurrentStepEnum} [currentStep] 
         * @param {string} [externerName] 
         * @param {string} [error] 
         * @param {string} [lockedBy] 
         * @param {string} [fehlertyp] 
         * @param {string} [dokumentTyp] 
         * @param {string} [unterdrueckung] 
         * @param {string} [searchText] 
         * @param {GetVorgaengeArchivSearchOperatorEnum} [searchOperator] 
         * @param {GetVorgaengeArchivStale24hEnum} [stale24h] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {string} [sortBy] 
         * @param {GetVorgaengeArchivSortOrderEnum} [sortOrder] 
         * @param {string} [columns] 
         * @param {string | null} [searchFields] 
         * @param {GetVorgaengeArchivAuftragsnummerOperatorEnum} [auftragsnummerOperator] 
         * @param {GetVorgaengeArchivVertragsnummerOperatorEnum} [vertragsnummerOperator] 
         * @param {GetVorgaengeArchivExternerNameOperatorEnum} [externerNameOperator] 
         * @param {GetVorgaengeArchivDokumentTypOperatorEnum} [dokumentTypOperator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgaengeArchiv: async (archivierungsstatus?: GetVorgaengeArchivArchivierungsstatusEnum, status?: string, createdAtFrom?: string, createdAtTo?: string, currentGestartedAmFrom?: string, currentGestartedAmTo?: string, auftragsnummer?: string, vertragsnummer?: string, kundennummer?: string, correlationId?: string, externeId?: string, vorgangType?: string, currentStep?: GetVorgaengeArchivCurrentStepEnum, externerName?: string, error?: string, lockedBy?: string, fehlertyp?: string, dokumentTyp?: string, unterdrueckung?: string, searchText?: string, searchOperator?: GetVorgaengeArchivSearchOperatorEnum, stale24h?: GetVorgaengeArchivStale24hEnum, offset?: string, limit?: string, sortBy?: string, sortOrder?: GetVorgaengeArchivSortOrderEnum, columns?: string, searchFields?: string | null, auftragsnummerOperator?: GetVorgaengeArchivAuftragsnummerOperatorEnum, vertragsnummerOperator?: GetVorgaengeArchivVertragsnummerOperatorEnum, externerNameOperator?: GetVorgaengeArchivExternerNameOperatorEnum, dokumentTypOperator?: GetVorgaengeArchivDokumentTypOperatorEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vorgaenge-archiv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (archivierungsstatus !== undefined) {
                localVarQueryParameter['archivierungsstatus'] = archivierungsstatus;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['createdAtFrom'] = createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['createdAtTo'] = createdAtTo;
            }

            if (currentGestartedAmFrom !== undefined) {
                localVarQueryParameter['currentGestartedAmFrom'] = currentGestartedAmFrom;
            }

            if (currentGestartedAmTo !== undefined) {
                localVarQueryParameter['currentGestartedAmTo'] = currentGestartedAmTo;
            }

            if (auftragsnummer !== undefined) {
                localVarQueryParameter['auftragsnummer'] = auftragsnummer;
            }

            if (vertragsnummer !== undefined) {
                localVarQueryParameter['vertragsnummer'] = vertragsnummer;
            }

            if (kundennummer !== undefined) {
                localVarQueryParameter['kundennummer'] = kundennummer;
            }

            if (correlationId !== undefined) {
                localVarQueryParameter['correlationId'] = correlationId;
            }

            if (externeId !== undefined) {
                localVarQueryParameter['externeId'] = externeId;
            }

            if (vorgangType !== undefined) {
                localVarQueryParameter['vorgangType'] = vorgangType;
            }

            if (currentStep !== undefined) {
                localVarQueryParameter['currentStep'] = currentStep;
            }

            if (externerName !== undefined) {
                localVarQueryParameter['externerName'] = externerName;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (lockedBy !== undefined) {
                localVarQueryParameter['lockedBy'] = lockedBy;
            }

            if (fehlertyp !== undefined) {
                localVarQueryParameter['fehlertyp'] = fehlertyp;
            }

            if (dokumentTyp !== undefined) {
                localVarQueryParameter['dokumentTyp'] = dokumentTyp;
            }

            if (unterdrueckung !== undefined) {
                localVarQueryParameter['unterdrueckung'] = unterdrueckung;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (searchOperator !== undefined) {
                localVarQueryParameter['searchOperator'] = searchOperator;
            }

            if (stale24h !== undefined) {
                localVarQueryParameter['stale24h'] = stale24h;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (columns !== undefined) {
                localVarQueryParameter['columns'] = columns;
            }

            if (searchFields !== undefined) {
                localVarQueryParameter['searchFields'] = searchFields;
            }

            if (auftragsnummerOperator !== undefined) {
                localVarQueryParameter['auftragsnummerOperator'] = auftragsnummerOperator;
            }

            if (vertragsnummerOperator !== undefined) {
                localVarQueryParameter['vertragsnummerOperator'] = vertragsnummerOperator;
            }

            if (externerNameOperator !== undefined) {
                localVarQueryParameter['externerNameOperator'] = externerNameOperator;
            }

            if (dokumentTypOperator !== undefined) {
                localVarQueryParameter['dokumentTypOperator'] = dokumentTypOperator;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns status counts. Use scope=main for the cockpit start page, scope=archive for the archive view, scope=full for unfiltered active-table counts.
         * @summary Get Status Clustering
         * @param {GetVorgaengeStatusClusteringScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgaengeStatusClustering: async (scope?: GetVorgaengeStatusClusteringScopeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vorgaenge-status-clustering`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific vorgang item by ID
         * @summary Get specific vorgang item
         * @param {string | null} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgang: async (id: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVorgang', 'id', id)
            const localVarPath = `/vorgaenge/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lade Protokoll-Einträge (Kommentare) für einen Vorgang
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgangKommentare: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVorgangKommentare', 'id', id)
            const localVarPath = `/vorgaenge/{id}/kommentare`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Locks a specific vorgang item for editing by a user. If the item is already locked by another user, the lock can be overridden if the existing lock is older than 1 hour.
         * @summary Lock event for editing
         * @param {string} id 
         * @param {LockEventRequest} lockEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEvent: async (id: string, lockEventRequest: LockEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lockEvent', 'id', id)
            // verify required parameter 'lockEventRequest' is not null or undefined
            assertParamExists('lockEvent', 'lockEventRequest', lockEventRequest)
            const localVarPath = `/vorgaenge/{id}/lock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restores a previously deleted vorgang item by ID
         * @summary Restore vorgang item
         * @param {string} id 
         * @param {string} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreVorgang: async (id: string, user: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreVorgang', 'id', id)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('restoreVorgang', 'user', user)
            const localVarPath = `/vorgaenge/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retries processing of a specific vorgang item event
         * @summary Retry event processing
         * @param {string} id 
         * @param {RetryEventRequest} retryEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryEvent: async (id: string, retryEventRequest: RetryEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retryEvent', 'id', id)
            // verify required parameter 'retryEventRequest' is not null or undefined
            assertParamExists('retryEvent', 'retryEventRequest', retryEventRequest)
            const localVarPath = `/vorgaenge/{id}/retry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retryEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves modified event data for a specific vorgang item
         * @summary Save event data
         * @param {string} id 
         * @param {SaveEventRequest} saveEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvent: async (id: string, saveEventRequest: SaveEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('saveEvent', 'id', id)
            // verify required parameter 'saveEventRequest' is not null or undefined
            assertParamExists('saveEvent', 'saveEventRequest', saveEventRequest)
            const localVarPath = `/vorgaenge/{id}/save`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Setzt einen Vorgang mit einem Fehlerstatus zurück und legt einen Protokoll-Eintrag mit Kommentar an.
         * @summary Zurückstellen eines fehlerhaften Vorgangs
         * @param {string} id 
         * @param {string} user 
         * @param {StelleVorgangZurueckRequest} stelleVorgangZurueckRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stelleVorgangZurueck: async (id: string, user: string, stelleVorgangZurueckRequest: StelleVorgangZurueckRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stelleVorgangZurueck', 'id', id)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('stelleVorgangZurueck', 'user', user)
            // verify required parameter 'stelleVorgangZurueckRequest' is not null or undefined
            assertParamExists('stelleVorgangZurueck', 'stelleVorgangZurueckRequest', stelleVorgangZurueckRequest)
            const localVarPath = `/vorgaenge/{id}/zurueckstellungen`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stelleVorgangZurueckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlocks a specific vorgang item, making it available for editing by other users
         * @summary Unlock event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockEvent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unlockEvent', 'id', id)
            const localVarPath = `/vorgaenge/{id}/unlock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VorgngeApi - functional programming interface
 * @export
 */
export const VorgngeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VorgngeApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes multiple vorgang items by their IDs
         * @summary Bulk delete vorgang items
         * @param {BulkDeleteVorgaengeRequest} bulkDeleteVorgaengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteVorgaenge(bulkDeleteVorgaengeRequest: BulkDeleteVorgaengeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteVorgaenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteVorgaenge(bulkDeleteVorgaengeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.bulkDeleteVorgaenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retries processing of multiple vorgang items
         * @summary Bulk retry event processing
         * @param {BulkRetryVorgaengeRequest} bulkRetryVorgaengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkRetryVorgaenge(bulkRetryVorgaengeRequest: BulkRetryVorgaengeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteVorgaenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkRetryVorgaenge(bulkRetryVorgaengeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.bulkRetryVorgaenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stellt mehrere Vorgänge gleichzeitig zurück
         * @summary Bulk zurückstellen
         * @param {BulkZurueckstellenVorgaengeRequest} bulkZurueckstellenVorgaengeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkZurueckstellenVorgaenge(bulkZurueckstellenVorgaengeRequest: BulkZurueckstellenVorgaengeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteVorgaenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkZurueckstellenVorgaenge(bulkZurueckstellenVorgaengeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.bulkZurueckstellenVorgaenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a specific vorgang item by ID
         * @summary Delete vorgang item
         * @param {string} id 
         * @param {string | null} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVorgang(id: string, user: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVorgang(id, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.deleteVorgang']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exports the filtered and sorted Vorgänge as CSV and returns a presigned download URL which expires after 1 hour.
         * @summary Export Vorgaenge as CSV
         * @param {ExportVorgaengeArchivierungsstatusEnum} [archivierungsstatus] 
         * @param {string | null} [status] 
         * @param {string | null} [createdAtFrom] 
         * @param {string | null} [createdAtTo] 
         * @param {string | null} [currentGestartedAmFrom] 
         * @param {string | null} [currentGestartedAmTo] 
         * @param {string} [auftragsnummer] 
         * @param {string} [vertragsnummer] 
         * @param {string} [kundennummer] 
         * @param {string} [correlationId] 
         * @param {string} [externeId] 
         * @param {string} [vorgangType] 
         * @param {ExportVorgaengeCurrentStepEnum} [currentStep] 
         * @param {string} [externerName] 
         * @param {string} [error] 
         * @param {string} [lockedBy] 
         * @param {string | null} [fehlertyp] 
         * @param {string} [dokumentTyp] 
         * @param {string} [unterdrueckung] 
         * @param {string} [searchText] 
         * @param {ExportVorgaengeSearchOperatorEnum} [searchOperator] 
         * @param {ExportVorgaengeStale24hEnum} [stale24h] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {string | null} [sortBy] 
         * @param {ExportVorgaengeSortOrderEnum} [sortOrder] 
         * @param {string | null} [columns] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportVorgaenge(archivierungsstatus?: ExportVorgaengeArchivierungsstatusEnum, status?: string | null, createdAtFrom?: string | null, createdAtTo?: string | null, currentGestartedAmFrom?: string | null, currentGestartedAmTo?: string | null, auftragsnummer?: string, vertragsnummer?: string, kundennummer?: string, correlationId?: string, externeId?: string, vorgangType?: string, currentStep?: ExportVorgaengeCurrentStepEnum, externerName?: string, error?: string, lockedBy?: string, fehlertyp?: string | null, dokumentTyp?: string, unterdrueckung?: string, searchText?: string, searchOperator?: ExportVorgaengeSearchOperatorEnum, stale24h?: ExportVorgaengeStale24hEnum, offset?: string, limit?: string, sortBy?: string | null, sortOrder?: ExportVorgaengeSortOrderEnum, columns?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportVorgaenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportVorgaenge(archivierungsstatus, status, createdAtFrom, createdAtTo, currentGestartedAmFrom, currentGestartedAmTo, auftragsnummer, vertragsnummer, kundennummer, correlationId, externeId, vorgangType, currentStep, externerName, error, lockedBy, fehlertyp, dokumentTyp, unterdrueckung, searchText, searchOperator, stale24h, offset, limit, sortBy, sortOrder, columns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.exportVorgaenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exports filtered and sorted rows from the archive (same query shape as GET /vorgaenge-archiv) as CSV; returns a presigned download URL.
         * @summary Export archived Vorgänge as CSV
         * @param {ExportVorgaengeArchivArchivierungsstatusEnum} [archivierungsstatus] 
         * @param {string} [status] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {string} [currentGestartedAmFrom] 
         * @param {string} [currentGestartedAmTo] 
         * @param {string} [auftragsnummer] 
         * @param {string} [vertragsnummer] 
         * @param {string} [kundennummer] 
         * @param {string} [correlationId] 
         * @param {string} [externeId] 
         * @param {string} [vorgangType] 
         * @param {ExportVorgaengeArchivCurrentStepEnum} [currentStep] 
         * @param {string} [externerName] 
         * @param {string} [error] 
         * @param {string} [lockedBy] 
         * @param {string} [fehlertyp] 
         * @param {string} [dokumentTyp] 
         * @param {string} [unterdrueckung] 
         * @param {string} [searchText] 
         * @param {ExportVorgaengeArchivSearchOperatorEnum} [searchOperator] 
         * @param {ExportVorgaengeArchivStale24hEnum} [stale24h] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {string} [sortBy] 
         * @param {ExportVorgaengeArchivSortOrderEnum} [sortOrder] 
         * @param {string} [columns] 
         * @param {string} [searchFields] 
         * @param {ExportVorgaengeArchivAuftragsnummerOperatorEnum} [auftragsnummerOperator] 
         * @param {ExportVorgaengeArchivVertragsnummerOperatorEnum} [vertragsnummerOperator] 
         * @param {ExportVorgaengeArchivExternerNameOperatorEnum} [externerNameOperator] 
         * @param {ExportVorgaengeArchivDokumentTypOperatorEnum} [dokumentTypOperator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportVorgaengeArchiv(archivierungsstatus?: ExportVorgaengeArchivArchivierungsstatusEnum, status?: string, createdAtFrom?: string, createdAtTo?: string, currentGestartedAmFrom?: string, currentGestartedAmTo?: string, auftragsnummer?: string, vertragsnummer?: string, kundennummer?: string, correlationId?: string, externeId?: string, vorgangType?: string, currentStep?: ExportVorgaengeArchivCurrentStepEnum, externerName?: string, error?: string, lockedBy?: string, fehlertyp?: string, dokumentTyp?: string, unterdrueckung?: string, searchText?: string, searchOperator?: ExportVorgaengeArchivSearchOperatorEnum, stale24h?: ExportVorgaengeArchivStale24hEnum, offset?: string, limit?: string, sortBy?: string, sortOrder?: ExportVorgaengeArchivSortOrderEnum, columns?: string, searchFields?: string, auftragsnummerOperator?: ExportVorgaengeArchivAuftragsnummerOperatorEnum, vertragsnummerOperator?: ExportVorgaengeArchivVertragsnummerOperatorEnum, externerNameOperator?: ExportVorgaengeArchivExternerNameOperatorEnum, dokumentTypOperator?: ExportVorgaengeArchivDokumentTypOperatorEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportVorgaenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportVorgaengeArchiv(archivierungsstatus, status, createdAtFrom, createdAtTo, currentGestartedAmFrom, currentGestartedAmTo, auftragsnummer, vertragsnummer, kundennummer, correlationId, externeId, vorgangType, currentStep, externerName, error, lockedBy, fehlertyp, dokumentTyp, unterdrueckung, searchText, searchOperator, stale24h, offset, limit, sortBy, sortOrder, columns, searchFields, auftragsnummerOperator, vertragsnummerOperator, externerNameOperator, dokumentTypOperator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.exportVorgaengeArchiv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an array of vorgänge containing event data and optional document information
         * @summary Get Vorgänge
         * @param {GetVorgaengeArchivierungsstatusEnum} [archivierungsstatus] 
         * @param {string} [status] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {string} [currentGestartedAmFrom] 
         * @param {string} [currentGestartedAmTo] 
         * @param {string} [auftragsnummer] 
         * @param {string} [vertragsnummer] 
         * @param {string} [kundennummer] 
         * @param {string} [correlationId] 
         * @param {string} [externeId] 
         * @param {string} [vorgangType] 
         * @param {GetVorgaengeCurrentStepEnum} [currentStep] 
         * @param {string} [externerName] 
         * @param {string} [error] 
         * @param {string} [lockedBy] 
         * @param {string} [fehlertyp] 
         * @param {string} [dokumentTyp] 
         * @param {string} [unterdrueckung] 
         * @param {string} [searchText] 
         * @param {GetVorgaengeSearchOperatorEnum} [searchOperator] 
         * @param {GetVorgaengeStale24hEnum} [stale24h] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {string} [sortBy] 
         * @param {GetVorgaengeSortOrderEnum} [sortOrder] 
         * @param {string} [columns] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVorgaenge(archivierungsstatus?: GetVorgaengeArchivierungsstatusEnum, status?: string, createdAtFrom?: string, createdAtTo?: string, currentGestartedAmFrom?: string, currentGestartedAmTo?: string, auftragsnummer?: string, vertragsnummer?: string, kundennummer?: string, correlationId?: string, externeId?: string, vorgangType?: string, currentStep?: GetVorgaengeCurrentStepEnum, externerName?: string, error?: string, lockedBy?: string, fehlertyp?: string, dokumentTyp?: string, unterdrueckung?: string, searchText?: string, searchOperator?: GetVorgaengeSearchOperatorEnum, stale24h?: GetVorgaengeStale24hEnum, offset?: string, limit?: string, sortBy?: string, sortOrder?: GetVorgaengeSortOrderEnum, columns?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVorgaenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVorgaenge(archivierungsstatus, status, createdAtFrom, createdAtTo, currentGestartedAmFrom, currentGestartedAmTo, auftragsnummer, vertragsnummer, kundennummer, correlationId, externeId, vorgangType, currentStep, externerName, error, lockedBy, fehlertyp, dokumentTyp, unterdrueckung, searchText, searchOperator, stale24h, offset, limit, sortBy, sortOrder, columns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.getVorgaenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns counts of non-deleted Vorgänge in status WARTEND or LAUFEND that have exceeded the configured staleness threshold in their current process step.
         * @summary Get stale Vorgang alerting counts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVorgaengeAlerting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVorgaengeAlerting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVorgaengeAlerting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.getVorgaengeAlerting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns completed and soft-deleted Vorgänge from archive storage with the same filters as the main list.
         * @summary Get archived Vorgänge
         * @param {GetVorgaengeArchivArchivierungsstatusEnum} [archivierungsstatus] 
         * @param {string} [status] 
         * @param {string} [createdAtFrom] 
         * @param {string} [createdAtTo] 
         * @param {string} [currentGestartedAmFrom] 
         * @param {string} [currentGestartedAmTo] 
         * @param {string} [auftragsnummer] 
         * @param {string} [vertragsnummer] 
         * @param {string} [kundennummer] 
         * @param {string} [correlationId] 
         * @param {string} [externeId] 
         * @param {string} [vorgangType] 
         * @param {GetVorgaengeArchivCurrentStepEnum} [currentStep] 
         * @param {string} [externerName] 
         * @param {string} [error] 
         * @param {string} [lockedBy] 
         * @param {string} [fehlertyp] 
         * @param {string} [dokumentTyp] 
         * @param {string} [unterdrueckung] 
         * @param {string} [searchText] 
         * @param {GetVorgaengeArchivSearchOperatorEnum} [searchOperator] 
         * @param {GetVorgaengeArchivStale24hEnum} [stale24h] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {string} [sortBy] 
         * @param {GetVorgaengeArchivSortOrderEnum} [sortOrder] 
         * @param {string} [columns] 
         * @param {string | null} [searchFields] 
         * @param {GetVorgaengeArchivAuftragsnummerOperatorEnum} [auftragsnummerOperator] 
         * @param {GetVorgaengeArchivVertragsnummerOperatorEnum} [vertragsnummerOperator] 
         * @param {GetVorgaengeArchivExternerNameOperatorEnum} [externerNameOperator] 
         * @param {GetVorgaengeArchivDokumentTypOperatorEnum} [dokumentTypOperator] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVorgaengeArchiv(archivierungsstatus?: GetVorgaengeArchivArchivierungsstatusEnum, status?: string, createdAtFrom?: string, createdAtTo?: string, currentGestartedAmFrom?: string, currentGestartedAmTo?: string, auftragsnummer?: string, vertragsnummer?: string, kundennummer?: string, correlationId?: string, externeId?: string, vorgangType?: string, currentStep?: GetVorgaengeArchivCurrentStepEnum, externerName?: string, error?: string, lockedBy?: string, fehlertyp?: string, dokumentTyp?: string, unterdrueckung?: string, searchText?: string, searchOperator?: GetVorgaengeArchivSearchOperatorEnum, stale24h?: GetVorgaengeArchivStale24hEnum, offset?: string, limit?: string, sortBy?: string, sortOrder?: GetVorgaengeArchivSortOrderEnum, columns?: string, searchFields?: string | null, auftragsnummerOperator?: GetVorgaengeArchivAuftragsnummerOperatorEnum, vertragsnummerOperator?: GetVorgaengeArchivVertragsnummerOperatorEnum, externerNameOperator?: GetVorgaengeArchivExternerNameOperatorEnum, dokumentTypOperator?: GetVorgaengeArchivDokumentTypOperatorEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVorgaenge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVorgaengeArchiv(archivierungsstatus, status, createdAtFrom, createdAtTo, currentGestartedAmFrom, currentGestartedAmTo, auftragsnummer, vertragsnummer, kundennummer, correlationId, externeId, vorgangType, currentStep, externerName, error, lockedBy, fehlertyp, dokumentTyp, unterdrueckung, searchText, searchOperator, stale24h, offset, limit, sortBy, sortOrder, columns, searchFields, auftragsnummerOperator, vertragsnummerOperator, externerNameOperator, dokumentTypOperator, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.getVorgaengeArchiv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns status counts. Use scope=main for the cockpit start page, scope=archive for the archive view, scope=full for unfiltered active-table counts.
         * @summary Get Status Clustering
         * @param {GetVorgaengeStatusClusteringScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVorgaengeStatusClustering(scope?: GetVorgaengeStatusClusteringScopeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVorgaengeStatusClustering200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVorgaengeStatusClustering(scope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.getVorgaengeStatusClustering']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific vorgang item by ID
         * @summary Get specific vorgang item
         * @param {string | null} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVorgang(id: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVorgang200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVorgang(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.getVorgang']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lade Protokoll-Einträge (Kommentare) für einen Vorgang
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVorgangKommentare(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetVorgangKommentare200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVorgangKommentare(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.getVorgangKommentare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Locks a specific vorgang item for editing by a user. If the item is already locked by another user, the lock can be overridden if the existing lock is older than 1 hour.
         * @summary Lock event for editing
         * @param {string} id 
         * @param {LockEventRequest} lockEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockEvent(id: string, lockEventRequest: LockEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockEvent(id, lockEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.lockEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restores a previously deleted vorgang item by ID
         * @summary Restore vorgang item
         * @param {string} id 
         * @param {string} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreVorgang(id: string, user: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreVorgang(id, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.restoreVorgang']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retries processing of a specific vorgang item event
         * @summary Retry event processing
         * @param {string} id 
         * @param {RetryEventRequest} retryEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryEvent(id: string, retryEventRequest: RetryEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryEvent(id, retryEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.retryEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves modified event data for a specific vorgang item
         * @summary Save event data
         * @param {string} id 
         * @param {SaveEventRequest} saveEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEvent(id: string, saveEventRequest: SaveEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEvent(id, saveEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.saveEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Setzt einen Vorgang mit einem Fehlerstatus zurück und legt einen Protokoll-Eintrag mit Kommentar an.
         * @summary Zurückstellen eines fehlerhaften Vorgangs
         * @param {string} id 
         * @param {string} user 
         * @param {StelleVorgangZurueckRequest} stelleVorgangZurueckRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stelleVorgangZurueck(id: string, user: string, stelleVorgangZurueckRequest: StelleVorgangZurueckRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stelleVorgangZurueck(id, user, stelleVorgangZurueckRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.stelleVorgangZurueck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unlocks a specific vorgang item, making it available for editing by other users
         * @summary Unlock event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockEvent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VorgngeApi.unlockEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VorgngeApi - factory interface
 * @export
 */
export const VorgngeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VorgngeApiFp(configuration)
    return {
        /**
         * Deletes multiple vorgang items by their IDs
         * @summary Bulk delete vorgang items
         * @param {VorgngeApiBulkDeleteVorgaengeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteVorgaenge(requestParameters: VorgngeApiBulkDeleteVorgaengeRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDeleteVorgaenge200Response> {
            return localVarFp.bulkDeleteVorgaenge(requestParameters.bulkDeleteVorgaengeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retries processing of multiple vorgang items
         * @summary Bulk retry event processing
         * @param {VorgngeApiBulkRetryVorgaengeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRetryVorgaenge(requestParameters: VorgngeApiBulkRetryVorgaengeRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDeleteVorgaenge200Response> {
            return localVarFp.bulkRetryVorgaenge(requestParameters.bulkRetryVorgaengeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Stellt mehrere Vorgänge gleichzeitig zurück
         * @summary Bulk zurückstellen
         * @param {VorgngeApiBulkZurueckstellenVorgaengeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkZurueckstellenVorgaenge(requestParameters: VorgngeApiBulkZurueckstellenVorgaengeRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDeleteVorgaenge200Response> {
            return localVarFp.bulkZurueckstellenVorgaenge(requestParameters.bulkZurueckstellenVorgaengeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a specific vorgang item by ID
         * @summary Delete vorgang item
         * @param {VorgngeApiDeleteVorgangRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVorgang(requestParameters: VorgngeApiDeleteVorgangRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVorgang(requestParameters.id, requestParameters.user, options).then((request) => request(axios, basePath));
        },
        /**
         * Exports the filtered and sorted Vorgänge as CSV and returns a presigned download URL which expires after 1 hour.
         * @summary Export Vorgaenge as CSV
         * @param {VorgngeApiExportVorgaengeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportVorgaenge(requestParameters: VorgngeApiExportVorgaengeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExportVorgaenge200Response> {
            return localVarFp.exportVorgaenge(requestParameters.archivierungsstatus, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.currentGestartedAmFrom, requestParameters.currentGestartedAmTo, requestParameters.auftragsnummer, requestParameters.vertragsnummer, requestParameters.kundennummer, requestParameters.correlationId, requestParameters.externeId, requestParameters.vorgangType, requestParameters.currentStep, requestParameters.externerName, requestParameters.error, requestParameters.lockedBy, requestParameters.fehlertyp, requestParameters.dokumentTyp, requestParameters.unterdrueckung, requestParameters.searchText, requestParameters.searchOperator, requestParameters.stale24h, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.columns, options).then((request) => request(axios, basePath));
        },
        /**
         * Exports filtered and sorted rows from the archive (same query shape as GET /vorgaenge-archiv) as CSV; returns a presigned download URL.
         * @summary Export archived Vorgänge as CSV
         * @param {VorgngeApiExportVorgaengeArchivRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportVorgaengeArchiv(requestParameters: VorgngeApiExportVorgaengeArchivRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExportVorgaenge200Response> {
            return localVarFp.exportVorgaengeArchiv(requestParameters.archivierungsstatus, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.currentGestartedAmFrom, requestParameters.currentGestartedAmTo, requestParameters.auftragsnummer, requestParameters.vertragsnummer, requestParameters.kundennummer, requestParameters.correlationId, requestParameters.externeId, requestParameters.vorgangType, requestParameters.currentStep, requestParameters.externerName, requestParameters.error, requestParameters.lockedBy, requestParameters.fehlertyp, requestParameters.dokumentTyp, requestParameters.unterdrueckung, requestParameters.searchText, requestParameters.searchOperator, requestParameters.stale24h, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.columns, requestParameters.searchFields, requestParameters.auftragsnummerOperator, requestParameters.vertragsnummerOperator, requestParameters.externerNameOperator, requestParameters.dokumentTypOperator, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an array of vorgänge containing event data and optional document information
         * @summary Get Vorgänge
         * @param {VorgngeApiGetVorgaengeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgaenge(requestParameters: VorgngeApiGetVorgaengeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetVorgaenge200Response> {
            return localVarFp.getVorgaenge(requestParameters.archivierungsstatus, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.currentGestartedAmFrom, requestParameters.currentGestartedAmTo, requestParameters.auftragsnummer, requestParameters.vertragsnummer, requestParameters.kundennummer, requestParameters.correlationId, requestParameters.externeId, requestParameters.vorgangType, requestParameters.currentStep, requestParameters.externerName, requestParameters.error, requestParameters.lockedBy, requestParameters.fehlertyp, requestParameters.dokumentTyp, requestParameters.unterdrueckung, requestParameters.searchText, requestParameters.searchOperator, requestParameters.stale24h, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.columns, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns counts of non-deleted Vorgänge in status WARTEND or LAUFEND that have exceeded the configured staleness threshold in their current process step.
         * @summary Get stale Vorgang alerting counts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgaengeAlerting(options?: RawAxiosRequestConfig): AxiosPromise<GetVorgaengeAlerting200Response> {
            return localVarFp.getVorgaengeAlerting(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns completed and soft-deleted Vorgänge from archive storage with the same filters as the main list.
         * @summary Get archived Vorgänge
         * @param {VorgngeApiGetVorgaengeArchivRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgaengeArchiv(requestParameters: VorgngeApiGetVorgaengeArchivRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetVorgaenge200Response> {
            return localVarFp.getVorgaengeArchiv(requestParameters.archivierungsstatus, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.currentGestartedAmFrom, requestParameters.currentGestartedAmTo, requestParameters.auftragsnummer, requestParameters.vertragsnummer, requestParameters.kundennummer, requestParameters.correlationId, requestParameters.externeId, requestParameters.vorgangType, requestParameters.currentStep, requestParameters.externerName, requestParameters.error, requestParameters.lockedBy, requestParameters.fehlertyp, requestParameters.dokumentTyp, requestParameters.unterdrueckung, requestParameters.searchText, requestParameters.searchOperator, requestParameters.stale24h, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.columns, requestParameters.searchFields, requestParameters.auftragsnummerOperator, requestParameters.vertragsnummerOperator, requestParameters.externerNameOperator, requestParameters.dokumentTypOperator, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns status counts. Use scope=main for the cockpit start page, scope=archive for the archive view, scope=full for unfiltered active-table counts.
         * @summary Get Status Clustering
         * @param {VorgngeApiGetVorgaengeStatusClusteringRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgaengeStatusClustering(requestParameters: VorgngeApiGetVorgaengeStatusClusteringRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetVorgaengeStatusClustering200Response> {
            return localVarFp.getVorgaengeStatusClustering(requestParameters.scope, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific vorgang item by ID
         * @summary Get specific vorgang item
         * @param {VorgngeApiGetVorgangRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgang(requestParameters: VorgngeApiGetVorgangRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetVorgang200Response> {
            return localVarFp.getVorgang(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lade Protokoll-Einträge (Kommentare) für einen Vorgang
         * @param {VorgngeApiGetVorgangKommentareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVorgangKommentare(requestParameters: VorgngeApiGetVorgangKommentareRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetVorgangKommentare200ResponseInner>> {
            return localVarFp.getVorgangKommentare(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Locks a specific vorgang item for editing by a user. If the item is already locked by another user, the lock can be overridden if the existing lock is older than 1 hour.
         * @summary Lock event for editing
         * @param {VorgngeApiLockEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockEvent(requestParameters: VorgngeApiLockEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.lockEvent(requestParameters.id, requestParameters.lockEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Restores a previously deleted vorgang item by ID
         * @summary Restore vorgang item
         * @param {VorgngeApiRestoreVorgangRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreVorgang(requestParameters: VorgngeApiRestoreVorgangRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreVorgang(requestParameters.id, requestParameters.user, options).then((request) => request(axios, basePath));
        },
        /**
         * Retries processing of a specific vorgang item event
         * @summary Retry event processing
         * @param {VorgngeApiRetryEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryEvent(requestParameters: VorgngeApiRetryEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.retryEvent(requestParameters.id, requestParameters.retryEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Saves modified event data for a specific vorgang item
         * @summary Save event data
         * @param {VorgngeApiSaveEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEvent(requestParameters: VorgngeApiSaveEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveEvent(requestParameters.id, requestParameters.saveEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Setzt einen Vorgang mit einem Fehlerstatus zurück und legt einen Protokoll-Eintrag mit Kommentar an.
         * @summary Zurückstellen eines fehlerhaften Vorgangs
         * @param {VorgngeApiStelleVorgangZurueckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stelleVorgangZurueck(requestParameters: VorgngeApiStelleVorgangZurueckRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stelleVorgangZurueck(requestParameters.id, requestParameters.user, requestParameters.stelleVorgangZurueckRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Unlocks a specific vorgang item, making it available for editing by other users
         * @summary Unlock event
         * @param {VorgngeApiUnlockEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockEvent(requestParameters: VorgngeApiUnlockEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlockEvent(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkDeleteVorgaenge operation in VorgngeApi.
 * @export
 * @interface VorgngeApiBulkDeleteVorgaengeRequest
 */
export interface VorgngeApiBulkDeleteVorgaengeRequest {
    /**
     * 
     * @type {BulkDeleteVorgaengeRequest}
     * @memberof VorgngeApiBulkDeleteVorgaenge
     */
    readonly bulkDeleteVorgaengeRequest: BulkDeleteVorgaengeRequest
}

/**
 * Request parameters for bulkRetryVorgaenge operation in VorgngeApi.
 * @export
 * @interface VorgngeApiBulkRetryVorgaengeRequest
 */
export interface VorgngeApiBulkRetryVorgaengeRequest {
    /**
     * 
     * @type {BulkRetryVorgaengeRequest}
     * @memberof VorgngeApiBulkRetryVorgaenge
     */
    readonly bulkRetryVorgaengeRequest: BulkRetryVorgaengeRequest
}

/**
 * Request parameters for bulkZurueckstellenVorgaenge operation in VorgngeApi.
 * @export
 * @interface VorgngeApiBulkZurueckstellenVorgaengeRequest
 */
export interface VorgngeApiBulkZurueckstellenVorgaengeRequest {
    /**
     * 
     * @type {BulkZurueckstellenVorgaengeRequest}
     * @memberof VorgngeApiBulkZurueckstellenVorgaenge
     */
    readonly bulkZurueckstellenVorgaengeRequest: BulkZurueckstellenVorgaengeRequest
}

/**
 * Request parameters for deleteVorgang operation in VorgngeApi.
 * @export
 * @interface VorgngeApiDeleteVorgangRequest
 */
export interface VorgngeApiDeleteVorgangRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiDeleteVorgang
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiDeleteVorgang
     */
    readonly user: string | null
}

/**
 * Request parameters for exportVorgaenge operation in VorgngeApi.
 * @export
 * @interface VorgngeApiExportVorgaengeRequest
 */
export interface VorgngeApiExportVorgaengeRequest {
    /**
     * 
     * @type {'ERFOLGREICH' | 'UEBERSPRUNGEN'}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly archivierungsstatus?: ExportVorgaengeArchivierungsstatusEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly status?: string | null

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly createdAtFrom?: string | null

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly createdAtTo?: string | null

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly currentGestartedAmFrom?: string | null

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly currentGestartedAmTo?: string | null

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly auftragsnummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly vertragsnummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly kundennummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly correlationId?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly externeId?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly vorgangType?: string

    /**
     * 
     * @type {'TRANSFORMATION' | 'FACHLICHE_VALIDIERUNG' | 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER' | 'ANTWORT_VON_DOKUMENTDIENSTLEISTER' | 'ARCHIVIERUNG' | 'EMAIL_VERSAND' | 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER' | 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly currentStep?: ExportVorgaengeCurrentStepEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly externerName?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly error?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly lockedBy?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly fehlertyp?: string | null

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly dokumentTyp?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly unterdrueckung?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly searchText?: string

    /**
     * 
     * @type {'equals' | 'contains' | 'not_contains'}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly searchOperator?: ExportVorgaengeSearchOperatorEnum

    /**
     * 
     * @type {'true'}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly stale24h?: ExportVorgaengeStale24hEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly offset?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly sortBy?: string | null

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly sortOrder?: ExportVorgaengeSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaenge
     */
    readonly columns?: string | null
}

/**
 * Request parameters for exportVorgaengeArchiv operation in VorgngeApi.
 * @export
 * @interface VorgngeApiExportVorgaengeArchivRequest
 */
export interface VorgngeApiExportVorgaengeArchivRequest {
    /**
     * 
     * @type {'ERFOLGREICH' | 'UEBERSPRUNGEN'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly archivierungsstatus?: ExportVorgaengeArchivArchivierungsstatusEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly createdAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly createdAtTo?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly currentGestartedAmFrom?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly currentGestartedAmTo?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly auftragsnummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly vertragsnummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly kundennummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly correlationId?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly externeId?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly vorgangType?: string

    /**
     * 
     * @type {'TRANSFORMATION' | 'FACHLICHE_VALIDIERUNG' | 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER' | 'ANTWORT_VON_DOKUMENTDIENSTLEISTER' | 'ARCHIVIERUNG' | 'EMAIL_VERSAND' | 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER' | 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly currentStep?: ExportVorgaengeArchivCurrentStepEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly externerName?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly error?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly lockedBy?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly fehlertyp?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly dokumentTyp?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly unterdrueckung?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly searchText?: string

    /**
     * 
     * @type {'equals' | 'contains' | 'not_contains'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly searchOperator?: ExportVorgaengeArchivSearchOperatorEnum

    /**
     * 
     * @type {'true'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly stale24h?: ExportVorgaengeArchivStale24hEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly offset?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly sortBy?: string

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly sortOrder?: ExportVorgaengeArchivSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly columns?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly searchFields?: string

    /**
     * 
     * @type {'contains' | 'equals'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly auftragsnummerOperator?: ExportVorgaengeArchivAuftragsnummerOperatorEnum

    /**
     * 
     * @type {'contains' | 'equals'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly vertragsnummerOperator?: ExportVorgaengeArchivVertragsnummerOperatorEnum

    /**
     * 
     * @type {'contains' | 'equals'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly externerNameOperator?: ExportVorgaengeArchivExternerNameOperatorEnum

    /**
     * 
     * @type {'contains' | 'equals'}
     * @memberof VorgngeApiExportVorgaengeArchiv
     */
    readonly dokumentTypOperator?: ExportVorgaengeArchivDokumentTypOperatorEnum
}

/**
 * Request parameters for getVorgaenge operation in VorgngeApi.
 * @export
 * @interface VorgngeApiGetVorgaengeRequest
 */
export interface VorgngeApiGetVorgaengeRequest {
    /**
     * 
     * @type {'ERFOLGREICH' | 'UEBERSPRUNGEN'}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly archivierungsstatus?: GetVorgaengeArchivierungsstatusEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly createdAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly createdAtTo?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly currentGestartedAmFrom?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly currentGestartedAmTo?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly auftragsnummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly vertragsnummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly kundennummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly correlationId?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly externeId?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly vorgangType?: string

    /**
     * 
     * @type {'TRANSFORMATION' | 'FACHLICHE_VALIDIERUNG' | 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER' | 'ANTWORT_VON_DOKUMENTDIENSTLEISTER' | 'ARCHIVIERUNG' | 'EMAIL_VERSAND' | 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER' | 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly currentStep?: GetVorgaengeCurrentStepEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly externerName?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly error?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly lockedBy?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly fehlertyp?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly dokumentTyp?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly unterdrueckung?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly searchText?: string

    /**
     * 
     * @type {'equals' | 'contains' | 'not_contains'}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly searchOperator?: GetVorgaengeSearchOperatorEnum

    /**
     * 
     * @type {'true'}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly stale24h?: GetVorgaengeStale24hEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly offset?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly sortBy?: string

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly sortOrder?: GetVorgaengeSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaenge
     */
    readonly columns?: string
}

/**
 * Request parameters for getVorgaengeArchiv operation in VorgngeApi.
 * @export
 * @interface VorgngeApiGetVorgaengeArchivRequest
 */
export interface VorgngeApiGetVorgaengeArchivRequest {
    /**
     * 
     * @type {'ERFOLGREICH' | 'UEBERSPRUNGEN'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly archivierungsstatus?: GetVorgaengeArchivArchivierungsstatusEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly createdAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly createdAtTo?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly currentGestartedAmFrom?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly currentGestartedAmTo?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly auftragsnummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly vertragsnummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly kundennummer?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly correlationId?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly externeId?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly vorgangType?: string

    /**
     * 
     * @type {'TRANSFORMATION' | 'FACHLICHE_VALIDIERUNG' | 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER' | 'ANTWORT_VON_DOKUMENTDIENSTLEISTER' | 'ARCHIVIERUNG' | 'EMAIL_VERSAND' | 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER' | 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly currentStep?: GetVorgaengeArchivCurrentStepEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly externerName?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly error?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly lockedBy?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly fehlertyp?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly dokumentTyp?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly unterdrueckung?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly searchText?: string

    /**
     * 
     * @type {'equals' | 'contains' | 'not_contains'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly searchOperator?: GetVorgaengeArchivSearchOperatorEnum

    /**
     * 
     * @type {'true'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly stale24h?: GetVorgaengeArchivStale24hEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly offset?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly sortBy?: string

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly sortOrder?: GetVorgaengeArchivSortOrderEnum

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly columns?: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly searchFields?: string | null

    /**
     * 
     * @type {'contains' | 'equals'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly auftragsnummerOperator?: GetVorgaengeArchivAuftragsnummerOperatorEnum

    /**
     * 
     * @type {'contains' | 'equals'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly vertragsnummerOperator?: GetVorgaengeArchivVertragsnummerOperatorEnum

    /**
     * 
     * @type {'contains' | 'equals'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly externerNameOperator?: GetVorgaengeArchivExternerNameOperatorEnum

    /**
     * 
     * @type {'contains' | 'equals'}
     * @memberof VorgngeApiGetVorgaengeArchiv
     */
    readonly dokumentTypOperator?: GetVorgaengeArchivDokumentTypOperatorEnum
}

/**
 * Request parameters for getVorgaengeStatusClustering operation in VorgngeApi.
 * @export
 * @interface VorgngeApiGetVorgaengeStatusClusteringRequest
 */
export interface VorgngeApiGetVorgaengeStatusClusteringRequest {
    /**
     * 
     * @type {'main' | 'archive' | 'full'}
     * @memberof VorgngeApiGetVorgaengeStatusClustering
     */
    readonly scope?: GetVorgaengeStatusClusteringScopeEnum
}

/**
 * Request parameters for getVorgang operation in VorgngeApi.
 * @export
 * @interface VorgngeApiGetVorgangRequest
 */
export interface VorgngeApiGetVorgangRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgang
     */
    readonly id: string | null
}

/**
 * Request parameters for getVorgangKommentare operation in VorgngeApi.
 * @export
 * @interface VorgngeApiGetVorgangKommentareRequest
 */
export interface VorgngeApiGetVorgangKommentareRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiGetVorgangKommentare
     */
    readonly id: string
}

/**
 * Request parameters for lockEvent operation in VorgngeApi.
 * @export
 * @interface VorgngeApiLockEventRequest
 */
export interface VorgngeApiLockEventRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiLockEvent
     */
    readonly id: string

    /**
     * 
     * @type {LockEventRequest}
     * @memberof VorgngeApiLockEvent
     */
    readonly lockEventRequest: LockEventRequest
}

/**
 * Request parameters for restoreVorgang operation in VorgngeApi.
 * @export
 * @interface VorgngeApiRestoreVorgangRequest
 */
export interface VorgngeApiRestoreVorgangRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiRestoreVorgang
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiRestoreVorgang
     */
    readonly user: string
}

/**
 * Request parameters for retryEvent operation in VorgngeApi.
 * @export
 * @interface VorgngeApiRetryEventRequest
 */
export interface VorgngeApiRetryEventRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiRetryEvent
     */
    readonly id: string

    /**
     * 
     * @type {RetryEventRequest}
     * @memberof VorgngeApiRetryEvent
     */
    readonly retryEventRequest: RetryEventRequest
}

/**
 * Request parameters for saveEvent operation in VorgngeApi.
 * @export
 * @interface VorgngeApiSaveEventRequest
 */
export interface VorgngeApiSaveEventRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiSaveEvent
     */
    readonly id: string

    /**
     * 
     * @type {SaveEventRequest}
     * @memberof VorgngeApiSaveEvent
     */
    readonly saveEventRequest: SaveEventRequest
}

/**
 * Request parameters for stelleVorgangZurueck operation in VorgngeApi.
 * @export
 * @interface VorgngeApiStelleVorgangZurueckRequest
 */
export interface VorgngeApiStelleVorgangZurueckRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiStelleVorgangZurueck
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof VorgngeApiStelleVorgangZurueck
     */
    readonly user: string

    /**
     * 
     * @type {StelleVorgangZurueckRequest}
     * @memberof VorgngeApiStelleVorgangZurueck
     */
    readonly stelleVorgangZurueckRequest: StelleVorgangZurueckRequest
}

/**
 * Request parameters for unlockEvent operation in VorgngeApi.
 * @export
 * @interface VorgngeApiUnlockEventRequest
 */
export interface VorgngeApiUnlockEventRequest {
    /**
     * 
     * @type {string}
     * @memberof VorgngeApiUnlockEvent
     */
    readonly id: string
}

/**
 * VorgngeApi - object-oriented interface
 * @export
 * @class VorgngeApi
 * @extends {BaseAPI}
 */
export class VorgngeApi extends BaseAPI {
    /**
     * Deletes multiple vorgang items by their IDs
     * @summary Bulk delete vorgang items
     * @param {VorgngeApiBulkDeleteVorgaengeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public bulkDeleteVorgaenge(requestParameters: VorgngeApiBulkDeleteVorgaengeRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).bulkDeleteVorgaenge(requestParameters.bulkDeleteVorgaengeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retries processing of multiple vorgang items
     * @summary Bulk retry event processing
     * @param {VorgngeApiBulkRetryVorgaengeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public bulkRetryVorgaenge(requestParameters: VorgngeApiBulkRetryVorgaengeRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).bulkRetryVorgaenge(requestParameters.bulkRetryVorgaengeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stellt mehrere Vorgänge gleichzeitig zurück
     * @summary Bulk zurückstellen
     * @param {VorgngeApiBulkZurueckstellenVorgaengeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public bulkZurueckstellenVorgaenge(requestParameters: VorgngeApiBulkZurueckstellenVorgaengeRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).bulkZurueckstellenVorgaenge(requestParameters.bulkZurueckstellenVorgaengeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a specific vorgang item by ID
     * @summary Delete vorgang item
     * @param {VorgngeApiDeleteVorgangRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public deleteVorgang(requestParameters: VorgngeApiDeleteVorgangRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).deleteVorgang(requestParameters.id, requestParameters.user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exports the filtered and sorted Vorgänge as CSV and returns a presigned download URL which expires after 1 hour.
     * @summary Export Vorgaenge as CSV
     * @param {VorgngeApiExportVorgaengeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public exportVorgaenge(requestParameters: VorgngeApiExportVorgaengeRequest = {}, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).exportVorgaenge(requestParameters.archivierungsstatus, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.currentGestartedAmFrom, requestParameters.currentGestartedAmTo, requestParameters.auftragsnummer, requestParameters.vertragsnummer, requestParameters.kundennummer, requestParameters.correlationId, requestParameters.externeId, requestParameters.vorgangType, requestParameters.currentStep, requestParameters.externerName, requestParameters.error, requestParameters.lockedBy, requestParameters.fehlertyp, requestParameters.dokumentTyp, requestParameters.unterdrueckung, requestParameters.searchText, requestParameters.searchOperator, requestParameters.stale24h, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.columns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exports filtered and sorted rows from the archive (same query shape as GET /vorgaenge-archiv) as CSV; returns a presigned download URL.
     * @summary Export archived Vorgänge as CSV
     * @param {VorgngeApiExportVorgaengeArchivRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public exportVorgaengeArchiv(requestParameters: VorgngeApiExportVorgaengeArchivRequest = {}, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).exportVorgaengeArchiv(requestParameters.archivierungsstatus, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.currentGestartedAmFrom, requestParameters.currentGestartedAmTo, requestParameters.auftragsnummer, requestParameters.vertragsnummer, requestParameters.kundennummer, requestParameters.correlationId, requestParameters.externeId, requestParameters.vorgangType, requestParameters.currentStep, requestParameters.externerName, requestParameters.error, requestParameters.lockedBy, requestParameters.fehlertyp, requestParameters.dokumentTyp, requestParameters.unterdrueckung, requestParameters.searchText, requestParameters.searchOperator, requestParameters.stale24h, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.columns, requestParameters.searchFields, requestParameters.auftragsnummerOperator, requestParameters.vertragsnummerOperator, requestParameters.externerNameOperator, requestParameters.dokumentTypOperator, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an array of vorgänge containing event data and optional document information
     * @summary Get Vorgänge
     * @param {VorgngeApiGetVorgaengeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public getVorgaenge(requestParameters: VorgngeApiGetVorgaengeRequest = {}, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).getVorgaenge(requestParameters.archivierungsstatus, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.currentGestartedAmFrom, requestParameters.currentGestartedAmTo, requestParameters.auftragsnummer, requestParameters.vertragsnummer, requestParameters.kundennummer, requestParameters.correlationId, requestParameters.externeId, requestParameters.vorgangType, requestParameters.currentStep, requestParameters.externerName, requestParameters.error, requestParameters.lockedBy, requestParameters.fehlertyp, requestParameters.dokumentTyp, requestParameters.unterdrueckung, requestParameters.searchText, requestParameters.searchOperator, requestParameters.stale24h, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.columns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns counts of non-deleted Vorgänge in status WARTEND or LAUFEND that have exceeded the configured staleness threshold in their current process step.
     * @summary Get stale Vorgang alerting counts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public getVorgaengeAlerting(options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).getVorgaengeAlerting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns completed and soft-deleted Vorgänge from archive storage with the same filters as the main list.
     * @summary Get archived Vorgänge
     * @param {VorgngeApiGetVorgaengeArchivRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public getVorgaengeArchiv(requestParameters: VorgngeApiGetVorgaengeArchivRequest = {}, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).getVorgaengeArchiv(requestParameters.archivierungsstatus, requestParameters.status, requestParameters.createdAtFrom, requestParameters.createdAtTo, requestParameters.currentGestartedAmFrom, requestParameters.currentGestartedAmTo, requestParameters.auftragsnummer, requestParameters.vertragsnummer, requestParameters.kundennummer, requestParameters.correlationId, requestParameters.externeId, requestParameters.vorgangType, requestParameters.currentStep, requestParameters.externerName, requestParameters.error, requestParameters.lockedBy, requestParameters.fehlertyp, requestParameters.dokumentTyp, requestParameters.unterdrueckung, requestParameters.searchText, requestParameters.searchOperator, requestParameters.stale24h, requestParameters.offset, requestParameters.limit, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.columns, requestParameters.searchFields, requestParameters.auftragsnummerOperator, requestParameters.vertragsnummerOperator, requestParameters.externerNameOperator, requestParameters.dokumentTypOperator, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns status counts. Use scope=main for the cockpit start page, scope=archive for the archive view, scope=full for unfiltered active-table counts.
     * @summary Get Status Clustering
     * @param {VorgngeApiGetVorgaengeStatusClusteringRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public getVorgaengeStatusClustering(requestParameters: VorgngeApiGetVorgaengeStatusClusteringRequest = {}, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).getVorgaengeStatusClustering(requestParameters.scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific vorgang item by ID
     * @summary Get specific vorgang item
     * @param {VorgngeApiGetVorgangRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public getVorgang(requestParameters: VorgngeApiGetVorgangRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).getVorgang(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lade Protokoll-Einträge (Kommentare) für einen Vorgang
     * @param {VorgngeApiGetVorgangKommentareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public getVorgangKommentare(requestParameters: VorgngeApiGetVorgangKommentareRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).getVorgangKommentare(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Locks a specific vorgang item for editing by a user. If the item is already locked by another user, the lock can be overridden if the existing lock is older than 1 hour.
     * @summary Lock event for editing
     * @param {VorgngeApiLockEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public lockEvent(requestParameters: VorgngeApiLockEventRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).lockEvent(requestParameters.id, requestParameters.lockEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restores a previously deleted vorgang item by ID
     * @summary Restore vorgang item
     * @param {VorgngeApiRestoreVorgangRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public restoreVorgang(requestParameters: VorgngeApiRestoreVorgangRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).restoreVorgang(requestParameters.id, requestParameters.user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retries processing of a specific vorgang item event
     * @summary Retry event processing
     * @param {VorgngeApiRetryEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public retryEvent(requestParameters: VorgngeApiRetryEventRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).retryEvent(requestParameters.id, requestParameters.retryEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves modified event data for a specific vorgang item
     * @summary Save event data
     * @param {VorgngeApiSaveEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public saveEvent(requestParameters: VorgngeApiSaveEventRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).saveEvent(requestParameters.id, requestParameters.saveEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Setzt einen Vorgang mit einem Fehlerstatus zurück und legt einen Protokoll-Eintrag mit Kommentar an.
     * @summary Zurückstellen eines fehlerhaften Vorgangs
     * @param {VorgngeApiStelleVorgangZurueckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public stelleVorgangZurueck(requestParameters: VorgngeApiStelleVorgangZurueckRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).stelleVorgangZurueck(requestParameters.id, requestParameters.user, requestParameters.stelleVorgangZurueckRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unlocks a specific vorgang item, making it available for editing by other users
     * @summary Unlock event
     * @param {VorgngeApiUnlockEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VorgngeApi
     */
    public unlockEvent(requestParameters: VorgngeApiUnlockEventRequest, options?: RawAxiosRequestConfig) {
        return VorgngeApiFp(this.configuration).unlockEvent(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportVorgaengeArchivierungsstatusEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN'
} as const;
export type ExportVorgaengeArchivierungsstatusEnum = typeof ExportVorgaengeArchivierungsstatusEnum[keyof typeof ExportVorgaengeArchivierungsstatusEnum];
/**
 * @export
 */
export const ExportVorgaengeCurrentStepEnum = {
    Transformation: 'TRANSFORMATION',
    FachlicheValidierung: 'FACHLICHE_VALIDIERUNG',
    WeiterleitungAnDokumentdienstleister: 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER',
    AntwortVonDokumentdienstleister: 'ANTWORT_VON_DOKUMENTDIENSTLEISTER',
    Archivierung: 'ARCHIVIERUNG',
    EmailVersand: 'EMAIL_VERSAND',
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER',
    WarteAufReaktivierungDesDokumenttyps: 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'
} as const;
export type ExportVorgaengeCurrentStepEnum = typeof ExportVorgaengeCurrentStepEnum[keyof typeof ExportVorgaengeCurrentStepEnum];
/**
 * @export
 */
export const ExportVorgaengeSearchOperatorEnum = {
    Equals: 'equals',
    Contains: 'contains',
    NotContains: 'not_contains'
} as const;
export type ExportVorgaengeSearchOperatorEnum = typeof ExportVorgaengeSearchOperatorEnum[keyof typeof ExportVorgaengeSearchOperatorEnum];
/**
 * @export
 */
export const ExportVorgaengeStale24hEnum = {
    True: 'true'
} as const;
export type ExportVorgaengeStale24hEnum = typeof ExportVorgaengeStale24hEnum[keyof typeof ExportVorgaengeStale24hEnum];
/**
 * @export
 */
export const ExportVorgaengeSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ExportVorgaengeSortOrderEnum = typeof ExportVorgaengeSortOrderEnum[keyof typeof ExportVorgaengeSortOrderEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivArchivierungsstatusEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN'
} as const;
export type ExportVorgaengeArchivArchivierungsstatusEnum = typeof ExportVorgaengeArchivArchivierungsstatusEnum[keyof typeof ExportVorgaengeArchivArchivierungsstatusEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivCurrentStepEnum = {
    Transformation: 'TRANSFORMATION',
    FachlicheValidierung: 'FACHLICHE_VALIDIERUNG',
    WeiterleitungAnDokumentdienstleister: 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER',
    AntwortVonDokumentdienstleister: 'ANTWORT_VON_DOKUMENTDIENSTLEISTER',
    Archivierung: 'ARCHIVIERUNG',
    EmailVersand: 'EMAIL_VERSAND',
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER',
    WarteAufReaktivierungDesDokumenttyps: 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'
} as const;
export type ExportVorgaengeArchivCurrentStepEnum = typeof ExportVorgaengeArchivCurrentStepEnum[keyof typeof ExportVorgaengeArchivCurrentStepEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivSearchOperatorEnum = {
    Equals: 'equals',
    Contains: 'contains',
    NotContains: 'not_contains'
} as const;
export type ExportVorgaengeArchivSearchOperatorEnum = typeof ExportVorgaengeArchivSearchOperatorEnum[keyof typeof ExportVorgaengeArchivSearchOperatorEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivStale24hEnum = {
    True: 'true'
} as const;
export type ExportVorgaengeArchivStale24hEnum = typeof ExportVorgaengeArchivStale24hEnum[keyof typeof ExportVorgaengeArchivStale24hEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ExportVorgaengeArchivSortOrderEnum = typeof ExportVorgaengeArchivSortOrderEnum[keyof typeof ExportVorgaengeArchivSortOrderEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivAuftragsnummerOperatorEnum = {
    Contains: 'contains',
    Equals: 'equals'
} as const;
export type ExportVorgaengeArchivAuftragsnummerOperatorEnum = typeof ExportVorgaengeArchivAuftragsnummerOperatorEnum[keyof typeof ExportVorgaengeArchivAuftragsnummerOperatorEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivVertragsnummerOperatorEnum = {
    Contains: 'contains',
    Equals: 'equals'
} as const;
export type ExportVorgaengeArchivVertragsnummerOperatorEnum = typeof ExportVorgaengeArchivVertragsnummerOperatorEnum[keyof typeof ExportVorgaengeArchivVertragsnummerOperatorEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivExternerNameOperatorEnum = {
    Contains: 'contains',
    Equals: 'equals'
} as const;
export type ExportVorgaengeArchivExternerNameOperatorEnum = typeof ExportVorgaengeArchivExternerNameOperatorEnum[keyof typeof ExportVorgaengeArchivExternerNameOperatorEnum];
/**
 * @export
 */
export const ExportVorgaengeArchivDokumentTypOperatorEnum = {
    Contains: 'contains',
    Equals: 'equals'
} as const;
export type ExportVorgaengeArchivDokumentTypOperatorEnum = typeof ExportVorgaengeArchivDokumentTypOperatorEnum[keyof typeof ExportVorgaengeArchivDokumentTypOperatorEnum];
/**
 * @export
 */
export const GetVorgaengeArchivierungsstatusEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN'
} as const;
export type GetVorgaengeArchivierungsstatusEnum = typeof GetVorgaengeArchivierungsstatusEnum[keyof typeof GetVorgaengeArchivierungsstatusEnum];
/**
 * @export
 */
export const GetVorgaengeCurrentStepEnum = {
    Transformation: 'TRANSFORMATION',
    FachlicheValidierung: 'FACHLICHE_VALIDIERUNG',
    WeiterleitungAnDokumentdienstleister: 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER',
    AntwortVonDokumentdienstleister: 'ANTWORT_VON_DOKUMENTDIENSTLEISTER',
    Archivierung: 'ARCHIVIERUNG',
    EmailVersand: 'EMAIL_VERSAND',
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER',
    WarteAufReaktivierungDesDokumenttyps: 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'
} as const;
export type GetVorgaengeCurrentStepEnum = typeof GetVorgaengeCurrentStepEnum[keyof typeof GetVorgaengeCurrentStepEnum];
/**
 * @export
 */
export const GetVorgaengeSearchOperatorEnum = {
    Equals: 'equals',
    Contains: 'contains',
    NotContains: 'not_contains'
} as const;
export type GetVorgaengeSearchOperatorEnum = typeof GetVorgaengeSearchOperatorEnum[keyof typeof GetVorgaengeSearchOperatorEnum];
/**
 * @export
 */
export const GetVorgaengeStale24hEnum = {
    True: 'true'
} as const;
export type GetVorgaengeStale24hEnum = typeof GetVorgaengeStale24hEnum[keyof typeof GetVorgaengeStale24hEnum];
/**
 * @export
 */
export const GetVorgaengeSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetVorgaengeSortOrderEnum = typeof GetVorgaengeSortOrderEnum[keyof typeof GetVorgaengeSortOrderEnum];
/**
 * @export
 */
export const GetVorgaengeArchivArchivierungsstatusEnum = {
    Erfolgreich: 'ERFOLGREICH',
    Uebersprungen: 'UEBERSPRUNGEN'
} as const;
export type GetVorgaengeArchivArchivierungsstatusEnum = typeof GetVorgaengeArchivArchivierungsstatusEnum[keyof typeof GetVorgaengeArchivArchivierungsstatusEnum];
/**
 * @export
 */
export const GetVorgaengeArchivCurrentStepEnum = {
    Transformation: 'TRANSFORMATION',
    FachlicheValidierung: 'FACHLICHE_VALIDIERUNG',
    WeiterleitungAnDokumentdienstleister: 'WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER',
    AntwortVonDokumentdienstleister: 'ANTWORT_VON_DOKUMENTDIENSTLEISTER',
    Archivierung: 'ARCHIVIERUNG',
    EmailVersand: 'EMAIL_VERSAND',
    BestaetigeVerarbeitungBeiDokumentdienstleister: 'BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER',
    WarteAufReaktivierungDesDokumenttyps: 'WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS'
} as const;
export type GetVorgaengeArchivCurrentStepEnum = typeof GetVorgaengeArchivCurrentStepEnum[keyof typeof GetVorgaengeArchivCurrentStepEnum];
/**
 * @export
 */
export const GetVorgaengeArchivSearchOperatorEnum = {
    Equals: 'equals',
    Contains: 'contains',
    NotContains: 'not_contains'
} as const;
export type GetVorgaengeArchivSearchOperatorEnum = typeof GetVorgaengeArchivSearchOperatorEnum[keyof typeof GetVorgaengeArchivSearchOperatorEnum];
/**
 * @export
 */
export const GetVorgaengeArchivStale24hEnum = {
    True: 'true'
} as const;
export type GetVorgaengeArchivStale24hEnum = typeof GetVorgaengeArchivStale24hEnum[keyof typeof GetVorgaengeArchivStale24hEnum];
/**
 * @export
 */
export const GetVorgaengeArchivSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetVorgaengeArchivSortOrderEnum = typeof GetVorgaengeArchivSortOrderEnum[keyof typeof GetVorgaengeArchivSortOrderEnum];
/**
 * @export
 */
export const GetVorgaengeArchivAuftragsnummerOperatorEnum = {
    Contains: 'contains',
    Equals: 'equals'
} as const;
export type GetVorgaengeArchivAuftragsnummerOperatorEnum = typeof GetVorgaengeArchivAuftragsnummerOperatorEnum[keyof typeof GetVorgaengeArchivAuftragsnummerOperatorEnum];
/**
 * @export
 */
export const GetVorgaengeArchivVertragsnummerOperatorEnum = {
    Contains: 'contains',
    Equals: 'equals'
} as const;
export type GetVorgaengeArchivVertragsnummerOperatorEnum = typeof GetVorgaengeArchivVertragsnummerOperatorEnum[keyof typeof GetVorgaengeArchivVertragsnummerOperatorEnum];
/**
 * @export
 */
export const GetVorgaengeArchivExternerNameOperatorEnum = {
    Contains: 'contains',
    Equals: 'equals'
} as const;
export type GetVorgaengeArchivExternerNameOperatorEnum = typeof GetVorgaengeArchivExternerNameOperatorEnum[keyof typeof GetVorgaengeArchivExternerNameOperatorEnum];
/**
 * @export
 */
export const GetVorgaengeArchivDokumentTypOperatorEnum = {
    Contains: 'contains',
    Equals: 'equals'
} as const;
export type GetVorgaengeArchivDokumentTypOperatorEnum = typeof GetVorgaengeArchivDokumentTypOperatorEnum[keyof typeof GetVorgaengeArchivDokumentTypOperatorEnum];
/**
 * @export
 */
export const GetVorgaengeStatusClusteringScopeEnum = {
    Main: 'main',
    Archive: 'archive',
    Full: 'full'
} as const;
export type GetVorgaengeStatusClusteringScopeEnum = typeof GetVorgaengeStatusClusteringScopeEnum[keyof typeof GetVorgaengeStatusClusteringScopeEnum];


